export const PSALMS_1928: { id: string; lines: [string, string][] }[] = [
    {
        id: "psalm1",
        lines: [
            [
                "BLESS_ED is the man that hath not walked in the coun_sel of the un_god_ly, nor stood in the /way of /sin_ners,",
                "and hath not sat in the /seat of the /scornf_ul.",
            ],
            [
                "But his de_light is in the /law of the /LORD;",
                "and in his law will he ex_er_cise him_self /day and /night.",
            ],
            [
                "And he shall be like a tree plan_ted /by the /wa_ter-_side,",
                "that will bring forth his /fruit in due /sea_son.",
            ],
            [
                "His leaf al_so /shall not /wi_ther;",
                "and look, what_so_ev_er he do_eth, /it shall /pros_per.",
            ],
            [
                "As for the un_god_ly, it /is not /so with /them;",
                "but they are like the chaff, which the wind scat_ter_eth a_way from the /face of the /earth.",
            ],
            [
                "There_fore the un_god_ly shall not be a_ble to /stand in the /judg_ment,",
                "nei_ther the sin_ners in the con_gre_/ga_tion of the /right_eous.",
            ],
            [
                "But the LORD know_eth the /way of the /right_eous;",
                "and the way of the un_/god_ly shall /per_ish.",
            ],
        ],
    },
    {
        id: "psalm2",
        lines: [
            [
                "WHY do the heath_en so fu_ri_ous_ly /rage to_/ge_ther?",
                "and why do the peo_ple i_/ma_gine a /vain thing?",
            ],
            [
                "The kings of the earth stand up, and the rul_ers take /coun_sel to_/ge_ther",
                "a_gainst the LORD, and a_/gainst his A_/noin_ted:",
            ],
            [
                "Let us break their /bonds a_/sun_der,",
                "and cast a_/way their /cords from us.",
            ],
            [
                "He that dwell_eth in hea_ven shall /laugh them to /scorn:",
                "the Lord shall have them /in de_/ri_sion.",
            ],
            [
                "Then shall he speak un_to /them in his /wrath,",
                "and vex them in his /sore dis_/plea_sure:",
            ],
            ["Yet /have I /set my /King", "up_on my ho_ly /hill of /Si_on."],
            [
                "I will re_/hearse the de_/cree;",
                "the LORD hath said un_to me, Thou art my Son, this day have /I be_/got_ten thee.",
            ],
            [
                "De_sire of me, and I shall give thee the na_tions for /thine in_/he_ri_tance,",
                "and the ut_most parts of the earth for /thy pos_/sess_ion.",
            ],
            [
                "Thou shalt bruise them with a /rod of /i_ron,",
                "and break them in pie_ces like a /pot_ter's /vess_el.",
            ],
            [
                "Be wise now /there_fore, /O ye kings;",
                "be in_struct_ed, ye that are /judg_es /of the /earth.",
            ],
            [
                "/Serve the /LORD in fear,",
                "and re_joice un_to /him with /rev_erence.",
            ],
            [
                "Kiss the Son, lest he be an_gry, and so ye per_ish from the right way, if his wrath be kin_dled, yea /but a /lit_tle.",
                "Bless_ed are all they that /put their /trust in /him.",
            ],
        ],
    },
    {
        id: "psalm3",
        lines: [
            [
                "LORD, how are they in_/creased that /trou_ble me!",
                "ma_ny are they that /rise a_/gainst me.",
            ],
            [
                "Ma_ny one there be that /say of my /soul,",
                "There is no /help for him /in his /God.",
            ],
            [
                "But thou, O LORD, art /my de_/fen_der;",
                "thou art my wor_ship, and the /lif_ter up of my /head.",
            ],
            [
                "I did call up_on the /LORD with my /voice,",
                "and he heard me /out of his /ho_ly hill.",
            ],
            [
                "I laid me down and /slept, and rose /up a_gain;",
                "for the /LORD sus_/tained me.",
            ],
            [
                "I will not be a_fraid for ten thou_sands /of the /peo_ple,",
                "that have set them_selves a_/gainst me /round a_/bout.",
            ],
            [
                "Up, LORD, and /help me, /O my /God,",
                "for thou smit_est all mine e_ne_mies up_on the cheek-_bone; thou hast bro_ken the teeth of /the un_/god_ly.",
            ],
            [
                "Sal_va_tion be_long_eth /un_to the /LORD;",
                "and thy bless_ing is up_/on thy /peo_ple.",
            ],
        ],
    },
    {
        id: "psalm4",
        lines: [
            [
                "HEAR me when I call, O /God of my /right_eous_ness:",
                "thou hast set me at li_ber_ty when I was in trou_ble; have mer_cy up_on me, and hear_ken /un_to /my /prayer.",
            ],
            [
                "O ye sons of men, how long will ye blas_/pheme mine /ho_nour,",
                "and have such plea_sure in va_ni_ty, and seek /af_ter /false_hood?",
            ],
            [
                "Know this al_so, that the LORD hath cho_sen to him_self the /man that is /god_ly;",
                "when I call up_on the LORD /he will /hear me.",
            ],
            [
                "Stand in /awe, and sin /not;",
                "comm_une with your own heart, and in your /cham_ber, /and be /still.",
            ],
            [
                "Off_er the sac_ri_/fice of /right_eous_ness,",
                "and put your /trust in the /LORD.",
            ],
            ["There be /ma_ny that /say,", "Who will /show us /an_y /good?"],
            [
                "/LORD, lift thou /up",
                "the light of thy /coun_te_nance up_/on us.",
            ],
            [
                "Thou hast put /glad_ness /in my /heart;",
                "yea, more than when their corn and /wine and /oil in_crease.",
            ],
            [
                "I will lay me down in /peace, and /take my /rest;",
                "for it is thou, LORD, on_ly, that mak_est me /dwell in /safe_ty.",
            ],
        ],
    },
    {
        id: "psalm5",
        lines: [
            ["/PON_DER my /words, O LORD,", "con_si_der my /me_di_/ta_tion."],
            [
                "O hear_ken thou un_to the voice of my call_ing, my /King and my /God:",
                "for un_to /thee will I /make my /prayer.",
            ],
            [
                "My voice shalt thou /hear be_/times, O LORD;",
                "ear_ly in the mor_ning will I di_rect my prayer un_to /thee, and will /look up.",
            ],
            [
                "For thou art the God that hast no /plea_sure in /wick_ed_ness;",
                "nei_ther shall an_y /e_vil /dwell with thee.",
            ],
            [
                "Such as be fool_ish shall not /stand in thy /sight;",
                "for thou hat_est all them that /work in_/i_qui_ty.",
            ],
            [
                "Thou shalt des_troy /them that speak /lies:",
                "the LORD will ab_hor both the blood-_thirs_ty /and de_/ceit_ful /man.",
            ],
            [
                "But as for me, in the mul_ti_tude of thy mer_cy I will come /in_to thine /house;",
                "and in thy fear will I wor_ship to_ward thy /ho_ly /tem_ple.",
            ],
            [
                "Lead me, O LORD, in thy right_eous_ness, be_/cause of mine /e_ne_mies;",
                "make thy way /plain be_/fore my face.",
            ],
            [
                "For there is no /faith_ful_ness /in their /mouth;",
                "their in_ward parts are /ve_ry /wick_ed_ness.",
            ],
            [
                "Their throat is an /o_pen /se_pul_chre;",
                "they /flat_ter /with their /tongue.",
            ],
            [
                "Des_troy thou them, O God; let them per_ish through their own i_/ma_gi_/na_tions;",
                "cast them out in the mul_ti_tude of their un_god_li_ness; for they have re_/belled a_/gainst thee.",
            ],
            [
                "And let all them that put their /trust in /thee re_/joice:",
                "they shall ev_er be gi_ving of thanks, be_cause thou de_fend_est them; they that love thy Name shall be /joy_ful in /thee;",
            ],
            [
                "For thou, LORD, wilt give thy bless_ing /un_to the /right_eous,",
                "and with thy fa_vour_a_ble kind_ness wilt thou de_/fend him as /with a /shield.",
            ],
        ],
    },
    {
        id: "psalm6",
        lines: [
            [
                "O LORD, re_buke me not in thine /in_dig_/na_tion,",
                "nei_ther chas_ten me in /thy dis_/plea_sure.",
            ],
            [
                "Have mer_cy up_on me, O /LORD, for /I am /weak;",
                "O LORD, heal me, /for my /bones are /vexed.",
            ],
            [
                "My soul /al_so is /sore /trou_bled:",
                "but, LORD, how /long wilt thou /pu_nish me?",
            ],
            [
                "Turn thee, O LORD, and de_/li_ver my /soul;",
                "O save me, /for thy /mer_cy's sake.",
            ],
            [
                "For in death no man re_/mem_bereth thee;",
                "and who will give thee /thanks in the /pit?",
            ],
            [
                "I am wea_ry /of my /groan_ing;",
                "eve_ry night wash I my bed, and wa_ter my /couch with my /tears.",
            ],
            [
                "My beau_ty is gone for /ve_ry /trou_ble,",
                "and worn a_way be_cause of /all mine /e_ne_mies.",
            ],
            [
                "A_way from me, all ye that /work in_/i_qui_ty;",
                "for the LORD hath heard the /voice of my /weep_ing.",
            ],
            [
                "The LORD hath /heard my pe_/ti_tion;",
                "the LORD /will re_/ceive my prayer.",
            ],
            [
                "All mine e_ne_mies shall be con_/foun_ded, and /sore /vexed;",
                "they shall be turned back, and /put to shame /sud_den_ly.",
            ],
        ],
    },
    {
        id: "psalm7",
        lines: [
            [
                "O LORD my God, in /thee have I /put my trust:",
                "save me from all them that per_se_cute me, /and de_/li_ver me;",
            ],
            [
                "Lest he de_vour my soul like a li_on, and /tear it in /pie_ces,",
                "/while there is /none to help.",
            ],
            [
                "O LORD my God, if I have done /an_y such /thing;",
                "or if there be an_y /wick_ed_ness in /my /hands;",
            ],
            [
                "If I have re_war_ded e_vil un_to him that dealt /friend_ly with /me;",
                "yea, I have de_li_vered him that with_out an_y /cause is mine /e_ne_my;",
            ],
            [
                "Then let mine e_ne_my per_se_cute my /soul, and /take me;",
                "yea, let him tread my life down up_on the earth, and lay mine /ho_nour /in the /dust.",
            ],
            [
                "Stand up, O LORD, in thy wrath, and lift up thy_self, be_cause of the in_dig_na_tion of /mine /e_ne_mies;",
                "a_rise up for me in the judg_ment that /thou hast com_/man_ded.",
            ],
            [
                "And so shall the con_gre_ga_tion of the peo_ples /come a_/bout thee:",
                "for their sakes there_fore lift /up thy_/self a_gain.",
            ],
            [
                "The LORD shall judge the peo_ples: give /sen_tence with /me, O LORD,",
                "ac_cor_ding to my right_eous_ness, and ac_cor_ding to the in_no_cen_cy /that is /in me.",
            ],
            [
                "O let the wick_ed_ness of the un_god_ly /come to an /end;",
                "but /guide thou the /just.",
            ],
            [
                "/For the /right_eous /God",
                "tri_eth the /ve_ry /hearts and reins.",
            ],
            [
                "My help /com_eth of /God,",
                "who pre_ser_veth /them that are /true of heart.",
            ],
            [
                "God is a right_eous Judge, /strong, and /pa_tient;",
                "and God is pro_/voked /eve_ry /day.",
            ],
            [
                "If a man will not turn, he /will whet his /sword;",
                "he hath bent his bow, and /made it /rea_dy.",
            ],
            [
                "He hath pre_pared for him the /inst_ru_ments of /death;",
                "he or_dain_eth his arr_ows a_gainst the /per_se_/cu_tors.",
            ],
            [
                "Be_hold, the un_god_ly tra_vail_eth /with in_/i_qui_ty;",
                "he hath con_ceived mis_chief, and /brought forth /false_hood.",
            ],
            [
                "He hath gra_ven and /digged up a /pit,",
                "and is fall_en him_self in_to the des_truc_tion that he /made for /oth_er.",
            ],
            [
                "For his tra_vail shall come up_/on his /own head,",
                "and his wick_ed_ness shall /fall on his /own /pate.",
            ],
            [
                "I will give thanks un_to the LORD, ac_cor_ding /to his /right_eous_ness;",
                "and I will praise the /Name of the /LORD Most High.",
            ],
        ],
    },
    {
        id: "psalm8",
        lines: [
            [
                "O LORD our Go_ver_nor, how ex_cell_ent is thy /Name in /all the /world;",
                "thou that hast set thy glo_ry a_/bove the /hea_vens!",
            ],
            [
                "Out of the mouth of ve_ry babes and suck_lings hast thou or_dained strength, be_/cause of thine /e_ne_mies,",
                "that thou might_est still the e_ne_my and /the a_/ven_ger.",
            ],
            [
                "When I con_si_der thy hea_vens, e_ven the /work of thy /fing_ers;",
                "the moon and the stars which /thou hast or_/dained;",
            ],
            [
                "What is man, that thou art /mind_ful of /him?",
                "and the son of man, that thou /vis_it_est /him?",
            ],
            [
                "Thou mad_est him low_er /than the /an_gels,",
                "to crown him with /glo_ry and /wor_ship.",
            ],
            [
                "Thou mak_est him to have do_min_ion of the /works of thy /hands;",
                "and thou hast put all things in sub_jec_tion /un_der his /feet:",
            ],
            ["All /sheep and /ox_en;", "yea, and the /beasts of the /field;"],
            [
                "The fowls of the air, and the /fish_es /of the /sea;",
                "and what_so_ev_er walk_eth through the /paths of the /seas.",
            ],
            [
                "O /LORD our /Go_ver_nor,",
                "how ex_cell_ent is thy /Name in /all the /world!",
            ],
        ],
    },
    {
        id: "psalm9",
        lines: [
            [
                "I WILL give thanks un_to thee, O LORD, with /my whole /heart;",
                "I will speak of all /thy mar_/vell_ous /works.",
            ],
            [
                "I will be /glad and re_/joice in thee;",
                "yea, my songs will I make of thy Name, O /thou Most /High_est.",
            ],
            [
                "While mine e_ne_/mies are /driv_en back,",
                "they shall fall and per_ish /at thy /pres_ence.",
            ],
            [
                "For thou hast main_tained my /right and my /cause;",
                "thou art set in the /throne that /judg_est right.",
            ],
            [
                "Thou hast re_buked the heath_en, and des_troyed /the un_/god_ly;",
                "thou hast put out their name for /ev_er and /ev_er.",
            ],
            [
                "O thou e_ne_my, thy des_truc_tions are come to a per_/pe_tu_al /end;",
                "e_ven as the ci_ties which thou hast des_troyed, whose me_mor_i_al is /per_ished with /them.",
            ],
            [
                "But the LORD shall en_/dure for /ev_er;",
                "he hath al_so pre_pared his /seat for /judg_ment.",
            ],
            [
                "For he shall judge the /world in /right_eous_ness,",
                "and mi_ni_ster true judg_ment /un_to the /peo_ple.",
            ],
            [
                "The LORD al_so will be a de_fence /for the op_/pressed,",
                "e_ven a re_fuge in due /time of /trou_ble.",
            ],
            [
                "And they that know thy Name will /put their /trust in thee;",
                "for thou, LORD, hast nev_er failed /them that /seek thee.",
            ],
            [
                "O praise the LORD which /dwell_eth in /Si_on;",
                "show the peo_ple /of his /do_ings.",
            ],
            [
                "For when he mak_eth in_qui_si_tion for blood, he re_/mem_ber_eth /them,",
                "and for_gett_eth not the com_plaint /of the /poor.",
            ],
            [
                "Have mer_cy up_on me, O LORD; con_si_der the trou_ble which I suf_fer of /them that /hate me,",
                "thou that lift_est me up /from the /gates of /death;",
            ],
            [
                "That I may show all thy prais_es with_in the gates of the /daugh_ter of /Si_on:",
                "I will re_joice in /thy sal_/va_tion.",
            ],
            [
                "The heath_en are sunk down in the /pit that they /made;",
                "in the same net which they hid pri_vi_ly is /their foot /tak_en.",
            ],
            [
                "The LORD is known to /ex_e_cute /judg_ment;",
                "the un_god_ly is trapped in the /work of his /own hands.",
            ],
            [
                "The wick_ed shall be /turned to des_/truc_tion,",
                "and all the peo_ple /that for_/get God.",
            ],
            [
                "For the poor shall not al_way /be for_/got_ten;",
                "the pa_tient a_bi_ding of the meek shall not /per_ish for /ev_er.",
            ],
            [
                "Up, LORD, and let not man /have the /up_per /hand;",
                "let the heath_en be /judged in thy /sight.",
            ],
            [
                "Put /them in /fear, O /LORD,",
                "that the heath_en may know them_/selves to /be but /men.",
            ],
        ],
    },
    {
        id: "psalm10",
        lines: [
            [
                "WHY stand_est thou /so far /off, O LORD,",
                "and hid_est thy face in the need_ful /time of /trou_ble?",
            ],
            [
                "The un_god_ly, for his own lust, doth /per_se_/cute the /poor:",
                "let them be tak_en in the craf_ty wi_li_ness that /they have i_/ma_gined.",
            ],
            [
                "For the un_god_ly hath made boast of his /own heart's de_/sire,",
                "and speak_eth good of the co_ve_tous, whom the /LORD ab_/horr_eth.",
            ],
            [
                "The un_god_ly is so proud, that he /ca_reth /not for God,",
                "nei_ther is /God in /all his thoughts.",
            ],
            [
                "His ways are /al_way /grie_vous;",
                "thy judg_ments are far a_bove out of his sight, and there_fore de_fieth he /all his /e_ne_mies.",
            ],
            [
                "For he hath said in his heart, Tush, I shall /nev_er be /cast /down,",
                "there shall no harm /hap_pen /un_to /me.",
            ],
            [
                "His mouth is full of /cur_sing, de_/ceit, and /fraud;",
                "un_der his tongue is un_god_li_ness /and /va_ni_/ty.",
            ],
            [
                "He sitt_eth lur_king in the thiev_ish /cor_ners /of the /streets,",
                "and pri_vi_ly in his lur_king dens doth he mur_der the in_no_cent; his eyes are /set a_/gainst the /poor.",
            ],
            [
                "For he li_eth wait_ing se_cret_ly; e_ven as a li_on lurk_eth /he in his /den,",
                "that he may /ra_vish the /poor.",
            ],
            [
                "He doth /ra_vish the /poor,",
                "when he gett_eth him /in_to his /net.",
            ],
            [
                "He fall_eth down, and /humb_leth him_/self,",
                "that the con_gre_ga_tion of the poor may fall in_to the /hands of his /cap_tains.",
            ],
            [
                "He hath said in his heart, Tush, God /hath for_/got_ten;",
                "he hid_eth a_way his face, and he will /nev_er /see it.",
            ],
            [
                "A_rise, O LORD God, and /lift up thine /hand;",
                "for_get /not the poor.",
            ],
            [
                "Where_fore should the /wick_ed blas_/pheme /God,",
                "while he doth say in his heart, Tush, thou God /car_est /not for it?",
            ],
            [
                "Sure_ly /thou hast /seen it;",
                "for thou be_hold_est un_god_li_ness and wrong, that thou may_est take the /mat_ter in_to /thy hand.",
            ],
            [
                "The poor com_mitt_eth him_/self un_to /thee;",
                "for thou art the hel_per /of the /friend_less.",
            ],
            [
                "Break thou the pow_er of the un_god_ly /and ma_/li_cious;",
                "search out his un_god_li_ness, un_/til thou /find /none.",
            ],
            [
                "The LORD is King for /ev_er and /ev_er,",
                "and the heath_en are per_ished /out of the /land.",
            ],
            [
                "LORD, thou hast heard the de_/sire of the /poor;",
                "thou pre_par_est their heart, and /thine ear /hear_ken_eth;",
            ],
            [
                "To help the fa_ther_less and poor /un_to their /right,",
                "that the man of the earth be no more ex_/al_ted a_/gainst them.",
            ],
        ],
    },
    {
        id: "psalm11",
        lines: [
            [
                "IN the LORD /put I my /trust;",
                "how say ye then to my soul, that she should flee as a /bird /un_to the /hill?",
            ],
            [
                "For lo, the un_god_ly bend their bow, and make rea_dy their arr_ows with_/in the /qui_ver,",
                "that they may pri_vi_ly shoot at them /which are /true of heart.",
            ],
            [
                "If the found_/a_tions /be des_/troyed,",
                "what /can the /right_eous do?",
            ],
            [
                "The LORD is in his /ho_ly /tem_ple;",
                "the LORD'S /seat is in /hea_ven.",
            ],
            [
                "His eyes con_/si_der the /poor,",
                "and his eye_lids try the /child_ren of /men.",
            ],
            [
                "The LORD app_/ro_veth the /right_eous:",
                "but the un_god_ly, and him that de_light_eth in wick_ed_ness, /doth his /soul ab_/hor.",
            ],
            [
                "Up_on the un_god_ly he shall rain snares, fire and brim_stone, /storm and /tem_pest:",
                "this shall be their /por_tion to /drink.",
            ],
            [
                "For the right_eous LORD /lov_eth /right_eous_ness;",
                "his coun_te_nance will be_hold the /thing that is /just.",
            ],
        ],
    },
    {
        id: "psalm12",
        lines: [
            [
                "HELP me, LORD, for there is not one /god_ly man /left;",
                "for the faith_ful are min_ished from a_mong the /child_ren of /men.",
            ],
            [
                "They talk of va_ni_ty eve_ry /one with his /neigh_bour;",
                "they do but flat_ter with their lips, and diss_em_ble /in their /dou_ble /heart.",
            ],
            [
                "The LORD shall root out /all de_/ceit_ful /lips,",
                "and the tongue that /speak_eth /proud things;",
            ],
            [
                "Which have said, With our /tongue will /we pre_/vail;",
                "we are they that ought to speak; /who is lord /o_ver /us?",
            ],
            [
                "Now, for the com_fort_less trou_bles' /sake of the /nee_dy,",
                "and be_cause of the deep /sigh_ing of the /poor,",
            ],
            [
                "I will /up, saith the /LORD;",
                "and will help eve_ry one from him that swell_eth a_gainst him, and will /set him at /rest.",
            ],
            [
                "The words of the /LORD are /pure words;",
                "e_ven as the sil_ver which from the earth is tried, and pu_ri_fied se_ven /times in the /fire.",
            ],
            [
                "Thou shalt /keep them, O /LORD;",
                "thou shalt pre_serve them from this ge_ne_/ra_tion for /ev_er.",
            ],
            [
                "The un_god_ly /walk on /eve_ry side:",
                "when they are ex_al_ted, the child_ren of men are /put to re_/buke.",
            ],
        ],
    },
    {
        id: "psalm13",
        lines: [
            [
                "HOW long wilt thou for_get me, O /LORD; for /ev_er?",
                "how long wilt thou /hide thy /face from me?",
            ],
            [
                "How long shall I seek coun_sel in my soul, and be so /vexed in my /heart?",
                "how long shall mine e_ne_my /tri_umph /o_ver me?",
            ],
            [
                "Con_si_der, and /hear me, O /LORD my God;",
                "light_en mine eyes, that I /sleep /not in /death;",
            ],
            [
                "Lest mine e_ne_my say, I have pre_/vailed a_/gainst him:",
                "for if I be cast down, they that trou_ble me /will re_/joice at it.",
            ],
            [
                "But my trust is /in thy /mer_cy,",
                "and my heart is joy_ful in /thy sal_/va_tion.",
            ],
            [
                "I will sing of the LORD, be_cause he hath dealt so /lov_ing_ly /with me;",
                "yea, I will praise the Name of the /Lord Most /High_est.",
            ],
        ],
    },
    {
        id: "psalm14",
        lines: [
            ["THE fool hath /said in his /heart,", "/There is /no God."],
            [
                "They are cor_rupt, and be_come a_bom_in_a_ble /in their /do_ings;",
                "there is none that do_eth /good, no not /one.",
            ],
            [
                "The LORD looked down from hea_ven up_on the /child_ren of /men,",
                "to see if there were an_y that would un_der_stand, and /seek af_ter /God.",
            ],
            [
                "But they are all gone out of the way, they are al_to_ge_ther be_come a_/bom_in_a_/ble;",
                "there is none that do_eth /good, no not /one.",
            ],
            [
                "Have they no know_ledge, that they are all such /wor_kers of /mis_chief,",
                "ea_ting up my peo_ple as it were bread, and call /not up_/on the LORD?",
            ],
            [
                "There were they brought in great fear, e_ven /where no /fear /was;",
                "for God is in the ge_ne_ra_tion /of the /right_eous.",
            ],
            [
                "As for you, ye have made a mock at the /coun_sel /of the poor;",
                "be_cause he putt_eth his /trust in the /LORD.",
            ],
            [
                "Who shall give sal_va_tion un_to Is_ra_el /out of /Si_on?",
                "When the LORD tur_neth the cap_ti_vi_ty of his peo_ple, then shall Ja_cob re_joice, and /Is_ra_el /shall be /glad.",
            ],
        ],
    },
    {
        id: "psalm15",
        lines: [
            [
                "LORD, who shall dwell in thy /tab_er_/na_cle?",
                "or who shall rest up_/on thy /ho_ly /hill?",
            ],
            [
                "E_ven he that lead_eth an /un_corr_upt /life,",
                "and do_eth the thing which is right, and speak_eth the /truth /from his /heart.",
            ],
            [
                "He that hath used no de_ceit in his tongue, nor done e_vil /to his /neigh_bour,",
                "and hath not /slan_dered his /neigh_bour.",
            ],
            [
                "He that set_teth not by him_self, but is low_ly /in his /own eyes,",
                "and mak_eth much of /them that /fear the LORD.",
            ],
            [
                "He that swear_eth un_to his neigh_bour, and dis_ap_/poin_teth him /not,",
                "though it were to /his own /hind_rance.",
            ],
            [
                "He that hath not gi_ven his mo_ney up_/on /us_u_ry,",
                "nor tak_en re_ward a_/gainst the /in_no_cent.",
            ],
            ["Who_so /do_eth these /things", "shall /nev_er fall."],
        ],
    },
    {
        id: "psalm16",
        lines: [
            ["PRE_/SERVE me, O /God;", "for in /thee have I /put my trust."],
            [
                "O my soul, thou hast said /un_to the /LORD,",
                "Thou art my God; I have no good /like /un_to /thee.",
            ],
            [
                "All my de_light is up_on the /saints that are /in the /earth,",
                "and up_on such as ex_/cel in /vir_tue.",
            ],
            [
                "But they that run /af_ter a_/no_ther god",
                "shall /have great /trou_ble.",
            ],
            [
                "Their drink-_off_er_ings of blood will /I not /off_er,",
                "nei_ther make men_tion of their /names with_/in my /lips.",
            ],
            [
                "The LORD him_self is the por_tion of mine in_he_ri_tance, /and of my /cup;",
                "/thou shalt main_/tain my /lot.",
            ],
            [
                "The lot is fall_en un_to me /in a /fair /ground;",
                "yea, I have a /good_ly /he_ri_tage.",
            ],
            [
                "I will thank the LORD for /gi_ving me /war_ning;",
                "my reins al_so chas_ten /me in the /night /sea_son.",
            ],
            [
                "I have set the LORD /al_way be_/fore me;",
                "for he is on my right hand, /there_fore I /shall not /fall.",
            ],
            [
                "Where_fore my heart is glad, and my /glo_ry re_/joic_eth:",
                "my flesh /al_so shall /rest in hope.",
            ],
            [
                "For why? thou shalt not /leave my /soul in /hell;",
                "nei_ther shalt thou suf_fer thy Ho_ly One to /see cor_/rup_tion.",
            ],
            [
                "Thou shalt show me the path of life: in thy pres_ence is the /ful_ness of /joy,",
                "and at thy right hand there is /plea_sure for /ev_er_/more.",
            ],
        ],
    },
    {
        id: "psalm17",
        lines: [
            [
                "HEAR the right, O LORD, con_/si_der my /com_/plaint,",
                "and hear_ken un_to my prayer, that go_eth not /out of /feigned lips.",
            ],
            [
                "Let my sen_tence come forth /from thy /pres_ence;",
                "and let thine eyes look up_on the /thing that is /e_qual.",
            ],
            [
                "Thou hast proved and vis_it_ed mine heart in the night sea_son; thou hast tried me, and shalt find no /wick_ed_ness in /me;",
                "for I am utt_er_ly pur_posed that my /mouth shall /not off_/end.",
            ],
            [
                "As /for the /works of /men,",
                "by the word of thy lips I have kept me from the ways of /the des_/troy_er.",
            ],
            [
                "O hold thou up my /go_ings /in thy paths,",
                "that my /foot_steps /slip not.",
            ],
            [
                "I have called up_on thee, O God, for /thou shalt /hear me:",
                "in_cline thine ear to me, and hear_ken /un_to my /words.",
            ],
            [
                "Show thy mar_vell_ous lov_ing-_kind_ness, thou that art the Sav_iour of them which /put their /trust in /thee,",
                "from such as res_/ist thy right /hand.",
            ],
            [
                "Keep me as the /ap_ple of an /eye;",
                "hide me un_der the /sha_dow of /thy /wings,",
            ],
            [
                "From the un_/god_ly, that /trou_ble me;",
                "mine e_ne_mies com_pass me round a_bout, to /take a_/way my /soul.",
            ],
            [
                "They are in_closed /in their /own fat,",
                "and their mouth /speak_eth proud /things.",
            ],
            [
                "They lie wait_ing in our /way on /eve_ry /side,",
                "watch_ing to cast us /down to the /ground;",
            ],
            [
                "Like as a li_on that is /gree_dy of /his prey,",
                "and as it were a li_on's whelp lur_king in /sec_ret /pla_ces.",
            ],
            [
                "Up, LORD, dis_ap_/point him, and /cast him down;",
                "de_li_ver my soul from the un_god_ly, /by thine /own /sword;",
            ],
            [
                "Yea, by thy hand, O LORD; from the /men of the /e_vil world;",
                "which have their por_tion in this life, whose bell_ies thou fill_est /with thy hid /trea_sure.",
            ],
            [
                "They have child_ren /at their de_/sire,",
                "and leave the rest of their /sub_stance /for their /babes.",
            ],
            [
                "But as for me, I shall be_hold thy /pres_ence in /right_eous_ness;",
                "and when I a_wake up af_ter thy like_ness, I /shall be /sa_tis_fied.",
            ],
        ],
    },
    {
        id: "psalm18",
        lines: [
            [
                "I WILL love /thee, O /LORD, my /strength.",
                "The LORD is my sto_ny /rock, and /my de_/fence;",
            ],
            [
                "My Sav_iour, my God, and my might, in /whom I will /trust;",
                "my buck_ler, the horn al_so of my sal_va_tion, /and my /re_fuge.",
            ],
            [
                "I will call up_on the LORD, which is /wor_thy /to be /praised;",
                "so shall I be /safe from mine /e_ne_mies.",
            ],
            [
                "The sor_rows of /death com_passed /me,",
                "and the o_ver_flow_ings of un_god_li_ness /made me a_/fraid.",
            ],
            [
                "The pains of hell /came a_/bout me;",
                "the snares of death /o_ver_/took me.",
            ],
            [
                "In my trou_ble I /called up_/on the /LORD,",
                "and com_plained /un_to my /God:",
            ],
            [
                "So he heard my voice out of his /ho_ly /tem_ple,",
                "and my com_plaint came be_fore him; it en_tered e_ven /in_to his /ears.",
            ],
            [
                "The earth /trem_bled and /quaked,",
                "the ve_ry found_a_tions al_so of the hills shook, and were re_moved, be_/cause he /was /wroth.",
            ],
            [
                "There went a smoke out /in his /pres_ence,",
                "and a con_su_ming fire out of his mouth, so that coals were /kin_dled at /it.",
            ],
            [
                "He bowed the hea_vens /al_so, and /came /down,",
                "and it was dark /un_der his /feet.",
            ],
            [
                "He rode up_on the /Che_ru_bim, /and did /fly;",
                "he came fly_ing up_on the /wings of the /wind.",
            ],
            [
                "He made /dark_ness his /sec_ret /place,",
                "his pa_vil_ion round a_bout him with dark wa_ter, and thick /clouds to /co_ver him.",
            ],
            [
                "At the bright_ness of his /pres_ence his /clouds re_/moved;",
                "/hail_stones and /coals of /fire.",
            ],
            [
                "The LORD al_so thun_dered out of hea_ven, and the High_est /gave his /thun_der;",
                "/hail_stones and /coals of /fire.",
            ],
            [
                "He sent out his /arr_ows, and /scat_tered /them;",
                "he cast forth light_nings, /and des_/troyed them.",
            ],
            [
                "The springs of wa_ters were seen, and the found_a_tions of the round world /were dis_/co_vered,",
                "at thy chid_ing, O LORD, at the blast_ing of the breath of /thy dis_/plea_sure.",
            ],
            [
                "He sent down from on /high to /fetch me,",
                "and took me out of /ma_ny /wa_ters.",
            ],
            [
                "He de_li_vered me from my strong_est e_ne_my, and from /them which /hate me;",
                "for they were too /migh_ty for /me.",
            ],
            [
                "They came up_on me in the /day of my /trou_ble;",
                "but the LORD was /my up_/hold_er.",
            ],
            [
                "He brought me forth al_so in_to a /place of /li_ber_ty;",
                "he brought me forth, e_ven be_cause he had a /fa_vour /un_to /me.",
            ],
            [
                "The LORD re_war_ded me af_ter my /right_eous /deal_ing,",
                "ac_cor_ding to the clean_ness of my hands did he /re_com_pense /me.",
            ],
            [
                "Be_cause I have kept the /ways of the /LORD,",
                "and have not for_sa_ken my /God, as the /wick_ed doth.",
            ],
            [
                "For I have an eye /un_to all his /laws,",
                "and will not cast out his com_/mand_ments from /me.",
            ],
            [
                "I was al_so un_corr_/upt be_/fore him,",
                "and es_chewed /mine own /wick_ed_ness.",
            ],
            [
                "There_fore the LORD re_war_ded me af_ter my /right_eous /deal_ing,",
                "and ac_cor_ding un_to the clean_ness of my hands /in his /eye_sight.",
            ],
            [
                "With the ho_ly thou /shalt be /ho_ly,",
                "and with a per_fect man thou /shalt be /per_fect.",
            ],
            [
                "With the /clean thou /shalt be /clean,",
                "and with the fro_ward thou /shalt be /fro_ward.",
            ],
            [
                "For thou shalt save the peo_ple that are /in ad_/ver_si_ty,",
                "and shalt bring down the high /looks of the /proud.",
            ],
            [
                "Thou al_so shalt /light my /can_dle;",
                "the LORD my God shall make my /dark_ness /to be /light.",
            ],
            [
                "For in thee I shall dis_/com_fit an /host of /men,",
                "and with the help of my God I shall leap /o_ver the /wall.",
            ],
            [
                "The way of God is an /un_de_/filed way:",
                "the word of the LORD al_so is tried in the fire; he is the de_fen_der of all them that /put their /trust in /him.",
            ],
            [
                "For who is /God, but the /LORD?",
                "or who hath an_y /strength, ex_/cept our /God?",
            ],
            [
                "It is God that gird_eth /me with /strength of /war,",
                "and mak_eth /my way /per_fect.",
            ],
            [
                "He mak_eth my /feet like /harts' feet,",
                "and set_teth /me up on /high.",
            ],
            [
                "He /teach_eth mine /hands to /fight,",
                "and mine arms shall bend /e_ven a /bow of /steel.",
            ],
            [
                "Thou hast gi_ven me the de_fence of /thy sal_/va_tion;",
                "thy right hand al_so shall hold me up, and thy lov_ing cor_/rec_tion shall /make me /great.",
            ],
            [
                "Thou shalt make room en_ough un_der /me /for to /go,",
                "that my /foot_steps /shall not /slide.",
            ],
            [
                "I will fol_low up_on mine e_ne_mies, and /o_ver_/take them;",
                "nei_ther will I turn a_gain till I /have des_/troyed them.",
            ],
            [
                "I will smite them, that they shall not be /a_ble to /stand,",
                "but fall /un_der my /feet.",
            ],
            [
                "Thou hast gir_ded me with strength /un_to the /bat_tle;",
                "thou shalt throw down mine /e_ne_mies /un_der me.",
            ],
            [
                "Thou hast made mine e_ne_mies al_so to turn their /backs up_/on me,",
                "and I shall des_troy /them that /hate me.",
            ],
            [
                "They shall cry, but there shall be /none to /help them;",
                "yea, e_ven un_to the LORD shall they cry, but he /shall not /hear them.",
            ],
            [
                "I will beat them as small as the /dust be_/fore the /wind:",
                "I will cast them out as the /clay in the /streets.",
            ],
            [
                "Thou shalt de_li_ver me from the striv_ings /of the /peo_ple,",
                "and thou shalt make me the head of the na_tions; a peo_ple whom I have not /known shall /serve me.",
            ],
            [
                "As soon as they hear of me, they /shall o_/bey me;",
                "the stran_gers shall feign o_/be_di_ence /un_to me.",
            ],
            [
                "The /stran_gers /shall /fail,",
                "and come trem_bling /out of their /strong_holds.",
            ],
            [
                "The LORD liv_eth; and bless_ed /be my strong /hel_per,",
                "and praised be the God of /my sal_/va_tion;",
            ],
            [
                "E_ven the God that seeth that /I be a_/venged,",
                "and sub_du_eth the /peo_ple /un_to me.",
            ],
            [
                "It is he that de_li_ver_eth me from my cru_el e_ne_mies, and set_teth me up a_bove /mine ad_/ver_sa_ries:",
                "thou shalt rid me /from the /wick_ed man.",
            ],
            [
                "For this cause will I give thanks un_to thee, O LORD, a_/mong the /Gen_tiles,",
                "and sing prais_es /un_to thy /Name.",
            ],
            [
                "Great pros_pe_ri_ty gi_veth he /un_to his /King,",
                "and show_eth lov_ing-_kind_ness un_to Da_vid his a_noin_ted, and un_to his /seed for /ev_er_more.",
            ],
        ],
    },
    {
        id: "psalm19",
        lines: [
            [
                "THE hea_vens de_clare the /glo_ry of /God;",
                "and the fir_ma_ment /show_eth his /han_dy-_work.",
            ],
            [
                "One day /tell_eth a_/no_ther;",
                "and one night cer_ti_/fi_eth a_/no_ther.",
            ],
            [
                "There is nei_ther /speech nor /lang_uage;",
                "but their voi_ces are /heard a_/mong them.",
            ],
            [
                "Their sound is gone out /in_to all /lands;",
                "and their words in_to the /ends of the /world.",
            ],
            [
                "In them hath he set a tab_er_/na_cle /for the /sun;",
                "which com_eth forth as a bride_groom out of his cham_ber, and re_joic_eth as a /gi_ant to /run his /course.",
            ],
            [
                "It go_eth forth from the ut_ter_most part of the hea_ven, and runn_eth a_bout un_to the /end of /it a_/gain;",
                "and there is noth_ing /hid from the /heat there_of.",
            ],
            [
                "The law of the LORD is an un_de_filed law, con_/ver_ting the /soul;",
                "the tes_ti_mo_ny of the LORD is sure, and gi_veth wis_dom /un_to the /sim_ple.",
            ],
            [
                "The stat_utes of the LORD are /right, and re_/joice the /heart;",
                "the com_mand_ment of the LORD is pure, and gi_veth /light un_/to the /eyes.",
            ],
            [
                "The fear of the LORD is clean, and en_/dur_eth for /ev_er;",
                "the judg_ments of the LORD are true, and right_eous /al_to_/ge_ther.",
            ],
            [
                "More to be de_sired are they than gold, /yea, than /much fine /gold;",
                "swee_ter al_so than hon_ey, /and the /hon_ey_comb.",
            ],
            [
                "More_ov_er, by them /is thy /ser_vant /taught;",
                "and in keep_ing of them /there is /great re_ward.",
            ],
            [
                "Who can tell how oft /he off_/end_eth?",
                "O cleanse thou me /from my /sec_ret /faults.",
            ],
            [
                "Keep thy ser_vant al_so from pre_sump_tu_ous sins, lest they get the do_/min_ion /o_ver me;",
                "so shall I be un_de_filed, and in_no_cent /from the /great of_/fence.",
            ],
            [
                "Let the words of my mouth, and the me_di_ta_tion of my heart, be al_way ac_/cep_ta_ble /in thy /sight,",
                "O LORD, my strength and /my re_/dee_mer.",
            ],
        ],
    },
    {
        id: "psalm20",
        lines: [
            [
                "THE LORD hear thee in the /day of /trou_ble;",
                "the Name of the God of /Ja_cob de_/fend thee:",
            ],
            [
                "Send thee help from the /sanc_tu_/a_ry,",
                "and strength_en thee /out of /Si_on:",
            ],
            [
                "Re_mem_ber /all thy /of_fer_ings,",
                "and ac_cept /thy burnt-_/sac_ri_fice:",
            ],
            [
                "Grant /thee thy /heart's de_/sire,",
                "and ful_/fil all thy /mind.",
            ],
            [
                "We will re_joice in thy sal_va_tion, and tri_umph in the /Name of the /Lord our God:",
                "the LORD per_form all /thy pe_/ti_tions.",
            ],
            [
                "Now know I that the LORD help_eth his a_noin_ted, and will hear him from his /ho_ly /hea_ven,",
                "e_ven with the whole_some /strength of his /right hand.",
            ],
            [
                "Some put their trust in cha_ri_ots, and /some in /hor_ses;",
                "but we will re_mem_ber the /Name of the /LORD our God.",
            ],
            [
                "They are brought /down and /fall_en;",
                "but we are ri_sen /and stand /up_right.",
            ],
            [
                "Save, LORD; and hear us, O /King of /hea_ven,",
                "when we /call up_/on thee.",
            ],
        ],
    },
    {
        id: "psalm21",
        lines: [
            [
                "THE King shall re_joice in /thy strength, O /LORD;",
                "ex_ceed_ing glad shall he be of /thy sal_/va_tion.",
            ],
            [
                "Thou hast gi_ven /him his /heart's de_/sire,",
                "and hast not de_nied him the re_/quest of his /lips.",
            ],
            [
                "For thou shalt meet him with the /bless_ings of /good_ness,",
                "and shalt set a crown of pure /gold up_/on his head.",
            ],
            [
                "He asked life of thee; and thou gav_est /him a /long life,",
                "e_ven for /ev_er and /ev_er.",
            ],
            [
                "His ho_nour is great in /thy sal_/va_tion;",
                "glo_ry and great wor_ship shalt thou /lay up_/on him.",
            ],
            [
                "For thou shalt give him ev_er_/last_ing fe_/li_ci_ty,",
                "and make him glad with the /joy of thy /coun_te_nance.",
            ],
            [
                "And why? be_cause the King putt_eth his /trust in the /LORD;",
                "and in the mer_cy of the Most High_est he shall /not mis_/car_ry.",
            ],
            [
                "All thine e_ne_mies /shall feel thine /hand;",
                "thy right hand shall find out /them that /hate thee.",
            ],
            [
                "Thou shalt make them like a fie_ry ov_en in /time of thy /wrath:",
                "the LORD shall des_troy them in his dis_plea_sure, and the fire /shall con_/sume them.",
            ],
            [
                "Their fruit shalt thou root /out of the /earth,",
                "and their seed from a_mong the /child_ren of /men.",
            ],
            [
                "For they in_ten_ded /mis_chief a_/gainst thee,",
                "and i_ma_gined such a de_vice as they are not /a_ble /to per_/form.",
            ],
            [
                "There_fore shalt thou /put /them to /flight,",
                "and the strings of thy bow shalt thou make rea_dy a_/gainst the /face of them.",
            ],
            [
                "Be thou ex_al_ted, /LORD, in thine /own /strength;",
                "so will we sing, and /praise thy /pow_er.",
            ],
        ],
    },
    {
        id: "psalm22",
        lines: [
            [
                "MY God, my God, look up_on me; why hast /thou for_/sa_ken me?",
                "and art so far from my health, and from the /words of /my com_/plaint?",
            ],
            [
                "O my God, I cry in the day-_time, /but thou /hear_est /not;",
                "and in the night sea_son /al_so I /take no /rest.",
            ],
            [
                "And thou con_/ti_nu_est /ho_ly,",
                "O thou /Wor_ship of /Is_ra_el.",
            ],
            [
                "Our /fa_thers /hoped in /thee;",
                "they trust_ed in thee, and thou /didst de_/li_ver them.",
            ],
            [
                "They called up_on thee, /and were /hol_pen;",
                "they put their trust in thee, and were /not con_/foun_ded.",
            ],
            [
                "But as for me, I am a /worm, and /no /man;",
                "a ve_ry scorn of men, and the out_cast /of the /peo_ple.",
            ],
            [
                "All they that see me /laugh me to /scorn;",
                "they shoot out their lips, and /shake their /heads, say_ing,",
            ],
            [
                "He trust_ed in the LORD, that he /would de_/li_ver him;",
                "let him de_li_ver him, /if he will /have him.",
            ],
            [
                "But thou art he that took me /out of my /mo_ther's /womb;",
                "thou wast my hope, when I hanged yet up_/on my /mo_ther's /breasts.",
            ],
            [
                "I have been left un_to thee ev_er /since /I was /born;",
                "thou art my God e_ven /from my /mo_ther's /womb.",
            ],
            [
                "O go not from me; for /trou_ble is /hard at /hand,",
                "and there is /none to /help me.",
            ],
            [
                "Ma_ny ox_en are /come a_/bout me;",
                "fat bulls of Ba_shan close me /in on /eve_ry /side.",
            ],
            [
                "They gape up_/on me /with their /mouths,",
                "as it were a ramp_ing and a /roar_ing /li_on.",
            ],
            [
                "I am poured out like wa_ter, and all my /bones are /out of /joint;",
                "my heart al_so in the midst of my bo_dy is e_ven /like /mel_ting /wax.",
            ],
            [
                "My strength is dried up like a pot_sherd, and my tongue /cleav_eth /to my /gums,",
                "and thou bring_est me /in_to the /dust of /death.",
            ],
            [
                "For ma_ny dogs are /come a_/bout me,",
                "and the coun_cil of the wick_ed lay_eth /siege a_/gainst /me.",
            ],
            [
                "They pierced my hands and my feet: I may /tell all my /bones:",
                "they stand star_ing and /look_ing up_/on me.",
            ],
            [
                "They part my /gar_ments a_/mong them,",
                "and cast lots up_/on my /ves_ture.",
            ],
            [
                "But be not thou far /from me, /O /LORD;",
                "thou art my suc_cour, haste /thee to /help me.",
            ],
            [
                "De_li_ver my /soul from the /sword,",
                "my dar_ling from the /pow_er of /the /dog.",
            ],
            [
                "Save me /from the /li_on's /mouth;",
                "thou hast heard me al_so from a_mong the /horns of the /u_ni_corns.",
            ],
            [
                "I will de_clare thy Name /un_to my /breth_ren;",
                "in the midst of the con_gre_ga_tion /will I /praise /thee.",
            ],
            [
                "O praise the LORD, /ye that /fear him:",
                "mag_ni_fy him, all ye of the seed of Ja_cob; and fear him, all ye /seed of /Is_ra_el.",
            ],
            [
                "For he hath not desp_ised nor ab_horred the low es_/tate of the /poor;",
                "he hath not hid his face from him; but when he called un_to /him he /heard him.",
            ],
            [
                "My praise is of thee in the great /con_gre_/ga_tion;",
                "my vows will I per_form in the sight of /them that /fear him.",
            ],
            [
                "The poor shall eat, and be sa_tis_fied; they that seek af_ter the /LORD shall /praise him:",
                "your heart shall /live for /ev_er.",
            ],
            [
                "All the ends of the world shall re_mem_ber them_selves, and be turned /un_to the /LORD;",
                "and all the kind_reds of the na_tions shall /wor_ship be_/fore him.",
            ],
            [
                "For the /king_dom /is the /LORD'S,",
                "and he is the Go_ver_nor a_/mong the /na_tions.",
            ],
            [
                "All such as be /fat up_/on /earth",
                "have /eat_en, and /wor_shipped.",
            ],
            [
                "All they that go down in_to the dust shall /kneel be_/fore /him;",
                "and no man hath /quick_ened his /own /soul.",
            ],
            [
                "My /seed shall /serve him:",
                "they shall be coun_ted un_to the Lord for a /ge_ne_/ra_tion.",
            ],
            [
                "They shall come, and shall de_/clare his /right_eous_ness",
                "un_to a peo_ple that shall be born, /whom the /Lord hath /made.",
            ],
        ],
    },
    {
        id: "psalm23",
        lines: [
            [
                "THE /LORD is my /shep_herd;",
                "there_fore /can I lack /noth_ing.",
            ],
            [
                "He shall feed me /in a green /pas_ture,",
                "and lead me forth be_side the /wa_ters of /com_fort.",
            ],
            [
                "He /shall con_/vert my /soul,",
                "and bring me forth in the paths of right_eous_ness /for his /Name's /sake.",
            ],
            [
                "Yea, though I walk through the val_ley of the sha_dow of death, I will /fear no /e_vil;",
                "for thou art with me; thy rod and thy /staff /com_fort me.",
            ],
            [
                "Thou shalt pre_pare a ta_ble be_fore me in the pres_ence of /them that /trou_ble me;",
                "thou hast a_noin_ted my head with oil, and my /cup /shall be /full.",
            ],
            [
                "Sure_ly thy lov_ing-_kind_ness and mer_cy shall fol_low me all the /days /of my /life;",
                "and I will dwell in the house of the /LORD for /ev_er.",
            ],
        ],
    },
    {
        id: "psalm24",
        lines: [
            [
                "THE earth is the LORD'S, and /all that /there_in /is;",
                "the com_pass of the world, and /they that /dwell there_/in.",
            ],
            [
                "For he hath foun_ded /it up_/on the /seas,",
                "and stab_lished /it up_/on the /floods.",
            ],
            [
                "Who shall asc_end in_to the /hill of the /LORD?",
                "or who shall rise up /in his /ho_ly /place?",
            ],
            [
                "E_ven he that hath clean hands, /and a /pure /heart;",
                "and that hath not lift up his mind un_to va_ni_ty, nor sworn to de_/ceive his /neigh_bour.",
            ],
            [
                "He shall re_ceive the /bless_ing /from the /LORD,",
                "and right_eous_ness from the God of /his sal_/va_tion.",
            ],
            [
                "This is the ge_ne_ra_tion of /them that /seek him;",
                "e_ven of them that seek thy face, O /God of /Ja_cob.",
            ],
            [
                "Lift up your heads, O ye gates; and be ye lift up, ye /ev_er_/last_ing /doors;",
                "and the King of /glo_ry /shall come /in.",
            ],
            [
                "Who is this /King of /glo_ry?",
                "It is the LORD strong and migh_ty, e_ven the LORD /migh_ty in /bat_tle.",
            ],
            [
                "Lift up your heads, O ye gates; and be ye lift up, ye /ev_er_/last_ing /doors;",
                "and the King of /glo_ry /shall come /in.",
            ],
            [
                "Who is this /King of /glo_ry?",
                "E_ven the LORD of hosts, he is the /King of /glo_ry.",
            ],
        ],
    },
    {
        id: "psalm25",
        lines: [
            [
                "UN_TO thee, O LORD, will I lift up my soul; my God, I have /put my /trust in /thee:",
                "O let me not be con_foun_ded, nei_ther let mine e_ne_mies /tri_umph /o_ver /me.",
            ],
            [
                "For all they that hope in thee /shall not /be a_/shamed;",
                "but such as trans_gress with_out a cause shall be /put to con_/fu_sion.",
            ],
            ["/Show me thy /ways, O /LORD,", "and /teach me thy /paths."],
            [
                "Lead me forth in thy /truth, and /learn me:",
                "for thou art the God of my sal_va_tion; in thee hath been my /hope all the /day /long.",
            ],
            [
                "Call to re_mem_brance, O LORD, thy /ten_der /mer_cies,",
                "and thy lov_ing-_kind_ness_es, which have been /ev_er of /old.",
            ],
            [
                "O re_mem_ber not the sins and off_/en_ces of my /youth;",
                "but ac_cor_ding to thy mer_cy think thou up_on me, O /LORD, for thy /good_ness.",
            ],
            [
                "Gra_cious and /right_eous /is the /LORD;",
                "there_fore, will he teach /sin_ners /in the /way.",
            ],
            [
                "Them that are meek shall he /guide in /judg_ment;",
                "and such as are gen_tle, /them shall he /learn his /way.",
            ],
            [
                "All the paths of the LORD are /mer_cy and /truth,",
                "un_to such as keep his co_ve_nant and his /tes_ti_/mon_ies.",
            ],
            [
                "For thy /Name's /sake, O /LORD,",
                "be mer_ci_ful un_to my sin; /for it is /great.",
            ],
            [
                "What man is he that /fear_eth the /LORD?",
                "him shall he teach in the /way that /he shall /choose.",
            ],
            [
                "His /soul shall /dwell at /ease,",
                "and his seed shall in_/he_rit the /land.",
            ],
            [
                "The sec_ret of the LORD is a_mong /them that /fear him;",
                "and he will /show them his /co_ve_nant.",
            ],
            [
                "Mine eyes are ev_er look_ing /un_to the /LORD;",
                "for he shall pluck my feet /out of the /net.",
            ],
            [
                "Turn thee un_to me, and have /mer_cy up_/on me;",
                "for I am de_so_late, /and in /mi_se_ry.",
            ],
            [
                "The sor_rows of my /heart are en_/larged:",
                "O bring thou me /out of my /trou_bles.",
            ],
            [
                "Look up_on my ad_ver_si_ty /and /mi_se_ry,",
                "and for_/give me /all my /sin.",
            ],
            [
                "Con_si_der mine e_ne_mies, how /ma_ny they /are;",
                "and they bear a ty_ran_nous /hate a_/gainst me.",
            ],
            [
                "O keep my /soul, and de_/li_ver /me:",
                "let me not be con_foun_ded, for I have /put my /trust in /thee.",
            ],
            [
                "Let per_fect_ness and right_eous deal_ing /wait up_/on me;",
                "for my /hope hath /been in /thee.",
            ],
            ["De_li_ver /Is_ra_el, /O /God,", "out of /all his /trou_bles."],
        ],
    },
    {
        id: "psalm26",
        lines: [
            [
                "BE thou my Judge, O LORD, for I have /walked /in_no_cent_ly:",
                "my trust hath been al_so in the LORD, there_fore /shall I /not /fall.",
            ],
            [
                "Ex_am_ine me, O /LORD, and /prove me;",
                "try out my /reins /and my /heart.",
            ],
            [
                "For thy lov_ing-_kind_ness is /ev_er be_/fore mine /eyes;",
                "and I will /walk in thy /truth.",
            ],
            [
                "I have not /dwelt with /vain /per_sons;",
                "nei_ther will I have fel_low_ship with /the de_/ceit_ful.",
            ],
            [
                "I have hat_ed the con_gre_ga_tion /of the /wick_ed;",
                "and will not sit a_mong /the un_/god_ly.",
            ],
            [
                "I will wash my hands in /in_no_cen_/cy, O /LORD;",
                "and so will I /go to thine /al_tar;",
            ],
            [
                "That I may show the /voice of thanks_/giv_ing,",
                "and tell of /all thy /won_drous /works.",
            ],
            [
                "LORD, I have loved the ha_bi_/ta_tion of /thy /house,",
                "and the place where thine /ho_nour /dwell_eth.",
            ],
            [
                "O shut not up my soul /with the /sin_ners,",
                "nor my life /with the blood-_/thirs_ty;",
            ],
            [
                "In whose /hands is /wick_ed_ness,",
                "and their right /hand is /full of /gifts.",
            ],
            [
                "But as for me, I will walk /in_no_cent_/ly:",
                "O de_li_ver me, and be /mer_ci_ful /un_to me.",
            ],
            [
                "My /foot /stand_eth /right:",
                "I will praise the LORD in the /con_gre_/ga_tions.",
            ],
        ],
    },
    {
        id: "psalm27",
        lines: [
            [
                "THE LORD is my light and my sal_va_tion; /whom then /shall I /fear?",
                "the LORD is the strength of my life; of whom then /shall I /be a_/fraid?",
            ],
            [
                "When the wick_ed, e_ven mine e_ne_mies and my foes, came up_on me to /eat up my /flesh,",
                "they /stum_bled and /fell.",
            ],
            [
                "Though an host of men were laid a_gainst me, yet shall not my /heart be a_/fraid;",
                "and though there rose up war a_gainst me, yet will I /put my /trust in /him.",
            ],
            [
                "One thing have I de_sired of the LORD, /which I /will re_/quire;",
                "e_ven that I may dwell in the house of the LORD all the days of my life, to be_hold the fair beau_ty of the LORD, and to /vis_it /his /tem_ple.",
            ],
            [
                "For in the time of trou_ble he shall hide me in his /tab_er_/na_cle;",
                "yea, in the sec_ret place of his dwell_ing shall he hide me, and set me up up_/on a /rock of /stone.",
            ],
            [
                "And now shall he /lift /up mine /head",
                "a_bove mine e_ne_mies /round a_/bout /me.",
            ],
            [
                "There_fore will I off_er in his dwell_ing an ob_la_tion, /with great /glad_ness:",
                "I will sing and speak prais_es /un_/to the /LORD.",
            ],
            [
                "Hear_ken un_to my voice, O LORD, when I /cry /un_to /thee;",
                "have mer_cy up_/on me, and /hear /me.",
            ],
            [
                "My heart hath talked of thee, /Seek ye my /face:",
                "Thy /face, LORD, /will I /seek.",
            ],
            [
                "O hide not /thou thy /face from /me,",
                "nor cast thy ser_vant a_way /in dis_/plea_sure.",
            ],
            [
                "Thou hast /been my /suc_cour;",
                "leave me not, nei_ther for_sake me, O God of /my sal_/va_tion.",
            ],
            [
                "When my fa_ther and my /mo_ther for_/sake me,",
                "the LORD /tak_eth me /up.",
            ],
            [
                "/Teach me thy /way, O /LORD,",
                "and lead me in the right way, be_/cause of mine /e_ne_mies.",
            ],
            [
                "De_li_ver me not o_ver in_to the will of mine /ad_ver_/sa_/ries:",
                "for there are false wit_ness_es ri_sen up a_gainst me, and /such /as speak /wrong.",
            ],
            [
                "I should utt_er_/ly have /faint_ed,",
                "but that I be_lieve ve_ri_ly to see the good_ness of the LORD in the /land of the /li_ving.",
            ],
            [
                "O tar_ry /thou the /LORD'S /lei_sure;",
                "be strong, and he shall com_fort thine heart; and put thou thy /trust in the /LORD.",
            ],
        ],
    },
    {
        id: "psalm28",
        lines: [
            [
                "UN_TO thee will I /cry, O /LORD, my /strength:",
                "think no scorn of me; lest, if thou make as though thou hear_est not, I be_come like them that go down /in_/to the /pit.",
            ],
            [
                "Hear the voice of my hum_ble pe_ti_tions, when I /cry /un_to /thee;",
                "when I hold up my hands to_wards the mer_cy_seat of thy /ho_ly /tem_ple.",
            ],
            [
                "O pluck me not a_way, nei_ther des_troy me with the un_god_ly and /wick_ed /do_ers,",
                "which speak friend_ly to their neigh_bours, but i_ma_gine /mis_chief /in their /hearts.",
            ],
            [
                "Re_ward them ac_/cor_ding /to their /deeds,",
                "and ac_cor_ding to the wick_ed_ness of their /own in_/ven_tions.",
            ],
            [
                "Re_com_pense them af_ter the /work /of their /hands;",
                "pay them /that they /have des_/erved.",
            ],
            [
                "For they re_gard not in their mind the works of the LORD, nor the op_er_/a_tion /of his /hands;",
                "there_fore shall he break them down, and /not /build them /up.",
            ],
            [
                "Praised /be the /LORD;",
                "for he hath heard the voice of my /hum_ble pe_/ti_tions.",
            ],
            [
                "The LORD is my strength, and my shield; my heart hath trust_ed in him, /and /I am /helped;",
                "there_fore my heart danc_eth for joy, and in my /song will I /praise /him.",
            ],
            [
                "The /LORD is my /strength,",
                "and he is the whole_some de_fence of /his a_/noin_ted.",
            ],
            [
                "O save thy peo_ple, and give thy bless_ing un_to /thine in_/he_ri_tance:",
                "feed them, and set them /up for /ev_er.",
            ],
        ],
    },
    {
        id: "psalm29",
        lines: [
            [
                "A_SCRIBE un_to the LORD, /O ye /migh_ty,",
                "a_scribe un_to the LORD /wor_ship and /strength.",
            ],
            [
                "A_scribe un_to the LORD the ho_nour due /un_to his /Name;",
                "wor_ship the LORD with /ho_ly /wor_ship.",
            ],
            [
                "The voice of the LORD is up_/on the /wa_ters;",
                "it is the glo_rious God that /mak_eth the /thun_der.",
            ],
            [
                "It is the LORD that rul_eth the sea; the voice of the LORD is migh_ty in /op_er_/a_tion;",
                "the voice of the LORD /is a /glo_rious /voice.",
            ],
            [
                "The voice of the LORD /break_eth the /ce_dar-_trees;",
                "yea, the LORD break_eth the /ce_dars of /Le_ba_non.",
            ],
            [
                "He mak_eth them al_so to /skip like a /calf;",
                "Le_ba_non al_so, and Sir_ion, /like a young /u_ni_corn.",
            ],
            [
                "The voice of the LORD di_vi_deth the flames of fire; the voice of the LORD /shak_eth the /wil_der_ness;",
                "yea, the LORD shak_eth the wil_der_ness of /Ka_desh.",
            ],
            [
                "The voice of the LORD mak_eth the hinds to bring forth young, and strip_peth /bare the /for_ests:",
                "in his tem_ple doth eve_ry thing /speak of his /ho_nour.",
            ],
            [
                "The LORD sitt_eth a_/bove the /wa_ter-_flood,",
                "and the LORD re_main_eth a /King for /ev_er.",
            ],
            [
                "The LORD shall give strength /un_to his /peo_ple;",
                "the LORD shall give his peo_ple the /bless_ing of /peace.",
            ],
        ],
    },
    {
        id: "psalm30",
        lines: [
            [
                "I WILL mag_ni_fy thee, O LORD; for /thou hast /set me /up,",
                "and not made my foes to /tri_umph /o_ver me.",
            ],
            [
                "O LORD my God, I /cried un_to /thee;",
                "and /thou hast /healed me.",
            ],
            [
                "Thou, LORD, hast brought my /soul /out of /hell:",
                "thou hast kept my life, that I should not go down in_to /the pit.",
            ],
            [
                "Sing prais_es un_to the LORD, /O ye /saints of his;",
                "and give thanks un_to him, for a re_mem_brance /of his /ho_li_ness.",
            ],
            [
                "For his wrath en_dur_eth but the twink_ling of an eye, and in his /plea_sure is /life;",
                "hea_vi_ness may en_dure for a night, but joy com_eth /in the /mor_ning.",
            ],
            [
                "And in my pros_pe_ri_ty I said, I shall /nev_er /be re_/moved:",
                "thou, LORD, of thy good_ness, hast /made my /hill so /strong.",
            ],
            ["Thou didst /turn thy /face from me,", "and /I was /trou_bled."],
            [
                "Then cried I /un_to /thee, O /LORD;",
                "and gat me to my /LORD right /humb_ly.",
            ],
            [
                "What pro_fit /is there /in my /blood,",
                "when I go down /in_/to the /pit?",
            ],
            [
                "Shall the dust give /thanks un_to /thee?",
                "or /shall it de_/clare thy /truth?",
            ],
            [
                "Hear, O LORD, and have /mer_cy up_/on me;",
                "LORD, be /thou my /hel_per.",
            ],
            [
                "Thou hast turned my /hea_vi_ness /in_to /joy;",
                "thou hast put off my sack_cloth, and gir_ded /me with /glad_ness:",
            ],
            [
                "There_fore shall eve_ry good man sing of thy /praise with_out /ceas_ing.",
                "O my God, I will give thanks un_to /thee for /ev_er.",
            ],
        ],
    },
    {
        id: "psalm31",
        lines: [
            [
                "IN thee, O LORD, have I put my trust; let me nev_er be /put to con_/fu_sion;",
                "de_li_ver /me in thy /right_eous_ness.",
            ],
            ["Bow /down thine /ear to me;", "make haste /to de_/li_ver me."],
            [
                "And be thou my strong rock, and /house of de_/fence,",
                "that thou /may_est /save me.",
            ],
            [
                "For thou art my strong /rock, and my /ca_stle:",
                "be thou al_so my guide, and lead me /for thy /Name's sake.",
            ],
            [
                "Draw me out of the net that they have laid /pri_vi_ly for /me;",
                "for /thou art /my /strength.",
            ],
            [
                "In_to thy hands I com_/mend my /spi_rit;",
                "for thou hast re_deemed me, O /LORD, thou /God of /truth.",
            ],
            [
                "I have hat_ed them that hold of /ly_ing /va_ni_ties,",
                "and my trust hath /been in the /LORD.",
            ],
            [
                "I will be glad and re_/joice in thy /mer_cy;",
                "for thou hast con_sid_ered my trou_ble, and hast known my /soul in ad_/ver_si_ties.",
            ],
            [
                "Thou hast not shut me up in_to the /hand of the /e_ne_my;",
                "but hast set my /feet in a /large /room.",
            ],
            [
                "Have mer_cy up_on me, O LORD, for /I am in /trou_ble,",
                "and mine eye is con_sumed for ve_ry hea_vi_ness; yea, my /soul and my /bo_dy.",
            ],
            [
                "For my life is wax_en /old with /hea_vi_ness,",
                "and my /years with /mourn_ing.",
            ],
            [
                "My strength fail_eth me, be_cause of /mine in_/i_qui_ty,",
                "and my bones /are con_/sumed.",
            ],
            [
                "I be_came a rep_roach a_mong all mine e_ne_mies, but es_pe_cial_ly a_/mong my /neigh_bours;",
                "and they of mine ac_quain_tance were a_fraid of me; and they that did see me with_out, con_veyed /them_selves /from /me.",
            ],
            [
                "I am clean for_got_ten as a /dead man /out of /mind;",
                "I am be_come like a /bro_ken /vess_el.",
            ],
            [
                "For I have heard the blas_phe_my of the mul_ti_tude, and /fear is on /eve_ry /side;",
                "while they con_spire to_ge_ther a_gainst me, and take their coun_sel to /take a_/way my /life.",
            ],
            [
                "But my hope hath /been in /thee, O LORD;",
                "I have said, /Thou art /my /God.",
            ],
            [
                "My times are in thy hand; de_li_ver me from the /hand of mine /e_ne_mies,",
                "and from them that /per_se_cute /me.",
            ],
            [
                "Show thy ser_vant the /light of thy /coun_te_nance,",
                "and save me /for thy /mer_cy's sake.",
            ],
            [
                "Let me not be con_foun_ded, O LORD, for I have /called up_/on /thee;",
                "let the un_god_ly be put to con_fu_sion, and be put to /si_lence /in the /grave.",
            ],
            [
                "Let the ly_ing lips be /put to /si_lence,",
                "which cruel_ly, dis_dain_ful_ly, and des_pite_ful_ly speak a_/gainst the /right_eous.",
            ],
            [
                "O how plen_ti_ful is thy good_ness, which thou hast laid up for /them that /fear thee,",
                "and that thou hast pre_pared for them that put their trust in thee, e_ven be_/fore the /sons of /men!",
            ],
            [
                "Thou shalt hide them in the co_vert of thine own pres_ence from the /plot_tings of /men:",
                "thou shalt keep them se_cret_ly in thy tab_er_na_cle /from the /strife of /tongues.",
            ],
            [
                "Thanks /be /to the /LORD;",
                "for he hath showed me mar_vell_ous great kind_ness /in a strong /ci_ty.",
            ],
            [
                "But /in my /haste I /said,",
                "I am cast out of the /sight of /thine /eyes.",
            ],
            [
                "Ne_ver_the_less, thou heard_est the /voice of /my /prayer,",
                "when I /cried /un_to /thee.",
            ],
            [
                "O love the /LORD, all /ye his /saints;",
                "for the LORD pre_ser_veth them that are faith_ful, and plent_eous_ly re_/ward_eth the /proud do_er.",
            ],
            [
                "Be strong, and he shall est_/ab_lish your /heart,",
                "all ye that put your /trust in the /LORD.",
            ],
        ],
    },
    {
        id: "psalm32",
        lines: [
            [
                "BLESS_ED is he whose un_right_eous_ness /is for_/gi_ven,",
                "and whose /sin is /co_vered.",
            ],
            [
                "Bless_ed is the man un_to whom the LORD im_/put_eth no /sin,",
                "and in whose spi_rit /there is no /guile.",
            ],
            [
                "For /whilst I /held my /tongue,",
                "my bones con_sumed a_way through my /dai_ly com_/plain_ing.",
            ],
            [
                "For thy hand was hea_vy up_/on me /day and /night,",
                "and my mois_ture was like the /drought in /sum_mer.",
            ],
            [
                "I ack_now_ledged my /sin un_to /thee;",
                "and mine un_right_eous_ness /have I /not /hid.",
            ],
            [
                "I said, I will con_fess my sins /un_to the /LORD;",
                "and so thou for_gav_est the /wick_ed_ness /of my /sin.",
            ],
            [
                "For this shall eve_ry one that is god_ly make his prayer un_to thee, in a time when thou /may_est be /found;",
                "sure_ly the great wa_ter-_floods shall /not come /nigh him.",
            ],
            [
                "Thou art a place to hide me in; thou shalt pre_/serve me from /trou_ble;",
                "thou shalt com_pass me a_bout with /songs of de_/liv_'rance.",
            ],
            [
                "I will in_form thee, and teach thee in the way where_/in thou shalt /go;",
                "and I will /guide thee with /mine /eye.",
            ],
            [
                "Be ye not like to horse and mule, which have no /un_der_/stan_ding;",
                "whose mouths must be held with bit and bri_dle, else they will /not o_/bey /thee.",
            ],
            [
                "Great plagues re_main for the un_/god_ly;",
                "but who_so putt_eth his trust in the LORD, mer_cy em_brac_eth him /on /eve_ry /side.",
            ],
            [
                "Be glad, O ye right_eous, and re_/joice in /the /LORD;",
                "and be joy_ful, all /ye that are /true of /heart.",
            ],
        ],
    },
    {
        id: "psalm33",
        lines: [
            [
                "RE_JOICE in the LORD, /O ye /right_eous;",
                "for it be_com_eth well the /just to be /thank_ful.",
            ],
            [
                "/Praise the /LORD with /harp;",
                "sing prais_es un_to him with the lute, and in_stru_/ment of /ten /strings.",
            ],
            [
                "Sing un_to the /Lord a new /song;",
                "sing prais_es lus_ti_ly un_to him /with a good /cou_rage.",
            ],
            [
                "For the /word of the /LORD is /true;",
                "and all his /works are /faith_ful.",
            ],
            [
                "He lov_eth right_eous_ness and /judg_ment;",
                "the earth is full of the /good_ness /of the /LORD.",
            ],
            [
                "By the word of the /LORD were the /hea_vens /made;",
                "and all the host of them by the /breath of /his /mouth.",
            ],
            [
                "He ga_ther_eth the wa_ters of the sea to_ge_ther, as it /were up_/on an /heap;",
                "and lay_eth up the deep, as /in a /trea_sure-_/house.",
            ],
            [
                "Let all the /earth fear the /LORD:",
                "stand in awe of him, all ye that /dwell in /the /world.",
            ],
            [
                "For he /spake, and /it was /done;",
                "he com_man_ded, /and it /stood /fast.",
            ],
            [
                "The LORD bring_eth the coun_sel of the /heath_en to /nought,",
                "and mak_eth the de_vices of the peo_ple to be of none eff_ect, and cast_eth out the /coun_sels of /prin_ces.",
            ],
            [
                "The coun_sel of the LORD shall en_/dure for /ev_er,",
                "and the thoughts of his heart from ge_ne_ra_tion to /ge_ne_/ra_tion.",
            ],
            [
                "Bless_ed are the peo_ple whose God is the /Lord JE_/HO_VAH;",
                "and bless_ed are the folk that he hath cho_sen to him, to be /his in_/he_ri_/tance.",
            ],
            [
                "The LORD look_eth down from hea_ven, and be_hold_eth all the /child_ren of /men;",
                "from the ha_bi_ta_tion of his dwell_ing, he con_si_der_eth all them that /dwell on /the /earth.",
            ],
            [
                "He fa_shion_eth /all the /hearts of /them,",
                "and un_der_/stand_eth /all their /works.",
            ],
            [
                "There is no king that can be saved by the /mul_ti_tude /of an /host;",
                "nei_ther is an_y migh_ty man de_/li_vered by /much /strength.",
            ],
            [
                "A horse is coun_ted but a vain /thing to /save a /man;",
                "nei_ther shall he de_li_ver an_y /man by his /great /strength.",
            ],
            [
                "Be_hold, the eye of the LORD is up_on /them that /fear him,",
                "and up_on them that put their /trust in his /mer_cy;",
            ],
            [
                "To de_/li_ver their /soul from /death,",
                "and to feed them /in the /time of /dearth.",
            ],
            [
                "Our soul hath pa_tient_ly /tar_ried for /the /LORD;",
                "for he is our /help and /our /shield.",
            ],
            [
                "For our heart /shall re_/joice in /him;",
                "be_cause we have /hoped in his /ho_ly /Name.",
            ],
            [
                "Let thy mer_ci_ful kind_ness, O /LORD, be up_/on us,",
                "like as we do /put our /trust in /thee.",
            ],
        ],
    },
    {
        id: "psalm34",
        lines: [
            [
                "I WILL al_way give thanks /un_to the /LORD;",
                "his praise shall ev_er /be /in my /mouth.",
            ],
            [
                "My soul shall make her /boast /in the /LORD;",
                "the hum_ble shall hear there_/of, /and be /glad.",
            ],
            [
                "O /praise the /LORD with /me,",
                "and let us mag_ni_fy his /Name to_/ge_ther.",
            ],
            [
                "I sought the LORD, /and he /heard me;",
                "yea, he de_li_vered me /out of /all my /fear.",
            ],
            [
                "They had an eye un_to him, /and were /light_ened;",
                "and their /fa_ces were /not a_/shamed.",
            ],
            [
                "Lo, the poor cri_eth, and the /LORD /hear_eth /him;",
                "yea, and sav_eth him out of /all his /trou_bles.",
            ],
            [
                "The an_gel of the LORD tar_ri_eth round a_bout /them that /fear him,",
                "and de_/li_/ver_eth /them.",
            ],
            [
                "O taste, and see, how /gra_cious the /LORD is:",
                "bless_ed is the man that /trust_eth in /him.",
            ],
            [
                "O fear the LORD, /ye that /are his /saints;",
                "for they that /fear him lack /noth_ing.",
            ],
            [
                "The li_ons do lack, and /suf_fer /hun_ger;",
                "but they who seek the LORD shall want no man_ner of /thing that is /good.",
            ],
            [
                "Come, ye child_ren, and /hear_ken /un_to /me;",
                "I will teach you the /fear /of the /LORD.",
            ],
            [
                "What man is he that /lust_eth to /live,",
                "and would /fain see /good /days?",
            ],
            [
                "Keep thy /tongue from /e_vil,",
                "and thy lips, /that they /speak no /guile.",
            ],
            ["Es_chew /e_vil, and /do /good;", "seek /peace, and en_/sue it."],
            [
                "The eyes of the LORD are /o_ver the /right_eous,",
                "and his ears are o_pen /un_to their /prayers.",
            ],
            [
                "The coun_te_nance of the LORD is a_gainst /them that do /e_vil,",
                "to root out the re_mem_brance of them /from the /earth.",
            ],
            [
                "The right_eous cry, and the /LORD /hear_eth /them,",
                "and de_li_ver_eth them out of /all their /trou_bles.",
            ],
            [
                "The LORD is nigh un_to them that are /of a /con_trite /heart,",
                "and will save such as be of an /hum_ble /spi_rit.",
            ],
            [
                "Great are the trou_bles /of the /right_eous;",
                "but the LORD de_li_ver_eth /him /out of /all.",
            ],
            [
                "He /keep_eth /all his /bones,",
                "so that not one of /them is /bro_ken.",
            ],
            [
                "But mis_for_tune shall /slay the un_/god_ly;",
                "and they that hate the right_eous /shall be /de_so_late.",
            ],
            [
                "The LORD de_li_ver_eth the /souls of his /ser_vants;",
                "and all they that put their trust in him shall /not be /des_ti_tute.",
            ],
        ],
    },
    {
        id: "psalm35",
        lines: [
            [
                "PLEAD thou my cause, O LORD, with /them that /strive with /me,",
                "and fight thou a_gainst them that /fight a_/gainst /me.",
            ],
            [
                "Lay hand up_on the /shield and /buck_ler,",
                "and stand /up to /help me.",
            ],
            [
                "Bring forth the spear, and stop the way a_gainst them /that pur_/sue /me:",
                "say un_to my soul, I am /thy sal_/va_tion.",
            ],
            [
                "Let them be con_foun_ded, and put to shame, that seek /af_ter my /soul;",
                "let them be turned back, and brought to con_fu_sion, that i_ma_gine /mis_chief for /me.",
            ],
            [
                "Let them be as the /dust be_/fore the /wind,",
                "and the an_gel of the LORD /scat_ter_ing /them.",
            ],
            [
                "Let their way be /dark and /slip_pe_ry,",
                "and let the an_gel of the /LORD pur_/sue them.",
            ],
            [
                "For they have pri_vi_ly laid their net to des_troy /me with_/out a /cause;",
                "yea, e_ven with_out a cause have they made a /pit for my /soul.",
            ],
            [
                "Let a sud_den des_truc_tion come up_on him un_a_wares, and his net that he hath laid /pri_vi_ly /catch him_/self;",
                "that he may fall in_to his /own /mis_chief.",
            ],
            [
                "And my soul shall be /joy_ful in the /LORD;",
                "it shall re_joice in /his sal_/va_tion.",
            ],
            [
                "All my bones shall say, LORD, who is like un_to thee, who de_li_ver_est the poor from him that is /too strong for /him;",
                "yea, the poor, and him that is in mi_se_ry, from /him that /spoil_eth /him?",
            ],
            [
                "False /wit_ness_es /did rise /up:",
                "they laid to my charge things /that I /knew /not.",
            ],
            [
                "They re_war_ded me /e_vil for /good,",
                "to the great dis_/com_fort of /my /soul.",
            ],
            [
                "Ne_ver_the_less, when they were sick, I put on sack_cloth, and hum_bled my /soul with /fast_ing;",
                "and my prayer shall turn in_to /mine own /bo_som.",
            ],
            [
                "I be_haved my_self as though it had been my /friend or my /bro_ther;",
                "I went hea_vi_ly, as one that mourn_eth /for his /mo_ther.",
            ],
            [
                "But in mine ad_ver_si_ty they re_joiced, and ga_thered them_/selves to_/ge_ther;",
                "yea, the ve_ry ab_jects came to_ge_ther a_gainst me un_a_wares, ma_king mouths at /me, and /ceased /not.",
            ],
            [
                "With the flat_ter_ers were /bu_sy /mock_ers,",
                "who gnashed up_/on me /with their /teeth.",
            ],
            [
                "Lord, how long wilt thou /look up_/on /this?",
                "O de_li_ver my soul from the ca_la_mi_ties which they bring on me, and my dar_ling /from the /li_ons.",
            ],
            [
                "So will I give thee thanks in the great /con_gre_/ga_tion;",
                "I will praise thee a_/mong much /peo_ple.",
            ],
            [
                "O let not them that are mine e_ne_mies tri_umph o_ver /me un_/god_ly;",
                "nei_ther let them wink with their eyes, that /hate me with_/out a /cause.",
            ],
            [
                "And why? their com_mun_ing /is not for /peace;",
                "but they i_ma_gine de_ceit_ful words a_gainst them that are /qui_et /in the /land.",
            ],
            [
                "They gaped up_on me /with their /mouths, and /said,",
                "Fie on thee! fie on thee! we /saw it with /our /eyes.",
            ],
            [
                "This /thou hast /seen, O /LORD;",
                "hold not thy tongue then; go not /far from /me, O /Lord.",
            ],
            [
                "A_wake, and stand up to /judge my /quar_rel;",
                "a_venge thou my cause, my /God and /my /Lord.",
            ],
            [
                "Judge me, O LORD my God, ac_cor_ding /to thy /right_eous_ness;",
                "and let them not /tri_umph /o_ver me.",
            ],
            [
                "Let them not say in their hearts, There! there! /so would /we have /it;",
                "nei_ther let them say, We /have de_/voured him.",
            ],
            [
                "Let them be put to con_fu_sion and shame to_ge_ther, that re_/joice at my /trou_ble;",
                "let them be clothed with re_buke and dis_hon_our, that boast them_/selves a_/gainst /me.",
            ],
            [
                "Let them be glad and re_joice, that fa_vour my /right_eous /deal_ing;",
                "yea, let them say al_way, Bless_ed be the LORD, who hath plea_sure in the pros_pe_ri_ty /of his /ser_vant.",
            ],
            [
                "And as for my tongue, it shall be talk_ing /of thy /right_eous_ness,",
                "and of thy praise, /all the /day /long.",
            ],
        ],
    },
    {
        id: "psalm36",
        lines: [
            [
                "MY heart show_eth me the wick_ed_ness of /the un_/god_ly,",
                "that there is no fear of /God be_/fore his /eyes.",
            ],
            [
                "For he flat_ter_eth him_self /in his /own sight,",
                "un_til his a_bom_in_a_ble /sin be /found /out.",
            ],
            [
                "The words of his mouth are un_right_eous and /full of de_/ceit:",
                "he hath left off to be_have him_self wise_ly, /and to /do /good.",
            ],
            [
                "He i_ma_gin_eth mis_chief up_on his bed, and hath set him_/self in no /good /way;",
                "nei_ther doth he ab_hor an_y thing /that is /e_vil.",
            ],
            [
                "Thy mer_cy, O LORD, reach_eth un_/to the /hea_vens,",
                "and thy faith_ful_ness /un_to the /clouds.",
            ],
            [
                "Thy right_eous_ness stand_eth /like the /strong /moun_tains:",
                "thy judg_ments are /like the /great /deep.",
            ],
            [
                "Thou, LORD, shalt save both man and beast: how ex_cell_ent is thy /mer_cy, /O /God!",
                "and the child_ren of men shall put their trust un_der the /sha_dow of /thy /wings.",
            ],
            [
                "They shall be sa_tis_fied with the /plen_teous_ness /of thy /house;",
                "and thou shalt give them drink of thy plea_sures, as /out of the /ri_ver.",
            ],
            [
                "For with /thee is the /well of /life;",
                "and in thy light /shall /we see /light.",
            ],
            [
                "O con_tin_ue forth thy lov_ing-_kind_ness un_to /them that /know thee,",
                "and thy right_eous_ness un_to /them that are /true of heart.",
            ],
            [
                "O let not the foot of pride /come a_/gainst me;",
                "and let not the hand of the un_/god_ly /cast me /down.",
            ],
            [
                "There are they fall_en, /all that work /wick_ed_ness;",
                "they are cast down, and shall not be /a_ble to /stand.",
            ],
        ],
    },
    {
        id: "psalm37",
        lines: [
            [
                "FRET not thy_self be_cause of /the un_/god_ly;",
                "nei_ther be thou en_vi_ous a_gainst the /e_vil /do_ers.",
            ],
            [
                "For they shall soon be cut /down like the /grass,",
                "and be with_ered /e_ven as the /green /herb.",
            ],
            [
                "Put thou thy trust in the LORD, /and be /do_ing /good;",
                "dwell in the land, and ve_ri_ly /thou /shalt be /fed.",
            ],
            [
                "De_/light thou in /the LORD,",
                "and he shall /give thee thy /heart's de_/sire.",
            ],
            [
                "Com_mit thy way un_to the LORD, and /put thy /trust in /him,",
                "and he shall /bring it to /pass.",
            ],
            [
                "He shall make thy right_eous_ness as /clear as the /light,",
                "and thy just deal_ing /as the /noon-_day.",
            ],
            [
                "Hold thee still in the LORD, and a_bide pa_tient_ly up_/on him:",
                "but grieve not thy_self at him whose way doth pros_per, a_gainst the man that do_eth af_ter /e_vil /coun_sels.",
            ],
            [
                "Leave off from wrath, and let /go dis_/plea_sure:",
                "fret not thy_self, else shalt thou be /moved to do /e_vil.",
            ],
            [
                "Wick_ed do_ers /shall be /root_ed /out;",
                "and they that pa_tient_ly a_bide the LORD, those shall in_/he_rit the /land.",
            ],
            [
                "Yet a lit_tle while, and the un_god_ly /shall be /clean /gone:",
                "thou shalt look af_ter his place, and /he shall /be a_/way.",
            ],
            [
                "But the meek-_spi_ri_ted /shall pos_/sess the /earth,",
                "and shall be re_freshed in the /mul_ti_/tude of /peace.",
            ],
            [
                "The un_god_ly seek_eth /coun_sel a_/gainst the /just,",
                "and gnash_eth up_/on him /with his /teeth.",
            ],
            [
                "The Lord shall /laugh him to-_/scorn;",
                "for he hath seen that his /day is /com_ing.",
            ],
            [
                "The un_god_ly have drawn out the sword, /and have /bent their /bow,",
                "to cast down the poor and nee_dy, and to slay such as be /up_right /in their /ways.",
            ],
            [
                "Their sword shall go /through their /own /heart,",
                "and their bow /shall be /bro_ken.",
            ],
            [
                "A small thing /that the /right_eous /hath,",
                "is bet_ter than great rich_es of /the un_/god_ly.",
            ],
            [
                "For the arms of the un_god_ly /shall be /bro_ken,",
                "and the LORD up_/hold_eth the /right_eous.",
            ],
            [
                "The LORD know_eth the /days of the /god_ly;",
                "and their in_he_ri_tance shall en_/dure for /ev_er.",
            ],
            [
                "They shall not be con_foun_ded in the /pe_ri_lous /time;",
                "and in the days of dearth /they shall /have en_/ough.",
            ],
            [
                "As for the un_god_ly, they shall per_ish, and the e_ne_mies of the LORD shall con_sume /as the /fat of /lambs:",
                "yea, e_ven as the smoke shall /they con_/sume a_/way.",
            ],
            [
                "The un_god_ly bor_row_eth, and /pay_eth /not a_/gain;",
                "but the right_eous is mer_ci_/ful and /lib_eral.",
            ],
            [
                "Such as are bless_ed of God, /shall pos_/sess the /land;",
                "and they that are curs_ed of him, /shall be /root_ed /out.",
            ],
            [
                "The LORD or_der_eth a /good man's /go_ing,",
                "and mak_eth his way ac_/cep_ta_ble /to him_/self.",
            ],
            [
                "Though he fall, he shall /not be /cast a_/way;",
                "for the LORD up_hold_eth /him /with his /hand.",
            ],
            [
                "I have been /young, and /now am /old;",
                "and yet saw I nev_er the right_eous for_sa_ken, nor his seed /beg_ging their /bread.",
            ],
            [
                "The right_eous is ev_er mer_ci_/ful, and /len_deth;",
                "and his /seed is /bless_ed.",
            ],
            [
                "Flee from e_vil, and do the /thing that is /good;",
                "and /dwell for /ev_er_/more.",
            ],
            [
                "For the LORD lov_eth the /thing /that is /right;",
                "he for_sak_eth not his that be god_ly, but they are pre_/served for /ev_er.",
            ],
            [
                "The un_right_eous /shall be /pun_ished;",
                "as for the seed of the un_god_ly, /it shall be /root_ed /out.",
            ],
            [
                "The right_eous shall in_/he_rit the /land,",
                "and dwell there_/in for /ev_er.",
            ],
            [
                "The mouth of the right_eous is ex_er_cised in /wis_dom,",
                "and his tongue will be /talk_ing of /judg_ment.",
            ],
            [
                "The law of his /God is /in his /heart,",
                "and his /go_ings /shall not /slide.",
            ],
            [
                "The un_god_ly /watch_eth the /right_eous,",
                "and seek_eth oc_/ca_sion to /slay /him.",
            ],
            [
                "The LORD will not /leave him /in his /hand,",
                "nor con_/demn him when /he is /judged.",
            ],
            [
                "Hope thou in the LORD, and keep his way, and he shall pro_mote thee, that /thou shalt pos_/sess the /land:",
                "when the un_god_ly shall per_ish, /thou shalt /see it.",
            ],
            [
                "I my_self have seen the un_/god_ly in /great /power,",
                "and flour_ish_ing /like a green /bay-_tree.",
            ],
            [
                "I went by, and /lo, he was /gone:",
                "I sought him, but his place could /no_where be /found.",
            ],
            [
                "Keep in_no_cen_cy, and take heed un_to the /thing that is /right;",
                "for that shall bring a man /peace /at the /last.",
            ],
            [
                "As for the trans_gres_sors, they shall /per_ish to_/ge_ther;",
                "and the end of the un_god_ly is, they shall be root_ed /out /at the /last.",
            ],
            [
                "But the sal_va_tion of the right_eous /com_eth /of the /LORD;",
                "who is al_so their strength in the /time of /trou_ble.",
            ],
            [
                "And the LORD shall stand /by them, and /save them:",
                "he shall de_li_ver them from the un_god_ly, and shall save them, be_cause they /put their /trust in /him.",
            ],
        ],
    },
    {
        id: "psalm38",
        lines: [
            [
                "PUT me not to re_buke, O LORD, /in thine /an_ger;",
                "nei_ther chas_ten me in thy /hea_vy dis_/plea_sure:",
            ],
            [
                "For thine /arr_ows stick /fast in me,",
                "and thy hand /press_eth /me /sore.",
            ],
            [
                "There is no health in my flesh, be_cause of /thy dis_/plea_sure;",
                "nei_ther is there an_y rest in my bones, by /rea_son of /my /sin.",
            ],
            [
                "For my wick_ed_ness_es are gone /o_ver my /head,",
                "and are like a sore bur_den, too hea_vy /for /me to /bear.",
            ],
            [
                "My wounds /stink, and /are cor_/rupt,",
                "/through my /fool_ish_ness.",
            ],
            [
                "I am brought in_to so great /trou_ble and /mi_se_ry,",
                "that I go mourn_ing /all the /day /long.",
            ],
            [
                "For my loins are /filled with a /sore dis_/ease,",
                "and there is no whole part /in my /bo_dy.",
            ],
            [
                "I am fee_ble /and sore /smit_ten;",
                "I have roar_ed for the ve_ry dis_qui_et_ness of /my /heart.",
            ],
            [
                "Lord, thou know_est /all my de_/sire;",
                "and my groan_ing /is not /hid from /thee.",
            ],
            [
                "My heart pan_teth, my /strength hath /failed me,",
                "and the light of mine /eyes is /gone from me.",
            ],
            [
                "My lov_ers and my neigh_bours did stand look_ing up_/on my /trou_ble,",
                "and my kins_men /stood af_/ar /off.",
            ],
            [
                "They al_so that sought af_ter my /life laid /snares for me;",
                "and they that went a_bout to do me e_vil talked of wick_ed_ness, and i_ma_gined de_ceit /all the /day long.",
            ],
            [
                "As for me, I was like a /deaf man, and /heard not;",
                "and as one that is dumb, who doth not /o_pen /his mouth.",
            ],
            [
                "I be_came e_ven as a /man that /hear_eth not,",
                "and in whose /mouth are no /re_proofs.",
            ],
            [
                "For in thee, O LORD, /have I /put my /trust;",
                "thou shalt an_swer for /me, O /Lord my /God.",
            ],
            [
                "I have re_quired that they, e_ven mine e_ne_mies, should not /tri_umph /o_ver me;",
                "for when my foot slipt, they re_joiced /great_ly a_/gainst me.",
            ],
            [
                "And I tru_ly am /set in the /plague,",
                "and my hea_vi_ness is /ev_er in /my /sight.",
            ],
            [
                "For I will con_/fess my /wick_ed_ness,",
                "and be /sor_ry for /my /sin.",
            ],
            [
                "But mine e_ne_mies /live, and are /migh_ty;",
                "and they that hate me wrong_ful_ly are /ma_ny in /num_ber.",
            ],
            [
                "They al_so that re_ward e_vil for /good are a_/gainst me;",
                "be_cause I fol_low the /thing that /good is.",
            ],
            [
                "For_sake me /not, O /LORD my /God;",
                "be /not thou /far from me.",
            ],
        ],
    },
    {
        id: "psalm39",
        lines: [
            [
                "I SAID, I will take /heed to my /ways,",
                "that I off_end /not in my /tongue",
            ],
            [
                "I will keep my mouth as it /were with a /bri_dle,",
                "while the un_/god_ly is /in my /sight.",
            ],
            [
                "I held my /tongue, and spake /noth_ing:",
                "I kept si_lence, yea, e_ven from good words; but it was /pain and /grief to /me.",
            ],
            [
                "My heart was hot with_in me: and while I was thus mus_ing the fire /kin_dled,",
                "and at the last I /spake with /my /tongue:",
            ],
            [
                "LORD, let me know mine end, and the /num_ber /of my /days;",
                "that I may be cer_ti_fied how /long I /have to /live.",
            ],
            [
                "Be_hold, thou hast made my days as it were a span long, and mine age is e_ven as noth_ing /in res_/pect of /thee;",
                "and ve_ri_ly eve_ry man li_ving is al_to_/ge_ther /va_ni_ty.",
            ],
            [
                "For man walk_eth in a vain sha_dow, and dis_qui_et_eth /him_self in /vain;",
                "he heap_eth up rich_es, and can_not tell /who shall /gath_er /them.",
            ],
            [
                "And now, Lord, /what is my /hope?",
                "tru_ly my hope is /e_ven /in /thee.",
            ],
            [
                "De_li_ver me from /all mine of_/fen_ces;",
                "and make me not a re_buke /un_to the /fool_ish.",
            ],
            [
                "I be_came dumb, and /o_pened not /my /mouth;",
                "for /it was thy /do_ing.",
            ],
            [
                "Take thy /plague a_/way from me:",
                "I am e_ven con_sumed by the /means of thy /hea_vy /hand.",
            ],
            [
                "When thou with re_bukes dost chas_ten man for sin, thou mak_est his beau_ty to con_sume a_way, like as it were a moth /frett_ing a /gar_ment:",
                "eve_ry man there_fore /is but /va_ni_ty.",
            ],
            [
                "Hear my prayer, O LORD, and with thine ears con_/si_der my /call_ing;",
                "hold not thy /peace at my /tears;",
            ],
            [
                "For I am a stran_ger with /thee, and a /so_jour_ner,",
                "as /all my /fa_thers /were.",
            ],
            [
                "O spare me a lit_tle, that I may re_/co_ver my /strength,",
                "be_fore I go /hence, and be /no more /seen.",
            ],
        ],
    },
    {
        id: "psalm40",
        lines: [
            [
                "I WAIT_ED /pa_tient_ly /for the /LORD,",
                "and he in_clined un_to me, and /heard my /call_ing.",
            ],
            [
                "He brought me al_so out of the hor_ri_ble pit, /out of the /mire and /clay,",
                "and set my feet up_on the rock, and /or_dered my /go_ings.",
            ],
            [
                "And he hath put a new /song /in my /mouth,",
                "e_ven a thanks_giv_ing /un_to /our /God.",
            ],
            [
                "Ma_ny shall /see it, and /fear,",
                "and shall put their /trust /in the /LORD.",
            ],
            [
                "Bless_ed is the man that hath set his /hope in the /LORD,",
                "and turned not un_to the proud, and to such as /go a_/bout with /lies.",
            ],
            [
                "O LORD my God, great are the won_drous works which thou hast done, like as be al_so thy thoughts, which /are to /us-_ward;",
                "and yet there is no man that or_der_eth /them /un_to /thee.",
            ],
            [
                "If I should de_clare them, /and /speak of /them,",
                "they should be more than I am /a_ble /to ex_/press.",
            ],
            [
                "Sac_ri_fice and off_er_ing /thou /would_est /not,",
                "but mine ears /hast thou /o_pened.",
            ],
            [
                "Burnt-_off_er_ing and sac_ri_fice for sin /hast thou /not re_/quired:",
                "/then said I, /Lo, I /come;",
            ],
            [
                "In the vol_ume of the book it is writ_ten of me, that I should ful_/fil thy will, /O my /God:",
                "I am con_tent to do it; yea, thy /law is with_/in my /heart.",
            ],
            [
                "I have de_clared thy right_eous_ness in the great /con_gre_/ga_tion:",
                "lo, I will not re_frain my lips, O LORD, and /that thou /know_est.",
            ],
            [
                "I have not hid thy right_eous_ness with_/in my /heart;",
                "my talk hath been of thy truth, and of /thy sal_/va_tion.",
            ],
            [
                "I have not kept back thy lov_ing /mer_cy and /truth",
                "from the great /con_gre_/ga_tion.",
            ],
            [
                "With_draw not thou thy mer_cy /from /me, O /LORD;",
                "let thy lov_ing-_kind_ness and thy truth al_/way pre_/serve me.",
            ],
            [
                "For in_nu_me_ra_ble trou_bles are come a_bout me; my sins have tak_en such hold up_on me, that I am not /a_ble to /look /up;",
                "yea, they are more in num_ber than the hairs of my head, and my /heart hath /failed me.",
            ],
            [
                "O LORD, let it be thy plea_sure /to de_/li_ver /me;",
                "make haste, O /LORD, to /help /me.",
            ],
            [
                "Let them be a_shamed, and con_foun_ded to_ge_ther, that seek af_ter my /soul to des_/troy it;",
                "let them be driv_en back_ward, and put to re_buke, that /wish me /e_vil.",
            ],
            [
                "Let them be de_so_late, and re_/war_ded /with /shame,",
                "that say un_to me, Fie up_on thee! /fie up_/on /thee!",
            ],
            [
                "Let all those that seek thee, be /joy_ful and /glad in thee;",
                "and let such as love thy sal_va_tion, say al_way, The /LORD be /praised.",
            ],
            [
                "As for me, I am /poor and /nee_dy;",
                "but the Lord /ca_reth /for /me.",
            ],
            [
                "Thou art my hel_per /and re_/dee_mer;",
                "make no long /tar_ry_ing, /O my /God.",
            ],
        ],
    },
    {
        id: "psalm41",
        lines: [
            [
                "BLESS_ED is he that con_si_der_eth the /poor and /nee_dy;",
                "the LORD shall de_li_ver him in the /time of /trou_ble.",
            ],
            [
                "The LORD pre_serve him, and keep him a_live, that he may be /blessed up_/on /earth;",
                "and de_li_ver not thou him in_to the /will of his /e_ne_mies.",
            ],
            [
                "The LORD com_fort him when he li_eth /sick up_/on his /bed;",
                "make thou all his bed /in his /sick_ness.",
            ],
            [
                "I said, LORD, be /mer_ci_ful /un_to me;",
                "heal my soul, for I have /sinned a_/gainst /thee.",
            ],
            [
                "Mine e_ne_mies speak /e_vil of /me,",
                "When shall he die, /and his name /per_ish?",
            ],
            [
                "And if he come to see me, he /speak_eth /va_ni_ty,",
                "and his heart con_ceiv_eth false_hood with_in him_self; and when he com_eth /forth, he /tell_eth it.",
            ],
            [
                "All mine e_ne_mies whis_per to_/ge_ther a_/gainst /me;",
                "e_ven a_gainst me do they i_/ma_gine this /e_vil.",
            ],
            [
                "An e_vil dis_ease, say they, cleav_eth /fast un_to /him;",
                "and now that he li_eth, he shall /rise up /no /more.",
            ],
            [
                "Yea, e_ven mine own fa_mi_li_ar /friend whom I /trust_ed,",
                "who did al_so eat of my bread, hath /laid great /wait for /me.",
            ],
            [
                "But be thou mer_ci_ful /un_to /me, O /LORD;",
                "raise thou me up a_gain, and I /shall re_/ward /them.",
            ],
            [
                "By this I know thou /fa_vour_est /me,",
                "that mine e_ne_my doth not /tri_umph a_/gainst me.",
            ],
            [
                "And in my in_no_cen_cy /thou up_/hold_est me,",
                "and shalt set me be_fore thy /face for /ev_er.",
            ],
            [
                "Bless_ed be the LORD /God of /Is_ra_el,",
                "world /with_out /end. A_/men.",
            ],
        ],
    },
    {
        id: "psalm42",
        lines: [
            [
                "LIKE as the hart de_/sir_eth the /wa_ter-_brooks,",
                "so long_eth my soul /af_ter /thee, O /God.",
            ],
            [
                "My soul is a_thirst for God, yea, e_/ven for the /li_ving /God:",
                "when shall I come to ap_pear be_fore the /pres_ence of /God?",
            ],
            [
                "My tears have /been my meat /day and /night,",
                "while they dai_ly say un_to me, /Where is /now thy /God?",
            ],
            [
                "Now when I think there_up_on, I pour out my /heart by my_/self;",
                "for I went with the mul_ti_tude, and brought them forth /in_to the /house of /God;",
            ],
            [
                "In the voice of /praise and thanks_/giv_ing,",
                "a_mong /such as keep /ho_ly-_/day.",
            ],
            [
                "Why art thou so full of /hea_vi_ness, O my /soul?",
                "and why art thou so dis_qui_et_ed with_/in me?",
            ],
            [
                "O /put thy /trust in /God;",
                "for I will yet thank him, which is the help of my /coun_te_nance, /and my /God.",
            ],
            [
                "My soul is /vexed with_/in me;",
                "there_fore will I re_mem_ber thee from the land of Jor_dan, from Her_mon /and the /lit_tle /hill.",
            ],
            [
                "One deep call_eth a_no_ther, be_cause of the /noise of thy /wa_ter-_floods;",
                "all thy waves and /storms are gone /o_ver /me.",
            ],
            [
                "The LORD will grant his lov_ing-_/kind_ness in the /day_time;",
                "and in the night sea_son will I sing of him, and make my prayer un_to the /God of my /life.",
            ],
            [
                "I will say un_to the God of my strength, Why hast /thou for_/got_ten me?",
                "why go I thus hea_vi_ly, while the e_ne_my op_/press_eth /me?",
            ],
            [
                "My bones are smit_ten a_sun_der /as with a /sword,",
                "while mine e_ne_mies that trou_ble me /cast me /in the /teeth;",
            ],
            [
                "Name_ly, while they say /dai_ly /un_to /me,",
                "/Where is /now thy /God?",
            ],
            [
                "Why art thou so /vexed, /O my /soul?",
                "and why art thou so dis_qui_et_ed with_/in me?",
            ],
            [
                "O /put thy /trust in /God;",
                "for I will yet thank him, which is the help of my /coun_te_nance, /and my /God.",
            ],
        ],
    },
    {
        id: "psalm43",
        lines: [
            [
                "GIVE sen_tence with me, O God, and de_fend my cause a_gainst the un_/god_ly /peo_ple;",
                "O de_li_ver me from the de_/ceit_ful and /wick_ed /man.",
            ],
            [
                "For thou art the God of my strength; why hast thou /put me /from thee?",
                "and why go I so hea_vi_ly, while the e_ne_my op_/press_eth /me?",
            ],
            [
                "O send out thy light and thy truth, that /they may /lead me,",
                "and bring me un_to thy ho_ly hill, and /to thy /dwell_ing;",
            ],
            [
                "And that I may go un_to the al_tar of God, e_ven un_to the God of my /joy and /glad_ness;",
                "and up_on the harp will I give thanks un_to /thee, O /God, my /God.",
            ],
            [
                "Why art thou so /hea_vy, O my /soul?",
                "and why art thou so dis_qui_et_ed with_/in me?",
            ],
            [
                "O /put thy /trust in /God;",
                "for I will yet give him thanks, which is the help of my /coun_te_nance, /and my /God.",
            ],
        ],
    },
    {
        id: "psalm44",
        lines: [
            [
                "WE have heard with our ears, O God, our /fa_thers have /told us",
                "what thou hast /done in their /time of /old:",
            ],
            [
                "How thou hast driv_en out the heath_en with thy hand, and /plan_ted our /fa_thers in;",
                "how thou hast des_troyed the na_tions, and made thy /peo_ple to /flou_rish.",
            ],
            [
                "For they gat not the land in pos_sess_ion /through their /own sword,",
                "nei_ther was it their own /arm that /helped them;",
            ],
            [
                "But thy right hand, and thine arm, and the /light of thy /coun_te_nance;",
                "be_cause thou hadst a /fa_vour un_/to /them.",
            ],
            ["Thou /art my /King, O God;", "send /help un_to /Ja_cob."],
            [
                "Through thee will we o_ver_/throw our /e_ne_mies,",
                "and in thy Name will we tread them un_der that rise /up a_/gainst us.",
            ],
            [
                "For I will not /trust in my /bow,",
                "it is not my /sword that shall /help me;",
            ],
            [
                "But it is thou that sav_est us /from our /e_ne_mies,",
                "and putt_est them to con_/fu_sion that /hate us.",
            ],
            [
                "We make our boast of /God all day /long,",
                "and will praise thy /Name for /ev_er.",
            ],
            [
                "But now thou art far off, and putt_est /us to con_/fu_sion,",
                "and go_est not /forth with our /arm_ies.",
            ],
            [
                "Thou mak_est us to turn our backs up_/on our /e_ne_mies,",
                "so that they which /hate us /spoil our /goods.",
            ],
            [
                "Thou lett_est us be /eat_en /up like sheep,",
                "and hast scat_tered us a_/mong the /heath_en.",
            ],
            [
                "Thou sell_est thy /peo_ple for /nought,",
                "and tak_est no /mo_ney for /them.",
            ],
            [
                "Thou mak_est us to be re_/buked of our /neigh_bours,",
                "to be laughed to scorn, and had in de_ri_sion of them that are /round a_/bout us.",
            ],
            [
                "Thou mak_est us to be a by-_word a_/mong the /na_tions,",
                "and that the peo_ples /shake their /heads at us.",
            ],
            [
                "My con_fu_sion is /dai_ly be_/fore me,",
                "and the shame of my /face hath /co_vered me;",
            ],
            [
                "For the voice of the slan_der_er /and blas_/phe_mer,",
                "for the e_ne_my /and a_/ven_ger.",
            ],
            [
                "And though all this be come up_on us, yet do we /not for_/get thee,",
                "nor be_have our_selves fro_ward_ly /in thy /co_ve_nant.",
            ],
            [
                "Our /heart is /not turned /back,",
                "nei_ther our steps gone /out of thy /way;",
            ],
            [
                "No, not when thou hast smit_ten us in_to the /place of /dra_gons,",
                "and co_vered us with the /sha_dow of /death.",
            ],
            [
                "If we have for_got_ten the Name of our God, and hold_en up our hands to /an_y /strange god,",
                "shall not God search it out? for he know_eth the ve_ry /sec_rets /of the /heart.",
            ],
            [
                "For thy sake al_so are we /killed all the /day long,",
                "and are coun_ted as sheep ap_/poin_ted to /be /slain.",
            ],
            [
                "/Up, Lord, why /sleep_est thou?",
                "a_wake, and be not ab_sent from /us for /ev_er.",
            ],
            [
                "Where_fore /hid_est /thou thy /face,",
                "and for_gett_est our mi_se_ry and /trou_ble?",
            ],
            [
                "For our soul is brought low, e_ven /un_to the /dust;",
                "our bel_ly cleav_eth /un_to the /ground.",
            ],
            [
                "A_/rise, and /help us,",
                "and de_li_ver us, /for thy /mer_cy's /sake.",
            ],
        ],
    },
    {
        id: "psalm45",
        lines: [
            [
                "MY heart ov_er_flow_eth with a good mat_ter; I speak the things which I have made con_/cer_ning the /King.",
                "My tongue is the pen of a /rea_dy /wri_ter.",
            ],
            [
                "Thou art fair_er than the /child_ren of /men;",
                "full of grace are thy lips, be_cause God hath blessed /thee for /ev_er.",
            ],
            [
                "Gird thee with thy sword up_on thy thigh, O /thou Most /Migh_ty,",
                "ac_cor_ding to thy /wor_ship /and re_/nown.",
            ],
            [
                "Good luck have thou /with thine /ho_nour:",
                "ride on, be_cause of the word of truth, of meek_ness, and right_eous_ness; and thy right hand shall teach thee /ter_ri_ble /things.",
            ],
            [
                "Thy arr_ows are ve_ry sharp in the heart of the /King's /e_ne_mies,",
                "and the peo_ple shall /be sub_dued /un_to /thee.",
            ],
            [
                "Thy seat, O God, en_/dur_eth for /ev_er;",
                "the scep_tre of thy king_dom /is a right /scep_tre.",
            ],
            [
                "Thou hast loved right_eous_ness, and /hat_ed in_/i_qui_ty;",
                "where_fore God, e_ven thy God, hath a_noin_ted thee with the oil of glad_ness a_/bove thy /fel_lows.",
            ],
            [
                "All thy gar_ments smell of myrrh, /al_oes, and /cas_si_a;",
                "out of the i_vo_ry pa_la_ces, where_by /they have /made thee /glad.",
            ],
            [
                "Kings' daugh_ters are a_mong thy /ho_nou_ra_ble /wo_men;",
                "up_on thy right hand doth stand the queen in a ves_ture of gold, wrought a_bout /with di_vers /col_ours.",
            ],
            [
                "Hear_ken, O daugh_ter, and con_si_der; /in_/cline thine /ear;",
                "for_get al_so thine own peo_ple, /and thy /fa_ther's /house.",
            ],
            [
                "So shall the King have plea_sure /in thy /beau_ty;",
                "for he is thy Lord, and /wor_ship /thou /him.",
            ],
            [
                "And the daugh_ter of Tyre shall /be there /with a /gift;",
                "like as the rich al_so a_mong the peo_ple shall make their supp_li_/ca_tion be_/fore /thee.",
            ],
            [
                "The King's daugh_ter is all /glo_rious with_/in;",
                "her clo_thing /is of /wrought gold.",
            ],
            [
                "She shall be brought un_to the King in /rai_ment of /nee_dle_work:",
                "the vir_gins that be her fel_lows shall bear her com_pa_ny, and shall be /brought /un_to /thee.",
            ],
            [
                "With joy and glad_ness /shall they be /brought,",
                "and shall en_ter in_/to the King's /pa_lace.",
            ],
            [
                "In_stead of thy fa_thers, thou /shalt have /child_ren,",
                "whom thou may_est make /prin_ces in /all /lands.",
            ],
            [
                "I will make thy Name to be re_mem_bered from one ge_ne_ra_tion /to a_/no_ther;",
                "there_fore shall the peo_ple give thanks un_to thee, /world with_/out end.",
            ],
        ],
    },
    {
        id: "psalm46",
        lines: [
            [
                "GOD is our /hope and /strength,",
                "a ve_ry pre_sent /help in /trou_ble.",
            ],
            [
                "There_fore will we not fear, /though the /earth be /moved,",
                "and though the hills be car_ried in_to the /midst of the /sea;",
            ],
            [
                "Though the wa_ters there_/of /rage and /swell,",
                "and though the moun_tains shake at the /tem_pest /of the /same.",
            ],
            [
                "There is a ri_ver, the streams where_of make glad the /ci_ty of /God;",
                "the ho_ly place of the tab_er_na_cle /of the Most /High_est.",
            ],
            [
                "God is in the midst of her, there_fore shall she /not be re_/moved;",
                "God shall help her, and /that right /ear_ly.",
            ],
            [
                "The na_tions make much ado, and the /king_doms are /moved;",
                "but God hath showed his voice, and the /earth shall /melt a_way.",
            ],
            [
                "The LORD of /hosts is /with us;",
                "the God of Ja_cob /is our /re_fuge.",
            ],
            [
                "O come hi_ther, and be_hold the /works of the /LORD,",
                "what des_truc_tion he hath /brought up_/on the /earth.",
            ],
            [
                "He mak_eth wars to /cease in /all the /world;",
                "he break_eth the bow, and knapp_eth the spear in sun_der, and burn_eth the /cha_ri_ots /in the /fire.",
            ],
            [
                "Be still then, and /know that /I am /God:",
                "I will be ex_al_ted a_mong the na_tions, and I will be ex_/al_ted /in the /earth.",
            ],
            [
                "The LORD of /hosts is /with us;",
                "the God of Ja_cob /is our /re_fuge.",
            ],
        ],
    },
    {
        id: "psalm47",
        lines: [
            [
                "CLAP your hands to_ge_ther, /all ye /peo_ples:",
                "O sing un_to God with the /voice of /me_lo_dy.",
            ],
            [
                "For the LORD is /high, and /to be /feared;",
                "he is the great /King up_on /all the /earth.",
            ],
            [
                "He shall sub_due the /peo_ples /un_der /us,",
                "and the na_tions /un_der our /feet.",
            ],
            [
                "He shall choose out an /he_ri_tage /for /us,",
                "e_ven the ex_cell_en_cy of /Ja_cob, /whom he /loved.",
            ],
            [
                "God is gone up /with a /mer_ry /noise,",
                "and the LORD with the /sound /of the /trump.",
            ],
            [
                "O sing prais_es, sing prais_es /un_to /our /God;",
                "O sing prais_es, sing prais_es /un_to /our /King.",
            ],
            [
                "For God is the /King of /all the /earth:",
                "sing ye prais_es with /un_der_/stan_ding.",
            ],
            [
                "God reign_eth /o_ver the /na_tions;",
                "God sitt_eth up_/on his /ho_ly /seat.",
            ],
            [
                "The prin_ces of the peo_ples are joined un_to the peo_ple of the /God of /Ab_ra_ham;",
                "for God, which is ve_ry high ex_al_ted, doth de_fend the earth, as it /were /with a /shield.",
            ],
        ],
    },
    {
        id: "psalm48",
        lines: [
            [
                "GREAT is the LORD, and /high_ly to be /praised",
                "in the ci_ty of our God, e_ven up_/on his /ho_ly /hill.",
            ],
            [
                "The hill of Si_on is a fair place, and the /joy of the /whole /earth;",
                "up_on the north side li_eth the ci_ty of the great King: God is well known in her pa_la_ces /as a sure /re_fuge.",
            ],
            [
                "For lo, the /kings of the /earth",
                "were ga_thered, and gone /by to_/ge_ther.",
            ],
            [
                "They /mar_velled to /see such /things;",
                "they were as_ton_ished, and /sud_den_ly /cast /down.",
            ],
            [
                "Fear came there up_/on them; and /sor_row,",
                "as up_on a wo_man /in /her tra_/vail.",
            ],
            [
                "Thou dost break the /ships of the /sea",
                "/through the /east-_wind.",
            ],
            [
                "Like as we have heard, so have we seen in the ci_ty of the LORD of hosts, in the /ci_ty of /our /God;",
                "God up_hold_eth the /same for /ev_er.",
            ],
            [
                "We wait for thy lov_ing-_/kind_ness, O /God,",
                "in the midst /of thy /tem_ple.",
            ],
            [
                "O God, ac_cor_ding to thy Name, so is thy praise /un_to the /world's end;",
                "thy right hand is /full of /right_eous_ness.",
            ],
            [
                "Let the mount Si_on re_joice, and the daugh_ters of /Ju_dah be /glad,",
                "be_/cause of thy /judg_ments.",
            ],
            [
                "Walk a_bout Si_on, and go /round a_/bout her;",
                "and /tell the /tow'rs there_/of.",
            ],
            [
                "Mark well her bul_warks, con_/si_der her /pa_la_ces,",
                "that ye may tell /them that come /af_ter.",
            ],
            [
                "For this God is our God for /ev_er and /ev_er:",
                "he shall /be our guide /un_to /death.",
            ],
        ],
    },
    {
        id: "psalm49",
        lines: [
            [
                "O HEAR ye this, /all ye /peo_ple;",
                "pon_der it with your ears, all ye that /dwell in /the /world;",
            ],
            ["High and /low, rich and /poor,", "one /with a_/no_ther."],
            [
                "My mouth shall /speak of /wis_dom,",
                "and my heart shall muse of /un_der_/stan_ding.",
            ],
            [
                "I will in_cline mine /ear to the /pa_ra_ble,",
                "and show my dark /speech up_/on the /harp.",
            ],
            [
                "Where_fore should I fear in the /days of /e_vil,",
                "when wick_ed_ness at my heels com_pass_eth /me round a_/bout?",
            ],
            [
                "There be some that put their /trust in their /goods,",
                "and boast them_selves in the mul_ti_tude /of their /rich_es.",
            ],
            [
                "But no man may de_/li_ver his /bro_ther,",
                "nor give a ran_som /un_to /God for him,",
            ],
            [
                "For it cost /more to re_/deem their /souls,",
                "so that he must let that a_/lone for /ev_er;",
            ],
            ["That he /shall live /al_way,", "and /not see the /grave."],
            [
                "For he seeth that wise men al_so die and /per_ish to_/ge_ther,",
                "as well as the ig_no_rant and fool_ish, and leave their /rich_es for /oth_er.",
            ],
            [
                "And yet they think that their hou_ses shall con_tin_ue for ev_er, and that their dwell_ing-_pla_ces shall en_dure from one ge_ne_ra_tion /to a_/no_ther;",
                "and call the lands /af_ter their /own /names.",
            ],
            [
                "Ne_ver_the_less, man be_ing in ho_nour a_/bi_deth /not,",
                "see_ing he may be comp_ared un_to the /beasts that /per_ish;",
            ],
            [
                "This their way is /ve_ry /fool_ish_ness;",
                "yet their pos_te_ri_ty /praise their /say_ing.",
            ],
            [
                "They lie in the grave like sheep; death is their shep_herd; and the right_eous shall have do_min_ion o_ver them /in the /mor_ning:",
                "their beau_ty shall con_sume in the se_pul_chre, and have /no a_/bi_ding.",
            ],
            [
                "But God hath de_li_vered my soul from the /pow_er of /the /grave;",
                "for he /shall re_/ceive me.",
            ],
            [
                "Be not thou a_fraid, though /one be made /rich,",
                "or if the glo_ry of his /house be in_/creased;",
            ],
            [
                "For he shall car_ry noth_ing a_way with him /when he /di_eth,",
                "nei_ther shall his /pomp fol_low /him.",
            ],
            [
                "For while he lived, he coun_ted him_/self an /hap_py /man;",
                "and so long as thou do_est well un_to thy_self, men will /speak /good of /thee.",
            ],
            [
                "He shall fol_low the ge_ne_ra_tion /of his /fa_thers,",
                "and shall /nev_er see /light.",
            ],
            [
                "Man that is in ho_nour but hath no /un_der_/stan_ding",
                "is comp_ared un_to the /beasts that /per_ish.",
            ],
        ],
    },
    {
        id: "psalm50",
        lines: [
            [
                "THE LORD, e_ven the Most Migh_ty /God, hath /spo_ken,",
                "and called the world, from the ris_ing up of the sun un_to the /go_ing /down there_/of.",
            ],
            ["Out of /Si_on hath /God ap_/peared", "in /per_fect /beau_ty."],
            [
                "Our God shall come, and shall /not keep /si_lence;",
                "there shall go be_fore him a con_su_ming fire, and a migh_ty tem_pest shall be stirred up /round a_/bout him.",
            ],
            [
                "He shall call the /hea_ven /from a_/bove,",
                "and the earth, that he may /judge his /peo_ple.",
            ],
            [
                "Gath_er my saints to_/ge_ther /un_to /me;",
                "those that have made a co_ve_nant with /me with /sac_ri_fice.",
            ],
            [
                "And the hea_vens shall de_/clare his /right_eous_ness;",
                "for /God is /Judge him_/self.",
            ],
            [
                "Hear, O my /peo_ple, and /I will /speak;",
                "I my_self will tes_ti_fy a_gainst thee, O Is_ra_el; for I am God, /e_ven /thy /God.",
            ],
            [
                "I will not re_prove thee be_cause of thy /sac_ri_/fi_ces;",
                "as for thy burnt-_off_er_ings, they are /al_way be_/fore /me.",
            ],
            [
                "I will take no bull_ock /out of thine /house,",
                "nor he-_goats /out of thy /folds.",
            ],
            [
                "For all the beasts of the /for_est are /mine,",
                "and so are the cat_tle up_/on a /thou_sand /hills.",
            ],
            [
                "I know all the fowls up_/on the /moun_tains,",
                "and the wild beasts of the /field are /in my /sight.",
            ],
            [
                "If I be hun_gry, I /will not /tell thee;",
                "for the whole world is mine, and /all that /is there_/in.",
            ],
            [
                "Think_est thou that /I will eat /bulls' /flesh,",
                "and /drink the /blood of /goats?",
            ],
            [
                "Off_er un_to /God thanks_/giv_ing,",
                "and pay thy vows /un_to the Most /High_est.",
            ],
            [
                "And call up_on me in the /time of /trou_ble;",
                "so will I hear thee, and /thou shalt /praise me.",
            ],
            [
                "But un_to the un_/god_ly saith /God,",
                "Why dost thou preach my laws, and tak_est my co_ve_nant in /thy /mouth;",
            ],
            [
                "Where_as thou /hat_est to /be re_/formed,",
                "and hast cast my /words be_/hind thee?",
            ],
            [
                "When thou saw_est a thief, thou con_/sent_edst /un_to /him;",
                "and hast been par_tak_er /with the ad_/ult_er_ers.",
            ],
            [
                "Thou hast let thy /mouth speak /wick_ed_ness,",
                "and with thy tongue thou hast /set /forth de_/ceit.",
            ],
            [
                "Thou satt_est and spak_est a_/gainst thy /bro_ther;",
                "yea, and hast slan_dered thine /own /mo_ther's /son.",
            ],
            [
                "These things hast thou done, and I held my tongue, and thou thought_est wick_ed_ly, that I am e_ven such a /one as thy_/self;",
                "but I will re_prove thee, and set be_fore thee the /things that /thou hast /done.",
            ],
            [
                "O con_si_der this, /ye that for_/get /God,",
                "lest I pluck you a_way, and there be /none to de_/li_ver you.",
            ],
            [
                "Who_so off_er_eth me thanks and praise, he /hon_our_eth /me;",
                "and to him that or_der_eth his way a_right, will I show the sal_/va_tion of /God.",
            ],
        ],
    },
    {
        id: "psalm51",
        lines: [
            [
                "HAVE mer_cy up_on me, O God, /af_ter /thy great /good_ness;",
                "ac_cor_ding to the mul_ti_tude of thy mer_cies do a_way /mine off_/en_ces.",
            ],
            [
                "Wash me through_ly /from my /wick_ed_ness,",
                "and /cleanse me /from my /sin.",
            ],
            [
                "For I ack_/now_ledge my /faults,",
                "and my sin is /ev_er be_/fore me.",
            ],
            [
                "A_gainst thee on_ly have I sinned, and done this /e_vil /in thy /sight;",
                "that thou might_est be jus_ti_fied in thy say_ing, and /clear when /thou shalt /judge.",
            ],
            [
                "Be_hold, I was /sha_pen in /wick_ed_ness,",
                "and in sin hath my /mo_ther con_/ceived me.",
            ],
            [
                "But lo, thou re_quir_est /truth in the /in_ward parts,",
                "and shalt make me to un_der_stand /wis_dom /se_cret_ly.",
            ],
            [
                "Thou shalt purge me with hys_sop, /and I /shall be /clean;",
                "thou shalt wash me, and I shall be /whi_ter than /snow.",
            ],
            [
                "Thou shalt make me hear of /joy and /glad_ness,",
                "that the bones which thou hast /bro_ken /may re_/joice.",
            ],
            [
                "Turn thy /face from my /sins,",
                "and put /out all /my mis_deeds.",
            ],
            [
                "Make /me a clean /heart, O /God,",
                "and re_new a right /spi_rit with_/in me.",
            ],
            [
                "Cast me not a_way /from thy /pres_ence,",
                "and take not thy ho_ly /Spi_rit /from me.",
            ],
            [
                "O give me the com_fort /of thy /help a_gain,",
                "and stab_lish me /with thy /free /Spi_rit.",
            ],
            [
                "Then shall I teach thy ways /un_to the /wick_ed,",
                "and sin_ners shall be con_/ver_ted /un_to /thee.",
            ],
            [
                "De_li_ver me from blood-_guil_ti_ness, O God, thou that art the /God of my /health;",
                "and my tongue shall /sing of thy /right_eous_ness.",
            ],
            [
                "Thou shalt /o_pen my /lips, O Lord,",
                "and my /mouth shall /show thy /praise.",
            ],
            [
                "For thou de_sir_est no sac_ri_fice, else /would I /give it thee;",
                "but thou de_light_est /not in burnt-_/off_er_ings.",
            ],
            [
                "The sac_ri_fice of God is a /trou_bled /spi_rit:",
                "a bro_ken and con_trite heart, O God, /shalt thou /not des_/pise.",
            ],
            [
                "O be fa_vour_a_ble and gra_cious /un_to /Si_on;",
                "build thou the /walls of Je_/ru_sa_/lem.",
            ],
            [
                "Then shalt thou be pleased with the sac_ri_fice of right_eous_ness, with the burnt-_off_er_ings /and ob_/la_tions;",
                "then shall they off_er young bull_ocks up_/on thine /al_tar.",
            ],
        ],
    },
    {
        id: "psalm52",
        lines: [
            [
                "WHY boast_est thou thy_/self, thou /ty_rant,",
                "that thou /canst do /mis_chief;",
            ],
            ["Where_as the /good_ness of /God", "en_/dur_eth yet /dai_ly?"],
            [
                "Thy tongue i_/ma_gin_eth /wick_ed_ness,",
                "and with lies thou cutt_est /like a sharp /ra_zor.",
            ],
            [
                "Thou hast loved un_right_eous_ness /more than /good_ness,",
                "and false_hood /more than /right_eous_ness.",
            ],
            [
                "Thou hast loved to speak all /words that /may do /hurt,",
                "/O thou /false /tongue.",
            ],
            [
                "There_fore shall God des_/troy thee for /ev_er;",
                "he shall take thee, and pluck thee out of thy dwell_ing, and root thee out of the /land of the /li_ving.",
            ],
            [
                "The right_eous al_so shall /see this, and /fear,",
                "and shall /laugh him to /scorn:",
            ],
            [
                "Lo, this is the man that took not /God for his /strength;",
                "but trust_ed un_to the mul_ti_tude of his rich_es, and strength_en_ed him_self /in his /wick_ed_ness.",
            ],
            [
                "As for me, I am like a green ol_ive-_tree /in the /house of /God;",
                "my trust is in the ten_der mer_cy of God for /ev_er and /ev_er.",
            ],
            [
                "I will al_way give thanks un_to thee for /that /thou hast /done;",
                "and I will hope in thy Name, for thy /saints like it /well.",
            ],
        ],
    },
    {
        id: "psalm53",
        lines: [
            [
                "THE fool_ish bo_dy hath /said in his /heart,",
                "/There is /no God.",
            ],
            [
                "Cor_rupt are they, and be_come a_bom_in_a_ble /in their /wick_ed_ness;",
                "there is /none that /do_eth /good.",
            ],
            [
                "God looked down from hea_ven up_on the /child_ren of /men,",
                "to see if there were an_y that would un_der_stand, and seek /af_ter /God.",
            ],
            [
                "But they are all gone out of the way, they are al_to_ge_ther be_come a_/bom_in_a_/ble;",
                "there is al_so none that do_eth /good, no not /one.",
            ],
            [
                "Are not they with_out un_der_stan_ding that /work /wick_ed_ness,",
                "ea_ting up my peo_ple as if they would eat bread? they have not /called up_/on God.",
            ],
            [
                "They were a_fraid /where no /fear /was;",
                "for God hath bro_ken the bones of him that be_sieged thee; thou hast put them to con_fu_sion, be_cause God /hath desp_/ised them.",
            ],
            [
                "O that the sal_va_tion were gi_ven un_to Is_ra_el /out of /Si_on!",
                "O that the Lord would de_li_ver his peo_ple /out of cap_/ti_vi_ty!",
            ],
            [
                "Then should /Ja_cob re_/joice,",
                "and Is_ra_el /should /be right /glad.",
            ],
        ],
    },
    {
        id: "psalm54",
        lines: [
            [
                "SAVE me, O God, /for thy /Name's sake,",
                "and a_venge me in thy /strength.",
            ],
            [
                "/Hear my /prayer, O /God,",
                "and hear_ken un_to the /words of my /mouth.",
            ],
            [
                "For stran_gers are ri_sen /up a_/gainst me;",
                "and ty_rants, which have not God be_fore their eyes, seek /af_ter my /soul.",
            ],
            [
                "Be_hold, /God is my /hel_per;",
                "the Lord is with them that up_hold my /soul.",
            ],
            [
                "He shall re_ward e_vil /un_to mine /e_ne_mies:",
                "des_troy thou /them in thy /truth.",
            ],
            [
                "An off_er_ing of a free heart will I give thee, and /praise thy /Name, O LORD;",
                "be_cause it is so /com_/for_ta_ble.",
            ],
            [
                "For he hath de_li_vered me out of /all my /trou_ble;",
                "and mine eye hath seen his de_sire up_/on mine /e_ne_mies.",
            ],
        ],
    },
    {
        id: "psalm55",
        lines: [
            [
                "/HEAR my /prayer, O /God,",
                "and hide not thy_self from /my pe_/ti_tion.",
            ],
            [
                "Take heed un_to /me, and /hear me,",
                "how I mourn in my /prayer, and /am /vexed;",
            ],
            [
                "The e_ne_my cri_eth so, and the un_god_ly /com_eth on /so /fast;",
                "for they are min_ded to do me some mis_chief, so ma_li_cious_ly are they /set a_/gainst me.",
            ],
            [
                "My heart is dis_qui_et_ed with_/in me,",
                "and the fear of death is /fall_en up_/on me.",
            ],
            [
                "Fear_ful_ness and trem_bling are /come up_/on me,",
                "and an hor_ri_ble dread hath /ov_er_/whelmed /me.",
            ],
            [
                "And I said, O that I had /wings like a /dove!",
                "for then would I flee a_/way, and /be at /rest.",
            ],
            [
                "Lo, then would I /get me a_/way far /off,",
                "and re_main /in the /wil_der_ness.",
            ],
            [
                "I would make /haste to es_/cape,",
                "be_cause of the stor_my /wind and /tem_pest.",
            ],
            [
                "Des_troy their tongues, O /Lord, and di_/vide them;",
                "for I have spied un_right_eous_ness and /strife in the /ci_ty.",
            ],
            [
                "Day and night they go a_bout with_/in the /walls there_/of:",
                "mis_chief al_so and sor_row are /in the /midst of it.",
            ],
            [
                "/Wick_ed_ness /is there_/in;",
                "de_ceit and guile go not /out of /her /streets.",
            ],
            [
                "For it is not an o_pen e_ne_my that hath done me /this dis_/hon_our;",
                "for then I /could have /borne it;",
            ],
            [
                "Nei_ther was it mine ad_ver_sa_ry that did mag_ni_fy him_/self a_/gainst /me;",
                "for then per_ad_ven_ture I would have /hid my_self /from /him;",
            ],
            [
                "But it was e_ven /thou, my com_/pan_ion,",
                "my guide, and mine /own fam_/il_iar /friend.",
            ],
            [
                "We took sweet /coun_sel to_/ge_ther,",
                "and walked in the /house of /God as /friends.",
            ],
            [
                "Let death come has_ti_ly up_on them, and let them go down a_live /in_to the /pit;",
                "for wick_ed_ness is in their dwell_ings, /and a_/mong them.",
            ],
            [
                "As for me, I will /call up_/on /God,",
                "and the /LORD shall /save me.",
            ],
            [
                "In the eve_ning, and mor_ning, and at noon-_day will I pray, /and that /in_stant_ly;",
                "and /he shall /hear my /voice.",
            ],
            [
                "It is he that hath de_li_vered my soul in peace from the bat_tle that /was a_/gainst me;",
                "for there were /ma_ny that /strove with me.",
            ],
            [
                "Yea, e_ven God, that en_dur_eth for ev_er, shall /hear me, and /bring them /down;",
                "for they will not /turn, nor /fear /God.",
            ],
            [
                "He laid his hands up_on such as /be at /peace with /him,",
                "and he /brake his /co_ve_nant.",
            ],
            [
                "The words of his mouth were sof_ter than but_ter, hav_ing /war in his /heart;",
                "his words were smooth_er than oil, and /yet be they /ve_ry /swords.",
            ],
            [
                "O cast thy bur_den up_on the LORD, and /he shall /nour_ish thee,",
                "and shall not suf_fer the right_eous to /fall for /ev_er.",
            ],
            [
                "/And /as for /them,",
                "thou, O God, shalt bring them in_to the /pit of des_/truc_tion.",
            ],
            [
                "The blood-_thirs_ty and de_ceit_ful men shall not /live out /half their /days:",
                "ne_ver_the_less, my trust shall /be in /thee, O /Lord.",
            ],
        ],
    },
    {
        id: "psalm56",
        lines: [
            [
                "BE mer_ci_ful un_to me, O God, for man go_eth a_/bout to de_/vour me;",
                "he is dai_ly /fight_ing, and /troubl_ing /me.",
            ],
            [
                "Mine e_ne_mies are dai_ly at hand to /swal_low me /up;",
                "for they be ma_ny that fight a_gainst me, O /thou Most /High_est.",
            ],
            [
                "Ne_ver_the_less, though I am /some_time a_/fraid,",
                "yet /put I my /trust in /thee.",
            ],
            [
                "I will praise God, be_/cause of his /word:",
                "I have put my trust in God, and will not fear what /flesh can do /un_to /me.",
            ],
            [
                "They /dai_ly mis_/take my /words;",
                "all that they i_ma_gine is to /do me /e_vil.",
            ],
            [
                "They hold all to_ge_ther, and /keep them_/selves /close,",
                "and mark my steps, when they lay /wait for /my /soul.",
            ],
            [
                "Shall they es_/cape for their /wick_ed_ness?",
                "thou, O God, in thy dis_/plea_sure shalt /cast them /down.",
            ],
            [
                "Thou tell_est my wan_der_ings; put my tears /in_to thy /bot_tle:",
                "are not these things /not_ed /in thy /book?",
            ],
            [
                "When_so_ev_er I call up_on thee, then shall mine e_ne_mies /be /put to /flight:",
                "this I know; for /God is /on my /side.",
            ],
            [
                "In God's /word will I re_/joice;",
                "in the LORD'S word /will I /com_fort me.",
            ],
            [
                "Yea, in /God have I /put my /trust;",
                "I will not be a_fraid what man can /do /un_to /me.",
            ],
            [
                "Un_to thee, O /God, will I /pay my /vows;",
                "un_to thee /will I /give /thanks.",
            ],
            [
                "For thou hast de_li_vered my soul from death, and my /feet from /fall_ing,",
                "that I may walk be_fore God in the /light of the /li_ving.",
            ],
        ],
    },
    {
        id: "psalm57",
        lines: [
            [
                "BE mer_ci_ful un_to me, O God, be mer_ci_ful un_to me; for my soul /trust_eth in /thee;",
                "and un_der the sha_dow of thy wings shall be my re_fuge, un_til this ty_ran_ny /be /ov_er_/past.",
            ],
            [
                "I will call /un_to the /Most High /God,",
                "e_ven un_to the God that shall per_form the cause /which I /have in /hand.",
            ],
            [
                "He shall /send from /hea_ven,",
                "and save me from the re_proof of /him that would /eat me /up.",
            ],
            [
                "God shall send forth his /mer_cy and /truth:",
                "my soul /is a_mong /li_ons;",
            ],
            [
                "And I lie e_ven a_mong the child_ren of /men, that are /set on /fire,",
                "whose teeth are spears and arr_ows, and their /tongue a /sharp /sword.",
            ],
            [
                "Set up thy_self, O God, a_/bove the /hea_vens;",
                "and thy glo_ry a_/bove /all the /earth.",
            ],
            [
                "They have laid a net for my feet, and /pressed /down my /soul;",
                "they have digged a pit be_fore me, and are fall_en in_to the /midst of /it them_/selves.",
            ],
            [
                "My heart is fixed, O God, /my /heart is /fixed;",
                "I will /sing and /give /praise.",
            ],
            [
                "A_wake up, my glo_ry; a_/wake, /lute and /harp:",
                "I my_self will a_/wake right /ear_ly.",
            ],
            [
                "I will give thanks un_to thee, O Lord, a_/mong the /peo_ples;",
                "and I will sing un_to thee a_/mong the /na_tions.",
            ],
            [
                "For the great_ness of thy mer_cy reach_eth un_/to the /hea_vens,",
                "and thy truth /un_to the /clouds.",
            ],
            [
                "Set up thy_self, O God, a_/bove the /hea_vens;",
                "and thy glo_ry a_/bove /all the /earth.",
            ],
        ],
    },
    {
        id: "psalm58",
        lines: [
            [
                "ARE your minds set up_on right_eous_ness, O ye /con_gre_/ga_tion?",
                "and do ye judge the thing that is right, /O ye /sons of /men?",
            ],
            [
                "Yea, ye i_ma_gine mis_chief in your /heart up_/on the /earth,",
                "and your hands /deal with /wick_ed_ness.",
            ],
            [
                "The un_god_ly are fro_ward, e_ven /from their /mo_ther's /womb;",
                "as soon as they are born, they go as_/tray, and /speak /lies.",
            ],
            [
                "They are as ve_no_mous as the poi_son /of a /ser_pent,",
                "e_ven like the deaf add_er, that /stopp_eth her /ears;",
            ],
            [
                "Which re_fus_eth to hear the /voice of the /char_mer,",
                "charm he /nev_er so /wise_ly.",
            ],
            [
                "Break their teeth, O /God, in their /mouths;",
                "smite the jaw-_bones of the /li_ons, O /LORD.",
            ],
            [
                "Let them fall a_way like wa_ter that /runn_eth a_/pace;",
                "when they shoot their arr_ows, /let them be /root_ed /out.",
            ],
            [
                "Let them con_sume a_way like a snail, and be like the un_time_ly /fruit of a /wo_man;",
                "and let them /not /see the /sun.",
            ],
            [
                "Or ev_er your /pots be made /hot with /thorns,",
                "he shall take them a_way with a whirl_wind, the green and the /burn_ing a_/like.",
            ],
            [
                "The right_eous shall re_joice when he /seeth the /ven_geance;",
                "he shall wash his foot_steps in the blood of /the un_/god_ly.",
            ],
            [
                "So that a man shall say, Ve_ri_ly there is a re_/ward for the /right_eous;",
                "doubt_less there is a God that /judg_eth the /earth.",
            ],
        ],
    },
    {
        id: "psalm59",
        lines: [
            [
                "DE_LI_VER me from mine /e_ne_mies, O /God;",
                "de_fend me from them that rise /up a_/gainst me.",
            ],
            [
                "O de_li_ver me from the /wick_ed /do_ers,",
                "and save me from the /blood-_thirs_ty /men.",
            ],
            [
                "For lo, they lie /wait_ing /for my /soul;",
                "the migh_ty men are ga_thered a_gainst me, with_out an_y of_fence or /fault of /me, O /LORD.",
            ],
            [
                "They run and pre_pare them_/selves with_/out my /fault;",
                "a_rise thou there_fore to /help me, /and be_/hold.",
            ],
            [
                "Stand up, O LORD God of hosts, thou God of Is_ra_el, to vis_it /all the /heath_en,",
                "and be not mer_ci_ful un_to them that off_end of ma_/li_cious /wick_ed_ness.",
            ],
            [
                "They go to and /fro in the /eve_ning,",
                "they grin like a dog, and run a_/bout through the /ci_ty.",
            ],
            [
                "Be_hold, they speak with their mouth, and /swords are /in their /lips;",
                "for /who doth /hear?",
            ],
            [
                "But thou, O LORD, shalt have them /in de_/ri_sion,",
                "and thou shalt laugh all the /heath_en to /scorn.",
            ],
            [
                "My strength will I a_/scribe un_to /thee;",
                "for thou art the /God of my /re_fuge.",
            ],
            [
                "God show_eth me his /good_ness /plent_eous_ly;",
                "and God shall let me see my de_sire up_/on mine /e_ne_mies.",
            ],
            [
                "Slay them not, lest my /peo_ple for_/get it;",
                "but scat_ter them a_broad a_mong the peo_ple, and put them down, O /Lord our de_/fence.",
            ],
            [
                "For the sin of their mouth, and for the words of their lips, they shall be /tak_en /in their /pride:",
                "and why? their talk is of /cur_sing and /lies.",
            ],
            [
                "Con_sume them in thy wrath, con_sume them, that /they may /per_ish;",
                "and know that it is God that rul_eth in Ja_cob, and un_to the /ends of the /world.",
            ],
            [
                "And in the /eve_ning they /will re_/turn,",
                "grin like a dog, and will go a_/bout the /ci_ty.",
            ],
            [
                "They will run /here and /there for /meat,",
                "and grudge if they /be not /sa_tis_fied.",
            ],
            [
                "As for me, I will sing of thy pow_er, and will praise thy mer_cy be_/times in the /mor_ning;",
                "for thou hast been my de_fence and re_fuge in the /day of my /trou_ble.",
            ],
            [
                "Un_to thee, O my /strength, will I /sing;",
                "for thou, O God, art my re_fuge, and my /mer_ci_ful /God.",
            ],
        ],
    },
    {
        id: "psalm60",
        lines: [
            [
                "O GOD, thou hast cast us out, and /scat_tered /us a_/broad;",
                "thou hast al_so been dis_pleased: O turn thee /un_to /us a_/gain.",
            ],
            [
                "Thou hast moved the /land, and di_/vi_ded /it:",
                "heal the sores there_of, /for it /shak_eth.",
            ],
            [
                "Thou hast showed thy /peo_ple /hea_vy /things;",
                "thou hast gi_ven us a /drink of /dead_ly /wine.",
            ],
            [
                "Thou hast gi_ven a to_ken for /such as /fear /thee,",
                "that they may tri_umph be_/cause of /the /truth.",
            ],
            [
                "There_fore were thy be_/lov_ed de_/li_vered;",
                "help me with thy right /hand, and /hear me.",
            ],
            [
                "God hath spo_ken in his ho_li_ness, I will re_joice, and di_/vide /She_chem,",
                "and mete out the /val_ley of /Succ_oth.",
            ],
            [
                "Gi_le_ad is mine, and Ma_/na_sseh /is /mine;",
                "Eph_ra_im al_so is the strength of my head; Ju_dah /is my /law-_gi_ver;",
            ],
            [
                "Mo_ab is my wash-_pot; o_ver E_dom will I /cast /out my /shoe;",
                "Phil_is_ti_a, /be thou /glad of /me.",
            ],
            [
                "Who will lead me in_to /the strong /ci_ty?",
                "who will bring me /in_to /E_dom?",
            ],
            [
                "Hast not thou /cast us /out, O /God?",
                "wilt not thou, O God, go /out /with our /hosts?",
            ],
            [
                "O be thou our /help in /trou_ble;",
                "for /vain is the /help of /man.",
            ],
            [
                "Through /God will we /do great /acts;",
                "for it is he that shall tread /down our /e_ne_mies.",
            ],
        ],
    },
    {
        id: "psalm61",
        lines: [
            ["HEAR my /cry_ing, O /God,", "give /ear un_to /my /prayer."],
            [
                "From the ends of the earth will I /call up_/on thee,",
                "when my /heart is in /hea_vi_ness.",
            ],
            [
                "O set me up up_on the rock that is /high_er /than /I;",
                "for thou hast been my hope, and a strong tow_er for me a_/gainst the /e_ne_my.",
            ],
            [
                "I will dwell in thy tab_er_/na_cle for /ev_er,",
                "and my trust shall be un_der the /co_ver_ing /of thy /wings.",
            ],
            [
                "For thou, O Lord, hast /heard my de_/sires,",
                "and hast gi_ven an he_ri_tage un_to /those that /fear thy /Name.",
            ],
            [
                "Thou shalt grant the /King a /long life,",
                "that his years may en_dure through_out all /gen_er_/a_tions.",
            ],
            [
                "He shall dwell be_fore /God for /ev_er:",
                "O pre_pare thy lov_ing mer_cy and faith_ful_ness, that they /may pre_/serve /him.",
            ],
            [
                "So will I al_way sing praise /un_to thy /Name,",
                "that I may /dai_ly per_/form my /vows.",
            ],
        ],
    },
    {
        id: "psalm62",
        lines: [
            [
                "MY soul tru_ly wait_eth /still up_on /God;",
                "for of him com_eth /my sal_/va_tion.",
            ],
            [
                "He ve_ri_ly is my strength and /my sal_/va_tion;",
                "he is my de_fence, so that I /shall not /great_ly /fall.",
            ],
            [
                "How long will ye i_ma_gine mis_chief a_/gainst eve_ry /man?",
                "Ye shall be slain all the sort of you; yea, as a tot_ter_ing wall shall ye be, and /like a /bro_ken /hedge.",
            ],
            [
                "Their de_vice is on_ly how to put him out whom /God will ex_/alt;",
                "their de_light is in lies; they give good words with their mouth, but /curse with /their /heart.",
            ],
            [
                "Ne_ver_the_less, my soul, wait thou /still up_/on /God;",
                "for my /hope is /in /him.",
            ],
            [
                "He tru_ly is my strength and /my sal_/va_tion;",
                "he is my de_fence, /so that I /shall not /fall.",
            ],
            [
                "In God is my /health and my /glo_ry;",
                "the rock of my might; and in /God is /my /trust.",
            ],
            [
                "O put your trust in him al_/way, ye /peo_ple;",
                "pour out your hearts be_fore him, for /God is our /hope.",
            ],
            [
                "As for the child_ren of men, they are but va_ni_ty; the child_ren of /men are de_/ceit_ful;",
                "up_on the weights they are al_to_ge_ther light_er than /va_ni_ty /it_/self.",
            ],
            [
                "O trust not in wrong and robb_e_ry; give not your_selves /un_to /va_ni_ty:",
                "if rich_es in_crease, set not your /heart up_/on them.",
            ],
            [
                "God spake once, and twice I have /al_so /heard the /same,",
                "that pow_er be_/long_eth /un_to /God;",
            ],
            [
                "And that thou, /Lord, art /mer_ci_ful;",
                "for thou re_ward_est eve_ry man ac_/cor_ding /to his /work.",
            ],
        ],
    },
    {
        id: "psalm63",
        lines: [
            ["O GOD, /thou art my /God;", "ear_ly /will I /seek thee."],
            [
                "My soul thirst_eth for thee, my flesh al_so /long_eth /af_ter /thee,",
                "in a bar_ren and dry /land where no /wa_ter /is.",
            ],
            [
                "Thus have I looked for thee in the /sanc_tu_/a_ry,",
                "that I might be_hold thy pow'r and /glo_ry.",
            ],
            [
                "For thy lov_ing-_kind_ness is bet_ter /than the /life it_/self:",
                "my /lips shall /praise thee.",
            ],
            [
                "As long as I live will I mag_ni_fy thee /in this /man_ner,",
                "and lift up my /hands in /thy /Name.",
            ],
            [
                "My soul shall be sa_tis_fied, e_ven as it were with /mar_row and /fat_ness,",
                "when my mouth prais_eth /thee with /joy_ful /lips.",
            ],
            [
                "Have I not re_/mem_bered thee /in my /bed,",
                "and thought up_on thee /when I /was /wak_ing?",
            ],
            [
                "Be_cause thou hast /been my /hel_per;",
                "there_fore un_der the sha_dow of thy /wings will /I re_/joice.",
            ],
            [
                "My soul /hang_eth up_/on /thee;",
                "thy right /hand hath up_/hold_en me.",
            ],
            [
                "These al_so that seek the /hurt of /my /soul,",
                "they shall go /un_der the /earth.",
            ],
            [
                "Let them fall up_on the /edge /of the /sword,",
                "that they may be a /por_tion for /fox_es.",
            ],
            [
                "But the King shall re_joice in God; all they al_so that swear by him shall /be com_/men_ded;",
                "for the mouth of them that speak /lies /shall be /stopped.",
            ],
        ],
    },
    {
        id: "psalm64",
        lines: [
            [
                "HEAR my voice, O /God, in my /prayer;",
                "pre_serve my life from /fear of the /e_ne_my.",
            ],
            [
                "Hide me from the gath_er_ing to_ge_ther /of the /fro_ward,",
                "and from the in_sur_rec_tion of /wick_ed /do_ers;",
            ],
            [
                "Who have whet their /tongue /like a /sword,",
                "and shoot out their arr_ows, /e_ven /bit_ter /words;",
            ],
            [
                "That they may pri_vi_ly shoot at him /that is /per_fect:",
                "sud_den_ly do they /hit him, and /fear not.",
            ],
            [
                "They en_cour_age them_/selves in /mis_chief,",
                "and comm_une a_mong them_selves, how they may lay snares; and say, that no /man shall /see them.",
            ],
            [
                "They i_ma_gine wick_ed_ness, and /prac_tise it;",
                "that they keep sec_ret a_mong them_selves, eve_ry man in the /deep of his /heart.",
            ],
            [
                "But God shall sud_den_ly shoot at them with a /swift /ar_row,",
                "that they /shall be /woun_ded.",
            ],
            [
                "Yea, their own /tongues shall /make them /fall;",
                "in_so_much that who_so seeth them shall /laugh them to /scorn.",
            ],
            [
                "And all men that see it shall say, /This hath /God done;",
                "for they shall per_ceive that it is /his work.",
            ],
            [
                "The right_eous shall re_joice in the LORD, and /put his /trust in him;",
                "and all they that are true of /heart shall be /glad.",
            ],
        ],
    },
    {
        id: "psalm65",
        lines: [
            [
                "THOU, O God, art /praised in /Si_on;",
                "and un_to thee shall the vow be per_/formed in Je_/ru_sa_lem.",
            ],
            [
                "Thou that /hear_est the /prayer,",
                "un_to /thee shall all /flesh come.",
            ],
            [
                "My mis_deeds pre_/vail a_/gainst /me:",
                "O be thou mer_ci_ful /un_to our /sins.",
            ],
            [
                "Bless_ed is the man whom thou choos_est, and re_/ceiv_est /un_to /thee:",
                "he shall dwell in thy court, and shall be sa_tis_fied with the plea_sures of thy house, e_ven of thy /ho_ly /tem_ple.",
            ],
            [
                "Thou shalt show us won_der_ful things in thy right_eous_ness, O God of /our sal_/va_tion;",
                "thou that art the hope of all the ends of the earth, and of them that re_/main in the /broad /sea.",
            ],
            [
                "Who in his strength set_teth /fast the /moun_tains,",
                "and is gir_ded a_/bout with /pow_er.",
            ],
            [
                "Who still_eth the /rag_ing /of the /sea,",
                "and the noise of his waves, and the mad_ness /of the /peo_ples.",
            ],
            [
                "They al_so that dwell in the ut_ter_most parts of the earth shall be a_/fraid at thy /tok_ens,",
                "thou that mak_est the out-_go_ings of the mor_ning and /eve_ning to /praise thee.",
            ],
            [
                "Thou vis_it_est the /earth, and /bless_est it;",
                "thou mak_est it /ve_ry /plen_te_ous.",
            ],
            [
                "The ri_ver of God is /full of /wa_ter:",
                "thou pre_par_est their corn, for so thou pro_/vi_dest /for the /earth.",
            ],
            [
                "Thou wa_ter_est her furr_ows; thou send_est rain in_to the lit_tle /vall_eys there_/of;",
                "thou mak_est it soft with the drops of rain, and bless_est the /in_crease of /it.",
            ],
            [
                "Thou crown_est the year /with thy /good_ness;",
                "and thy /clouds drop /fat_ness.",
            ],
            [
                "They shall drop up_on the dwell_ings /of the /wil_der_ness;",
                "and the lit_tle hills shall re_/joice on /eve_ry /side.",
            ],
            [
                "The folds /shall be /full of /sheep;",
                "the vall_eys al_so shall stand so thick with corn, that /they shall /laugh and /sing.",
            ],
        ],
    },
    {
        id: "psalm66",
        lines: [
            [
                "O BE joy_ful in /God, all ye /lands;",
                "sing prais_es un_to the ho_nour of his Name; make his /praise to be /glo_ri_ous.",
            ],
            [
                "Say un_to God, O how won_der_ful art /thou in /thy /works!",
                "through the great_ness of thy pow_er shall thine e_ne_mies bow /down /un_to /thee.",
            ],
            [
                "For all the /world shall /wor_ship thee,",
                "sing of /thee, and /praise thy /Name.",
            ],
            [
                "O come hi_ther, and be_/hold the /works of /God;",
                "how won_der_ful he is in his do_ing to_ward the /child_ren /of /men.",
            ],
            [
                "He turned the sea /in_to /dry /land,",
                "so that they went through the wa_ter on foot; there did /we re_/joice there_/of.",
            ],
            [
                "He rul_eth with his pow_er for ev_er; his eyes be_/hold the /na_tions:",
                "and such as will not be_lieve shall not be a_ble /to ex_/alt them_/selves.",
            ],
            [
                "O praise our /God, ye /peo_ples,",
                "and make the voice of his /praise to be /heard;",
            ],
            [
                "Who /hold_eth our /soul in /life;",
                "and suff_er_eth /not our /feet to /slip.",
            ],
            [
                "For thou, O /God, hast /proved us;",
                "thou al_so hast tried us, like as /sil_ver is /tried.",
            ],
            [
                "Thou brought_est us /in_to the /snare;",
                "and laid_est /trou_ble up_/on our /loins.",
            ],
            [
                "Thou suffer_edst men to ride /o_ver our /heads;",
                "we went through fire and wa_ter, and thou brought_est us out /in_to a /weal_thy /place.",
            ],
            [
                "I will go in_to thine house with burnt-_off_er_ings, and will /pay thee my /vows,",
                "which I prom_ised with my lips, and spake with my mouth, when /I was in /trou_ble.",
            ],
            [
                "I will off_er un_to thee fat burnt-_sac_ri_fi_ces, with the /in_cense of /rams;",
                "I will off_er /bull_ocks and /goats.",
            ],
            [
                "O come hi_ther, and hear_ken, all /ye that /fear /God;",
                "and I will tell you what he hath /done for /my /soul.",
            ],
            [
                "I called un_to /him with my /mouth,",
                "and gave him /prais_es /with my /tongue.",
            ],
            [
                "If I in_cline un_to /wick_ed_ness /with mine /heart,",
                "the Lord /will not /hear me.",
            ],
            [
                "But /God hath /heard me;",
                "and con_sid_ered the /voice of my /prayer.",
            ],
            [
                "Praised be God, who hath not /cast out my /prayer,",
                "nor turned his /mer_cy /from /me.",
            ],
        ],
    },
    {
        id: "psalm67",
        lines: [
            [
                "GOD be mer_ci_ful un_to /us, and /bless us,",
                "and show us the light of his coun_te_nance, and be /mer_ci_ful /un_to /us;",
            ],
            [
                "That thy way may be /known up_/on /earth,",
                "thy sav_ing health a_/mong all /na_tions.",
            ],
            [
                "Let the peo_ples /praise thee, O /God;",
                "yea, let all the /peo_ples /praise thee.",
            ],
            [
                "O let the na_tions re_/joice and be /glad;",
                "for thou shalt judge the folk right_eous_ly, and gov_ern the /na_tions up_on /earth.",
            ],
            [
                "Let the peo_ples /praise thee, O /God;",
                "yea, let all the /peo_ples /praise thee.",
            ],
            [
                "Then shall the earth bring /forth her /in_crease;",
                "and God, e_ven our own God, shall /give us his /bless_ing.",
            ],
            [
                "/God shall /bless us;",
                "and all the ends of the /world shall /fear him.",
            ],
        ],
    },
    {
        id: "psalm68",
        lines: [
            [
                "LET God a_rise, and let his /e_ne_mies be /scat_tered;",
                "let them al_so that hate him /flee be_/fore him.",
            ],
            [
                "Like as the smoke van_ish_eth, so shalt thou /drive them a_/way;",
                "and like as wax melt_eth at the fire, so let the un_god_ly per_ish at the /pres_ence /of /God.",
            ],
            [
                "But let the right_eous be glad, and re_/joice be_/fore /God;",
                "let them al_so be /mer_ry and /joy_ful.",
            ],
            [
                "O sing un_to God, and sing prais_es un_to his Name; mag_ni_fy him that rid_eth up_/on the /hea_vens;",
                "praise him in his Name JAH, and re_/joice be_/fore him.",
            ],
            [
                "He is a Fa_ther of the fa_ther_less, and de_fend_eth the /cause of the /wid_ows;",
                "e_ven God in his ho_ly /ha_bi_/ta_tion.",
            ],
            [
                "He is the God that mak_eth men to be of one mind in an house, and bring_eth the pris_on_ers /out of cap_/ti_vi_ty;",
                "but let_teth the run_a_gates con_/tin_ue in /scarce_ness.",
            ],
            [
                "O God, when thou went_est forth be_/fore the /peo_ple;",
                "when thou went_est /through the /wil_der_ness,",
            ],
            [
                "The earth shook, and the hea_vens dropped at the /pres_ence /of /God;",
                "e_ven as Si_nai al_so was moved at the pres_ence of God, who is the /God of /Is_ra_el.",
            ],
            [
                "Thou, O God, sent_est a gra_cious rain up_on /thine in_/he_ri_tance,",
                "and ref_resh_edst it /when it was /wea_ry.",
            ],
            [
                "Thy con_gre_/ga_tion shall /dwell there_in;",
                "for thou, O God, hast of thy good_ness pre_/pared /for the /poor.",
            ],
            [
                "The /Lord gave the /word;",
                "great was the com_pa_ny of wo_men that /bare the /tid_ings.",
            ],
            [
                "Kings with their arm_ies did flee, and /were dis_/com_fit_ed,",
                "and they of the house_hold di_/vi_ded /the /spoil.",
            ],
            [
                "Though ye have lain a_mong the sheep-_folds, yet shall ye be as the /wings of a /dove",
                "that is co_vered with sil_ver wings, and her /feath_ers /like /gold.",
            ],
            [
                "When the Al_migh_ty scat_tered /kings for their /sake,",
                "then were they as white as /snow in /Sal_mon.",
            ],
            [
                "As the hill of Ba_shan, /so is /God's hill;",
                "e_ven an high hill, as the /hill of /Ba_shan.",
            ],
            [
                "Why mock ye so, ye high hills? this is God's hill, in the which it /pleas_eth /him to /dwell;",
                "yea, the LORD will a_bide in /it for /ev_er.",
            ],
            [
                "The cha_ri_ots of God are twen_ty thou_sand, e_ven /thou_sands of /an_gels;",
                "and the Lord is a_mong them as in the ho_ly /place of /Si_nai.",
            ],
            [
                "Thou art gone up on high, thou hast led cap_ti_vi_ty cap_tive, and re_/ceived /gifts from /men;",
                "yea, e_ven from thine e_ne_mies, that the LORD God might /dwell a_/mong them.",
            ],
            [
                "Praised /be the Lord /dai_ly,",
                "e_ven the God who help_eth us, and pour_eth his be_ne_/fits up_/on us.",
            ],
            [
                "He is our God, e_ven the God of whom /com_eth sal_/va_tion:",
                "GOD is the Lord, by /whom we es_/cape /death.",
            ],
            [
                "God shall wound the /head of his /e_ne_mies,",
                "and the hai_ry scalp of such a one as go_eth on /still in his /wick_ed_ness.",
            ],
            [
                "The Lord hath said, I will bring my peo_ple a_gain, as I /did from /Ba_shan;",
                "mine own will I bring a_gain, as I did some_time from the /deep of the /sea.",
            ],
            [
                "That thy foot may be dipped in the /blood of thine /e_ne_mies,",
                "and that the tongue of thy dogs may be /red through the /same.",
            ],
            [
                "It is well seen, O God, /how thou /go_est;",
                "how thou, my God and King, go_est in the /sanc_tu_/a_ry.",
            ],
            [
                "The sing_ers go be_fore, the min_strels /fol_low /af_ter,",
                "in the midst of the dam_sels play_ing /with the /tim_brels.",
            ],
            [
                "Give thanks un_to God the Lord in the /con_gre_/ga_tion,",
                "ye that are of the /foun_tain of /Is_ra_el.",
            ],
            [
                "There is lit_tle Ben_ja_min their ru_ler, and the prin_ces of /Ju_dah their /coun_cil;",
                "the prin_ces of Ze_bu_lon, and the prin_ces /of Naph_/tha_li.",
            ],
            [
                "Thy God hath /sent forth /strength for /thee;",
                "stab_lish the thing, O God, that /thou hast /wrought in /us,",
            ],
            [
                "For thy temp_le's /sake at Je_/ru_sa_lem;",
                "so shall kings bring /pres_ents /un_to /thee.",
            ],
            [
                "Re_buke thou the dra_gon and the bull, with the lead_ers of the heath_en, so that they humb_ly bring /pie_ces of /sil_ver;",
                "scat_ter thou the peo_ples /that de_/light in /war;",
            ],
            [
                "Then shall the prin_ces come /out of /E_gypt;",
                "the Mo_ri_ans' land shall soon stretch out her /hands un_to /God.",
            ],
            [
                "Sing un_to God, O ye /king_doms /of the /earth;",
                "O sing prais_es /un_/to the /Lord;",
            ],
            [
                "Who sitt_eth in the hea_vens o_ver all, /from the be_/ginn_ing:",
                "lo, he doth send out his voice; yea, and /that a /migh_ty /voice.",
            ],
            [
                "A_scribe ye the pow_er to God /o_ver /Is_ra_el;",
                "his wor_ship and /strength is /in the /clouds.",
            ],
            [
                "O God, won_der_ful art thou in thy /ho_ly /pla_ces:",
                "e_ven the God of Is_ra_el, he will give strength and pow_er un_to his peo_ple. /Bless_ed be /God.",
            ],
        ],
    },
    {
        id: "psalm69",
        lines: [
            [
                "SAVE me, O /God;",
                "for the wa_ters are come in, e_ven /un_to my /soul.",
            ],
            [
                "I stick fast in the deep mire, /where no /ground is;",
                "I am come in_to deep wa_ters, so that the /floods run /o_ver me.",
            ],
            [
                "I am wea_ry of cry_ing; /my /throat is /dry;",
                "my sight fail_eth me for wait_ing so /long up_/on my /God.",
            ],
            [
                "They that hate me with_out a cause are more than the /hairs of my /head;",
                "they that are mine e_ne_mies, and would des_troy me /guilt_less, are /migh_ty.",
            ],
            [
                "I paid them the /things that I /nev_er /took:",
                "God, thou know_est my sim_ple_ness, and my /faults are not /hid from thee.",
            ],
            [
                "Let not them that trust in thee, O Lord GOD of hosts, be a_/shamed for my /cause;",
                "let not those that seek thee be con_foun_ded through me, O Lord /God of /Is_ra_el.",
            ],
            [
                "And why? for thy sake have I /suff_ered re_/proof;",
                "shame hath /co_vered my /face.",
            ],
            [
                "I am be_come a stran_ger /un_to my /breth_ren,",
                "e_ven an a_li_en un_to my /mo_ther's /child_ren.",
            ],
            [
                "For the zeal of thine house hath /e_ven /eat_en me;",
                "and the re_bukes of them that re_buked thee are /fall_en up_/on me.",
            ],
            [
                "I wept, and chast_ened my_/self with /fast_ing,",
                "and that was /turned to my /re_/proof.",
            ],
            ["I put on /sack_cloth /al_so,", "and they /jes_ted up_/on me."],
            [
                "They that sit in the /gate speak a_/gainst me,",
                "and the drunk_ards make /songs up_/on me.",
            ],
            [
                "But, LORD, I make my /prayer un_to /thee",
                "in an ac_/cep_ta_ble /time.",
            ],
            [
                "Hear me, O God, in the mul_ti_tude /of thy /mer_cy,",
                "e_ven in the truth of /thy sal_/va_tion.",
            ],
            [
                "Take me out of the /mire, that I /sink not;",
                "O let me be de_li_vered from them that hate me, and out of the deep /wa_ters.",
            ],
            [
                "Let not the wa_ter-_flood drown me, nei_ther let the deep /swal_low me /up;",
                "and let not the pit shut her /mouth up_/on me.",
            ],
            [
                "Hear me, O LORD, for thy lov_ing-_kind_ness is /com_fort_able;",
                "turn thee un_to me ac_cor_ding to the mul_ti_tude /of thy /mer_cies.",
            ],
            [
                "And hide not thy face from thy ser_vant; for /I am in /trou_ble:",
                "O /haste thee, and /hear me.",
            ],
            [
                "Draw nigh un_to my /soul, and /save it;",
                "O de_li_ver me, be_/cause of mine /e_ne_mies.",
            ],
            [
                "Thou hast known my rep_roach, my shame, and /my dis_/hon_our:",
                "mine ad_ver_sa_ries are /all /in thy /sight.",
            ],
            [
                "Rep_roach hath bro_ken my heart; I am /full of /hea_vi_ness:",
                "I looked for some to have pi_ty on me, but there was no man, nei_ther found I /an_y to /com_fort me.",
            ],
            [
                "They /gave me /gall to /eat;",
                "and when I was thirs_ty they gave me /vi_ne_gar to /drink.",
            ],
            [
                "Let their ta_ble be made a snare to /take them_/selves with_/al;",
                "and let the things that should have been for their wealth be un_to them an oc_/ca_sion of /fall_ing.",
            ],
            [
                "Let their eyes be blin_ded, /that they /see not;",
                "and ev_er /bow thou /down their /backs.",
            ],
            [
                "Pour out thine in_dig_/na_tion up_/on them,",
                "and let thy wrath_ful dis_/plea_sure take /hold of them.",
            ],
            [
                "Let their ha_bi_/ta_tion be /void,",
                "and no man to /dwell in their /tents.",
            ],
            [
                "For they per_se_cute him whom /thou hast /smit_ten;",
                "and they talk how they may vex them whom /thou hast /woun_ded.",
            ],
            [
                "Let them fall from one wick_ed_ness /to a_/no_ther,",
                "and not come /in_to thy /right_eous_ness.",
            ],
            [
                "Let them be wiped out of the /book of the /li_ving,",
                "and not be writ_ten a_/mong the /right_eous.",
            ],
            [
                "As for me, when I am /poor and in /hea_vi_ness,",
                "thy help, O /God, shall /lift me /up.",
            ],
            [
                "I will praise the Name of /God with a /song,",
                "and mag_ni_fy it /with thanks_/giv_ing.",
            ],
            [
                "This al_so /shall please the /LORD",
                "bet_ter than a bull_ock /that hath /horns and /hoofs.",
            ],
            [
                "The hum_ble shall con_si_der /this, and be /glad:",
                "seek ye af_ter God, /and your /soul shall /live.",
            ],
            [
                "For the LORD /hear_eth the /poor,",
                "and des_pis_eth /not his /pris_on_ers.",
            ],
            [
                "Let hea_ven /and earth /praise him:",
                "the sea, and all that /mov_eth there_/in.",
            ],
            [
                "For God will save Si_on, and build the /ci_ties of /Ju_dah,",
                "that men may dwell there, and have it /in pos_/sess_ion.",
            ],
            [
                "The pos_te_ri_ty al_so of his ser_vants /shall in_/he_rit it;",
                "and they that love his /Name shall /dwell there_/in.",
            ],
        ],
    },
    {
        id: "psalm70",
        lines: [
            [
                "HASTE thee, O /God, to de_/li_ver me;",
                "make haste to /help me, /O /LORD.",
            ],
            [
                "Let them be a_shamed and con_foun_ded that seek /af_ter my /soul;",
                "let them be turned back_ward and put to con_fu_sion that /wish me /e_vil.",
            ],
            [
                "Let them for their re_ward be /soon /brought to /shame,",
                "that cry /o_ver me, /There! there!",
            ],
            [
                "But let all those that seek thee be /joy_ful and /glad in thee:",
                "and let all such as de_light in thy sal_va_tion say al_way, /The /Lord be /praised.",
            ],
            [
                "As for me, I am /poor and in /mi_se_ry:",
                "haste thee /un_to me, /O God.",
            ],
            [
                "Thou art my hel_per, and /my re_/dee_mer:",
                "O LORD, make /no long /tar_ry_ing.",
            ],
        ],
    },
    {
        id: "psalm71",
        lines: [
            [
                "IN thee, O LORD, have I put my trust; let me nev_er be /put to con_/fu_sion,",
                "but rid me and de_li_ver me in thy right_eous_ness; in_cline thine ear un_to /me, and /save me.",
            ],
            [
                "Be thou my strong_hold, where_un_to I may /al_way res_/ort:",
                "thou hast prom_ised to help me, for thou art my house of de_/fence, and my /ca_stle.",
            ],
            [
                "De_li_ver me, O my God, out of the hand of /the un_/god_ly,",
                "out of the hand of the un_/right_eous and /cru_el /man.",
            ],
            [
                "For thou, O Lord GOD, art the /thing that I /long for:",
                "thou art my hope, /e_ven /from my /youth.",
            ],
            [
                "Through thee have I been hold_en up ev_er /since /I was /born:",
                "thou art he that took me out of my mo_ther's womb: my praise shall be /al_way of /thee.",
            ],
            [
                "I am be_come as it were a mon_ster /un_to /ma_ny,",
                "but my sure /trust is in /thee.",
            ],
            [
                "O let my mouth be /filled with /thy /praise,",
                "that I may sing of thy glo_ry and ho_nour /all the /day /long.",
            ],
            [
                "Cast me not a_/way in the /time of /age;",
                "for_sake me not when /my strength /fail_eth me.",
            ],
            [
                "For mine e_ne_mies /speak a_/gainst me;",
                "and they that lay wait for my soul take their coun_sel to_/ge_ther, /say_ing,",
            ],
            [
                "God /hath for_/sa_ken him;",
                "per_se_cute him, and take him, for there is /none to de_/li_ver /him.",
            ],
            [
                "Go not /far from /me, O /God;",
                "my God, /haste thee to /help me.",
            ],
            [
                "Let them be con_foun_ded and per_ish /that are a_/gainst my /soul;",
                "let them be co_vered with shame and dis_hon_our that seek to /do me /e_vil.",
            ],
            [
                "As for me, I will pa_tient_/ly a_bide /al_way,",
                "and will /praise thee /more and /more.",
            ],
            [
                "My mouth shall dai_ly speak of thy right_eous_ness /and sal_/va_tion;",
                "for I /know no /end there_/of.",
            ],
            [
                "I will go forth in the /strength of the /Lord GOD,",
                "and will make men_tion of thy /right_eous_ness /on_ly.",
            ],
            [
                "Thou, O God, hast taught me from my youth /up un_/til /now;",
                "there_fore will I /tell of thy /won_drous /works.",
            ],
            [
                "For_sake me not, O God, in mine old age, when /I am /gray-_/head_ed,",
                "un_til I have showed thy strength un_to this ge_ne_ra_tion, and thy pow_er to all them that are /yet for to /come.",
            ],
            [
                "Thy right_eous_ness, O /God, is /ve_ry /high,",
                "and great things are they that thou hast done: O God, who is /like /un_to /thee!",
            ],
            [
                "O what great trou_bles and ad_ver_si_ties hast thou showed me! and yet didst thou /turn and ref_/resh me;",
                "yea, and brought_est me from the /deep of the /earth a_/gain.",
            ],
            [
                "Thou hast brought me /to great /ho_nour,",
                "and com_for_ted /me on /eve_ry /side:",
            ],
            [
                "There_fore will I praise thee, and thy faith_ful_ness, O God, play_ing up_on an in_stru_/ment of /mu_sic:",
                "un_to thee will I sing up_on the harp, O thou Ho_ly /One of /Is_ra_el.",
            ],
            [
                "My lips will be glad when I /sing un_to /thee;",
                "and so will my soul whom thou /hast de_/li_vered.",
            ],
            [
                "My tongue al_so shall talk of thy right_eous_ness /all the day /long;",
                "for they are con_foun_ded and brought un_to shame that seek to /do me /e_vil.",
            ],
        ],
    },
    {
        id: "psalm72",
        lines: [
            [
                "GIVE the King thy /judg_ments, O /God,",
                "and thy right_eous_ness /un_to the /King's son.",
            ],
            [
                "Then shall he judge thy peo_ple ac_/cor_ding /un_to /right,",
                "/and de_/fend the poor.",
            ],
            [
                "The moun_tains /al_so /shall bring /peace,",
                "and the lit_tle hills right_eous_ness /un_to the /peo_ple.",
            ],
            [
                "He shall keep the sim_ple /folk /by their /right,",
                "de_fend the child_ren of the poor, and pu_nish /the wrong /do_er.",
            ],
            [
                "They shall fear thee, as long as the sun and /moon en_/dur_eth,",
                "from one ge_ne_ra_tion /to a_/no_ther.",
            ],
            [
                "He shall come down like the rain up_/on the /mown grass,",
                "e_ven as the drops that /wa_ter the /earth.",
            ],
            [
                "In his time shall the /right_eous /flou_rish;",
                "yea, and ab_un_dance of peace, so long as the /moon en_/dur_eth.",
            ],
            [
                "His do_min_ion shall be al_so from the one /sea to the /oth_er,",
                "and from the Ri_ver /un_to the /world's end.",
            ],
            [
                "They that dwell in the wil_der_ness shall /kneel be_/fore him;",
                "his e_ne_mies /shall /lick the /dust.",
            ],
            [
                "The kings of Tar_shish and of the /isles shall give /pres_ents;",
                "the kings of A_ra_bi_a and /Sa_ba shall /bring /gifts.",
            ],
            [
                "All kings shall fall /down be_/fore him;",
                "all na_tions shall /do him /ser_vice.",
            ],
            [
                "For he shall de_li_ver the /poor when he /cri_eth;",
                "the nee_dy al_so, and him that /hath no /hel_per.",
            ],
            [
                "He shall be fa_vour_a_ble to the /sim_ple and /nee_dy,",
                "and shall pre_serve the /souls /of the /poor.",
            ],
            [
                "He shall de_li_ver their souls from /false_hood and /wrong;",
                "and dear shall their /blood be /in his /sight.",
            ],
            [
                "He shall live, and un_to him shall be gi_ven of the /gold of A_/ra_bi_a;",
                "prayer shall be made ev_er un_to him, and dai_ly /shall /he be /praised.",
            ],
            [
                "There shall be an heap of corn in the earth, high up_on the hills; the fruit there_of shall /shake like /Le_ba_non:",
                "and they of the ci_ty shall flou_rish like /grass up_/on the /earth.",
            ],
            [
                "His Name shall en_dure for ev_er; his Name shall re_main un_der the sun a_mong the pos_te_ri_ties, which /shall be /blessed in /him;",
                "and all the /na_tions shall /praise him.",
            ],
            [
                "Bless_ed be the LORD God, e_ven the /God of /Is_ra_el,",
                "which on_ly /do_eth /won_drous /things;",
            ],
            [
                "And bless_ed be the Name of his ma_jes_ty for /ev_er:",
                "and all the earth shall be filled with his ma_jes_ty. /A_men, /A_men.",
            ],
        ],
    },
    {
        id: "psalm73",
        lines: [
            [
                "TRU_LY God is lov_ing /un_to /Is_ra_el:",
                "e_ven un_to such as are /of a /clean /heart.",
            ],
            [
                "Ne_ver_the_less, my /feet were /al_most /gone,",
                "my /tread_ings had /well-_nigh /slipt.",
            ],
            [
                "And why? I was /grieved at the /wick_ed:",
                "I do al_so see the un_god_ly in /such pros_/pe_ri_ty.",
            ],
            [
                "For they are in no /pe_ril of /death;",
                "but are /lus_ty and /strong.",
            ],
            [
                "They come in no mis_/for_tune like /oth_er /folk;",
                "nei_ther are they /plagued like /oth_er /men.",
            ],
            [
                "And this is the cause that they are so /hold_en with /pride,",
                "and cruel_ty co_ver_eth them /as a /gar_ment.",
            ],
            [
                "Their eyes /swell with /fat_ness,",
                "and they do /e_ven /what they /lust.",
            ],
            [
                "They cor_rupt oth_er, and speak of /wick_ed /blas_phe_my;",
                "their talk_ing is a_/gainst the /Most /High.",
            ],
            [
                "For they stretch forth their mouth /un_to the /hea_ven,",
                "and their tongue /go_eth /through the /world.",
            ],
            [
                "There_fore fall the /peo_ple /un_to /them,",
                "and there_out suck they no /small ad_/van_tage.",
            ],
            [
                "Tush, say they, how should /God per_/ceive it?",
                "is there know_ledge /in the /Most /High?",
            ],
            [
                "Lo, these are /the un_/god_ly,",
                "these pros_per in the world, and these have rich_es /in pos_/sess_ion:",
            ],
            [
                "And I said, Then have I /cleansed my /heart in /vain,",
                "and washed my hands in /in_no_/cen_cy.",
            ],
            [
                "All the day long have /I been /pun_ished,",
                "and chast_ened /eve_ry /mor_ning.",
            ],
            [
                "Yea, and I had al_most said /e_ven as /they;",
                "but lo, then I should have con_demned the ge_ne_ra_tion /of thy /child_ren.",
            ],
            [
                "Then thought I to /un_der_/stand this;",
                "but it /was too /hard for /me,",
            ],
            [
                "Un_til I went in_to the sanc_tu_/a_ry of /God:",
                "then un_der_stood I the /end of /these /men;",
            ],
            [
                "Name_ly, how thou dost set them in /slip_pe_ry /pla_ces,",
                "and cast_est them down, /and des_/troy_est /them.",
            ],
            [
                "O how sud_den_ly /do they con_/sume,",
                "per_ish, and /come to a /fear_ful /end!",
            ],
            [
                "Yea, e_ven like as a dream when /one a_/wak_eth;",
                "so shalt thou make their im_age to van_ish /out of the /ci_ty.",
            ],
            [
                "Thus /my /heart was /grieved,",
                "and it went /e_ven /through my /reins.",
            ],
            [
                "So fool_ish was /I, and /ig_no_rant,",
                "e_ven as it were a /beast be_/fore thee.",
            ],
            [
                "Ne_ver_the_less, I am /al_way by /thee;",
                "for thou hast hold_en me /by my /right hand.",
            ],
            [
                "Thou shalt guide me /with thy /coun_sel,",
                "and af_ter that re_/ceive me with /glo_ry.",
            ],
            [
                "Whom have I in /hea_ven but /thee?",
                "and there is none up_on earth that I de_sire in com_/pa_ri_son /of /thee.",
            ],
            [
                "My flesh /and my heart /fail_eth;",
                "but God is the strength of my heart, and my /por_tion for /ev_er.",
            ],
            [
                "For lo, they that for_/sake thee shall /per_ish;",
                "thou hast des_troyed all them that are un_/faith_ful /un_to /thee.",
            ],
            [
                "But it is good for me to hold me fast by God, to put my /trust in the /Lord GOD,",
                "and to speak of all thy works in the gates of the /daugh_ter of /Si_on.",
            ],
        ],
    },
    {
        id: "psalm74",
        lines: [
            [
                "O GOD, where_fore art thou ab_sent /from us /so /long?",
                "why is thy wrath so hot a_gainst the /sheep of thy /pas_ture?",
            ],
            [
                "O think up_on thy /con_gre_/ga_tion,",
                "whom thou hast purch_ased, /and re_/deemed of /old.",
            ],
            [
                "Think up_on the tribe of /thine in_/he_ri_tance,",
                "and Mount Si_on, /where_in thou /hast /dwelt.",
            ],
            [
                "Lift up thy feet, that thou may_est utt_er_ly des_troy /eve_ry /e_ne_my,",
                "which hath done e_vil in thy /sanc_tu_/a_ry.",
            ],
            [
                "Thine ad_ver_sa_ries roar in the midst of thy /con_gre_/ga_tions,",
                "and set up their /ban_ners for /tok_ens.",
            ],
            [
                "He that hewed tim_ber a_fore /out of the /thick /trees,",
                "was known to bring it to an /ex_cell_ent /work.",
            ],
            [
                "But now they break down all the /carved /work there_/of",
                "with /ax_es and /ham_mers.",
            ],
            [
                "They have set fire up_on thy /ho_ly /pla_ces,",
                "and have de_filed the dwell_ing-_place of thy Name, e_ven /un_to the /ground.",
            ],
            [
                "Yea, they said in their hearts, Let us make hav_oc of them /al_to_/ge_ther:",
                "thus have they burnt up all the hou_ses of /God in the /land.",
            ],
            [
                "We see not our tok_ens; there is not /one /pro_phet /more;",
                "no, not one is there a_mong us, that un_der_/stand_eth /an_y /more.",
            ],
            [
                "O God, how long shall the ad_ver_sa_ry /do this dis_/hon_our?",
                "shall the e_ne_my blas_pheme thy /Name for /ev_er?",
            ],
            [
                "Why with_/draw_est /thou thy /hand?",
                "why pluck_est thou not thy right hand out of thy bo_som to con_/sume the /e_ne_my?",
            ],
            [
                "For /God is my /King of /old;",
                "the help that is done up_on earth, he /do_eth /it him_/self.",
            ],
            [
                "Thou didst di_vide the sea /through thy /pow_er;",
                "thou brak_est the heads of the dra_gons /in the /wa_ters.",
            ],
            [
                "Thou smot_est the heads of le_/vi_a_than in /pie_ces,",
                "and gav_est him to be meat for the peo_ple /of the /wil_der_ness.",
            ],
            [
                "Thou brought_est out foun_tains and wa_ters /out of the /hard /rocks;",
                "thou driedst up /migh_ty /wa_ters.",
            ],
            [
                "The day is /thine, and the /night is thine;",
                "thou hast pre_pared the /light and the /sun.",
            ],
            [
                "Thou hast set all the /bor_ders /of the /earth;",
                "thou hast made /sum_mer and /win_ter.",
            ],
            [
                "Re_mem_ber this, O LORD, how the /e_ne_my /hath re_/buked;",
                "and how the fool_ish peo_ple /hath blas_/phemed thy /Name.",
            ],
            [
                "O de_li_ver not the soul of thy tur_tle-_dove un_to the mul_ti_tude /of the /e_ne_mies;",
                "and for_get not the con_gre_ga_tion of the /poor for /ev_er.",
            ],
            [
                "Look up_/on the /co_ve_nant;",
                "for all the earth is full of dark_ness and cru_el /ha_bi_/ta_tions.",
            ],
            [
                "O let not the sim_ple /go a_/way a_/shamed;",
                "but let the poor and nee_dy give praise /un_to /thy /Name.",
            ],
            [
                "A_rise, O God, main_/tain thine /own /cause;",
                "re_mem_ber how the fool_ish man blas_/phem_eth thee /dai_ly.",
            ],
            [
                "For_get not the /voice of thine /e_ne_mies:",
                "the pre_sump_tion of them that hate thee in_creas_eth /ev_er /more and /more.",
            ],
        ],
    },
    {
        id: "psalm75",
        lines: [
            [
                "UN_TO thee, O God, /do we /give thanks;",
                "yea, un_to /thee do /we give /thanks.",
            ],
            [
                "Thy Name /al_so /is so /nigh;",
                "and that do thy /won_drous /works de_/clare.",
            ],
            [
                "In the ap_/poin_ted /time, saith /God,",
                "I shall judge ac_/cor_ding /un_to /right.",
            ],
            [
                "The earth is weak, and all the in_/hab_it_ers /there_of:",
                "I bear up the /pill_ars of /it.",
            ],
            [
                "I said un_to the fools, /Deal not so /mad_ly;",
                "and to the un_god_ly, /Set not /up your /horn.",
            ],
            [
                "Set not /up your /horn on /high,",
                "and speak /not with a /stiff /neck.",
            ],
            [
                "For pro_mo_tion com_eth nei_ther from the east, /nor /from the /west,",
                "nor /yet from the /south.",
            ],
            [
                "And why? /God is the /Judge;",
                "he putt_eth down one, and set_teth /up a_/no_ther.",
            ],
            [
                "For in the hand of the LORD there is a /cup, and the /wine is /red;",
                "it is full mixt, and he pour_eth /out of the /same.",
            ],
            [
                "/As for the /dregs there_/of,",
                "all the un_god_ly of the earth shall /drink them, and /suck them /out.",
            ],
            [
                "But I will talk of the /God of /Ja_cob,",
                "and /praise him for /ev_er.",
            ],
            [
                "All the horns of the un_god_ly /al_so /will I /break,",
                "and the horns of the right_eous shall /be ex_/al_ted.",
            ],
        ],
    },
    {
        id: "psalm76",
        lines: [
            ["IN /Ju_dah is /God /known;", "his Name is /great in /Is_ra_el."],
            [
                "At Sa_lem is his /tab_er_/na_cle,",
                "and his /dwell_ing in /Si_on.",
            ],
            [
                "There brake he the /arr_ows /of the /bow,",
                "the shield, the /sword, and the /bat_tle.",
            ],
            [
                "Thou art /glo_rious in /might,",
                "when thou com_est from the /hills of the /rob_bers.",
            ],
            [
                "The proud are robbed, /they have /slept their sleep;",
                "and all the men whose hands were migh_ty /have found /noth_ing.",
            ],
            [
                "At thy re_buke, O /God of /Ja_cob,",
                "both the cha_ri_ot and /horse are /fall_en.",
            ],
            [
                "Thou, e_ven thou /art to be /feared;",
                "and who may stand in thy sight when /thou art /an_gry?",
            ],
            [
                "Thou didst cause thy judg_ment to be /heard from /hea_ven;",
                "the earth /trem_bled, /and was /still,",
            ],
            [
                "When God ar_/ose to /judg_ment,",
                "and to help all the /meek up_/on earth.",
            ],
            [
                "The fierce_ness of man shall /turn to thy /praise;",
                "and the fierce_ness of them /shalt /thou re_/frain.",
            ],
            [
                "Prom_ise un_to the LORD your God, and keep it, all ye that are /round a_/bout him;",
                "bring pres_ents un_to him that /ought /to be /feared.",
            ],
            [
                "He shall re_frain the /spi_rit of /prin_ces,",
                "and is won_der_ful a_mong the /kings of the /earth.",
            ],
        ],
    },
    {
        id: "psalm77",
        lines: [
            [
                "I WILL cry un_to /God with my /voice;",
                "e_ven un_to God will I cry with my voice, and he shall /hear_ken /un_to /me.",
            ],
            [
                "In the time of my /trou_ble I /sought the /Lord:",
                "I stretched forth my hands un_to him, and ceased not in the night sea_son; my /soul re_fused /com_fort.",
            ],
            [
                "When I am in hea_vi_ness, I will /think up_/on /God;",
                "when my heart is vexed, /I will com_/plain.",
            ],
            [
                "Thou /hold_est mine /eyes /wak_ing:",
                "I am so fee_ble /that I /can_not /speak.",
            ],
            [
                "I have con_/sid_ered the /days of /old,",
                "and the /years that are /past.",
            ],
            [
                "I call to re_/mem_brance my /song,",
                "and in the night I comm_une with mine own heart, and search /out my /spi_rit.",
            ],
            [
                "Will the Lord ab_sent him_/self for /ev_er?",
                "and will he be no /more in_/treat_ed?",
            ],
            [
                "Is his mer_cy clean /gone for /ev_er?",
                "and is his prom_ise come utt_er_ly to an /end for /ev_er_more?",
            ],
            [
                "Hath God for_got_ten /to be /gra_cious?",
                "and will he shut up his lov_ing-_kind_ness /in dis_/plea_sure?",
            ],
            [
                "And I said, It is mine /own in_/fir_mi_ty;",
                "but I will re_mem_ber the years of the right /hand of the /Most /High_est.",
            ],
            [
                "I will re_mem_ber the /works of the /LORD,",
                "and call to mind thy /won_ders of /old time.",
            ],
            [
                "I will think /al_so of /all thy /works,",
                "and my talk_ing shall be /of thy /do_ings.",
            ],
            [
                "Thy way, O /God, is /ho_ly:",
                "who is so great a /God as our /God?",
            ],
            [
                "Thou art the God that /do_est /won_ders,",
                "and hast de_clared thy pow_er a_/mong the /peo_ples.",
            ],
            [
                "Thou hast migh_ti_ly de_/li_vered thy /peo_ple,",
                "e_ven the sons of /Ja_cob and /Jo_seph.",
            ],
            [
                "The wa_ters saw thee, O God, the wa_ters /saw thee, and /were a_/fraid;",
                "the depths /al_so were /trou_bled.",
            ],
            [
                "The clouds poured out wa_ter, /the air /thun_dered,",
                "and thine /arr_ows /went a_/broad.",
            ],
            [
                "The voice of thy thun_der was /heard round a_/bout:",
                "the light_nings shone up_on the ground; the earth was /moved, and /shook with_/al.",
            ],
            [
                "Thy way is in the sea, and thy paths /in the great /wa_ters,",
                "and thy /foot_steps are /not /known.",
            ],
            [
                "Thou ledd_est thy /peo_ple like /sheep,",
                "by the hand of /Mo_ses and /Aa_ron.",
            ],
        ],
    },
    {
        id: "psalm78",
        lines: [
            [
                "HEAR my law, /O my /peo_ple;",
                "in_cline your ears un_to the /words of my /mouth.",
            ],
            [
                "I will o_pen my mouth /in a /pa_ra_ble;",
                "I will de_clare hard /sen_ten_ces /of old;",
            ],
            [
                "Which /we have /heard and /known,",
                "and such as our /fa_thers have /told us;",
            ],
            [
                "That we should not hide them from the child_ren of the gen_er_/a_tions to /come;",
                "but to show the ho_nour of the LORD, his migh_ty and won_der_ful /works that /he hath /done.",
            ],
            [
                "He made a co_ve_nant with Ja_cob, and gave /Is_ra_el a /law,",
                "which he com_man_ded our fore_fa_thers to /teach their /child_ren;",
            ],
            [
                "That their pos_te_ri_/ty might /know it,",
                "and the child_ren /which were /yet un_/born;",
            ],
            [
                "To the in_tent that /when they /came /up,",
                "they might show their /child_ren the /same;",
            ],
            [
                "That they might /put their /trust in /God;",
                "and not to for_get the works of God, but to /keep his com_/mand_ments;",
            ],
            [
                "And not to be as their fore_fa_thers, a faith_less and stub_born /ge_ne_/ra_tion;",
                "a ge_ne_ra_tion that set not their heart a_right, and whose spi_rit clave not /sted_fast_ly /un_to God;",
            ],
            [
                "Like as the /child_ren of /Eph_ra_im;",
                "who be_ing harn_essed, and car_ry_ing bows, turned them_selves back in the /day of /bat_tle.",
            ],
            [
                "They kept not the /co_ve_nant of /God,",
                "and would not /walk in his /law;",
            ],
            [
                "But for_/gat what /he had /done,",
                "and the won_der_ful works that /he had /showed for /them.",
            ],
            [
                "Mar_vell_ous things did he in the sight of our fore_fa_thers, in the /land of /E_gypt,",
                "e_ven in the /field of /Zo_an.",
            ],
            [
                "He di_vi_ded the sea, and /let them go /through;",
                "he made the wa_ters to /stand on /an /heap.",
            ],
            [
                "In the day-_time al_so he /led them /with a /cloud,",
                "and all the night /through with a /light of /fire.",
            ],
            [
                "He clave the hard /rocks in the /wil_der_ness,",
                "and gave them drink there_of, as it had been /out of the /great /depth.",
            ],
            [
                "He brought wa_ters /out of the /sto_ny /rock,",
                "so that it gushed /out like the /ri_vers.",
            ],
            [
                "Yet for all this they sinned /more a_/gainst him,",
                "and pro_voked the Most High_est /in the /wil_der_ness.",
            ],
            [
                "They tempt_ed /God /in their /hearts,",
                "and re_quired /meat for their /lust.",
            ],
            [
                "They spake a_gainst God /al_so, /say_ing,",
                "Shall God pre_pare a ta_ble /in the /wil_der_ness?",
            ],
            [
                "He smote the sto_ny rock in_deed, that the wa_ter gushed out, and the /streams /flowed with_al;",
                "but can he give bread al_so, or pro_vide /flesh for his /peo_ple?",
            ],
            [
                "When the LORD /heard this, /he was /wroth;",
                "so the fire was kin_dled in Ja_cob, and there came up hea_vy dis_plea_sure a_/gainst /Is_ra_el;",
            ],
            [
                "Be_cause they /be_lieved /not in God,",
                "and put not their /trust in his /help.",
            ],
            [
                "So he com_/man_ded the /clouds a_/bove,",
                "and o_pened the /doors of /hea_ven.",
            ],
            [
                "He rained down man_na al_so up_/on them /for to /eat,",
                "and gave them /food from /hea_ven.",
            ],
            [
                "So /man did eat /an_gels' food;",
                "for he /sent them /meat en_ough.",
            ],
            [
                "He caused the east-_wind to blow /un_der /hea_ven;",
                "and through his pow_er he brought /in the /south_west-_wind.",
            ],
            [
                "He rained flesh up_/on them as /thick as /dust,",
                "and feath_ered fowls like as the /sand of the /sea.",
            ],
            [
                "He let it /fall a_/mong their /tents,",
                "e_ven round a_bout their /ha_bi_/ta_tion.",
            ],
            [
                "So they did eat, and were well filled; for he /gave them their /own de_/sire:",
                "they were not dis_ap_/point_ed /of their /lust.",
            ],
            [
                "But while the meat was yet in their mouths, the hea_vy wrath of God came up_on them, and slew the /wealth_i_est of /them;",
                "yea, and smote down the cho_sen men that /were in /Is_ra_el.",
            ],
            [
                "But for all /this they /sinned yet /more,",
                "and be_lieved /not his /won_drous /works.",
            ],
            [
                "There_fore their days did he con_/sume in /va_ni_ty,",
                "and their /years in /trou_ble.",
            ],
            [
                "When he /slew them, they /sought him,",
                "and turned them ear_ly, and in_/quired /af_ter /God.",
            ],
            [
                "And they re_mem_bered that /God was their /strength,",
                "and that the High God was /their re_/dee_mer.",
            ],
            [
                "Ne_ver_the_less, they did but /flat_ter him /with their /mouth,",
                "and dis_sem_bled with /him /in their /tongue.",
            ],
            [
                "For their heart /was not /whole with him,",
                "nei_ther con_tin_ued they sted_fast /in his /co_ve_nant.",
            ],
            [
                "But he was so mer_ci_ful, that he for_/gave their /mis_deeds,",
                "and des_troyed /them not.",
            ],
            [
                "Yea, ma_ny a time turned /he his /wrath a_way,",
                "and would not suf_fer his whole dis_/plea_sure /to a_/rise.",
            ],
            [
                "For he con_sid_ered that /they /were but /flesh,",
                "and that they were e_ven a wind that pass_eth a_way, and /com_eth /not a_/gain.",
            ],
            [
                "Ma_ny a time did they pro_voke him /in the /wil_der_ness,",
                "and grieved him /in the /des_ert.",
            ],
            [
                "They turned /back, and /tempt_ed /God,",
                "and pro_voked the Ho_ly /One in /Is_ra_el.",
            ],
            [
                "They thought /not of /his /hand,",
                "and of the day when he de_li_vered them from the /hand of the /e_ne_my;",
            ],
            [
                "How he had wrought his mi_ra_/cles in /E_gypt,",
                "and his won_ders in the /field of /Zo_an.",
            ],
            [
                "He turned their /wa_ters /in_to /blood,",
                "so that they might not /drink of the /ri_vers.",
            ],
            [
                "He sent flies a_mong them, /and de_/voured them /up;",
                "and /frogs to des_/troy them.",
            ],
            [
                "He gave their fruit un_to the /ca_ter_/pil_lar,",
                "and their la_bour /un_to the /grass_hop_per.",
            ],
            [
                "He des_troyed their /vines with /hail_stones,",
                "and their mul_ber_ry_/-trees /with the /frost.",
            ],
            [
                "He smote their cat_tle /al_so with /hail_stones,",
                "and their flocks with /hot /thun_der_bolts.",
            ],
            [
                "He cast up_on them the fu_ri_ous_ness of his wrath, an_ger, dis_/plea_sure, and /trou_ble:",
                "and sent e_vil /an_gels a_/mong them.",
            ],
            [
                "He made a way to his in_dig_na_tion, and spared /not their /soul from /death;",
                "but gave their life o_ver /to the /pes_til_ence;",
            ],
            [
                "And smote all the /first_born in /E_gypt,",
                "the most prin_ci_pal and migh_ti_est in the /dwell_ings /of /Ham.",
            ],
            [
                "But as for his own peo_ple, he /led them /forth like /sheep,",
                "and car_ried them in the /wil_der_ness /like a /flock.",
            ],
            [
                "He brought them out safe_ly, /that they /should not /fear,",
                "and ov_er_whelmed their /e_ne_mies /with the /sea.",
            ],
            [
                "And brought them with_in the bor_ders of his /sanc_tu_/a_ry,",
                "e_ven to this moun_tain, which he purch_ased /with his /right hand.",
            ],
            [
                "He cast out the heath_en /al_so be_/fore them,",
                "caused their land to be di_vi_ded a_mong them for an he_ri_tage, and made the tribes of Is_ra_el to /dwell in their /tents.",
            ],
            [
                "Yet they tempt_ed and dis_/pleased the /Most High /God,",
                "and kept not his /tes_ti_/mon_ies.",
            ],
            [
                "They turned their backs, and fell a_way like their /fore_fa_thers;",
                "start_ing as_ide /like a /bro_ken /bow.",
            ],
            [
                "For they grieved him /with their /hill-_alt_ars,",
                "and pro_voked him to dis_plea_sure /with their /im_a_ges.",
            ],
            [
                "When God /heard this, /he was /wroth,",
                "and took sore dis_/plea_sure at /Is_ra_el;",
            ],
            [
                "So that he for_sook the tab_er_/na_cle in /Shi_loh,",
                "e_ven the tent that he had /pitched a_/mong men.",
            ],
            [
                "He de_li_vered their pow_er /in_to cap_/ti_vi_ty,",
                "and their beau_ty in_to the /e_/ne_my's /hand",
            ],
            [
                "He gave his peo_ple o_ver al_so /un_to the /sword,",
                "and was wroth with /his in_/he_ri_tance.",
            ],
            [
                "The fire con_/sumed their young /men,",
                "and their maid_ens were not /gi_ven in /mar_riage.",
            ],
            [
                "Their priests were /slain with the /sword,",
                "and there were no wid_ows to make /la_men_/ta_tion.",
            ],
            [
                "So the Lord a_waked as /one out of /sleep,",
                "and like a /gi_ant re_/freshed with /wine.",
            ],
            [
                "He drave his /e_ne_mies /back_ward,",
                "and put them to a per_/pe_/tu_al /shame.",
            ],
            [
                "He re_fused the tab_er_/na_cle of /Jo_seph,",
                "and chose not the /tribe of /Eph_ra_im;",
            ],
            [
                "But chose the /tribe of /Ju_dah,",
                "e_ven the hill of /Si_on /which he /loved.",
            ],
            [
                "And there he built his /tem_ple on /high,",
                "and laid the foun_da_tion of it like the ground which he hath made con_/ti_nu_/al_ly.",
            ],
            [
                "He chose Da_vid /al_so his /ser_vant,",
                "and took him a_/way from the /sheep-_folds:",
            ],
            [
                "As he was fol_low_ing the ewes with their /young he /took him,",
                "that he might feed Ja_cob his peo_ple, and Is_ra_el /his in_/he_ri_tance.",
            ],
            [
                "So he fed them with a /faith_ful and /true /heart,",
                "and ruled them pru_dent_ly with /all his /pow_er.",
            ],
        ],
    },
    {
        id: "psalm79",
        lines: [
            [
                "O GOD, the heath_en are come in_to /thine in_/he_ri_tance;",
                "thy ho_ly tem_ple have they de_filed, and made Je_ru_sa_/lem an /heap of /stones.",
            ],
            [
                "The dead bod_ies of thy ser_vants have they gi_ven to be meat un_to the /fowls of the /air,",
                "and the flesh of thy saints un_to the /beasts of the /land.",
            ],
            [
                "Their blood have they shed like wa_ter on eve_ry /side of Je_/ru_sa_/lem,",
                "and there was no /man to /bu_ry them.",
            ],
            [
                "We are be_come an o_pen /shame to our /e_ne_mies,",
                "a ve_ry scorn and de_ri_sion un_to them that are /round a_/bout us.",
            ],
            [
                "LORD, how long wilt /thou be /an_gry?",
                "shall thy jea_lou_sy burn like /fire for /ev_er?",
            ],
            [
                "Pour out thine in_dig_na_tion up_on the heath_en that /have not /known thee;",
                "and up_on the king_doms that have not /called up_/on thy /Name.",
            ],
            [
                "For they /have de_voured /Ja_cob,",
                "and laid /waste his /dwell_ing-_place.",
            ],
            [
                "O re_mem_ber not our old sins, but have mer_cy up_/on us, and /that /soon;",
                "for we are /come to great /mi_se_ry.",
            ],
            [
                "Help us, O God of our sal_va_tion, for the /glo_ry /of thy /Name:",
                "O de_li_ver us, and be mer_ci_ful un_to our sins, /for thy /Name's sake.",
            ],
            [
                "Where_fore /do the /heath_en /say,",
                "/Where is /now their /God?",
            ],
            [
                "O let the ven_geance of thy ser_vants' /blood that is /shed,",
                "be o_pen_ly showed up_on the /heath_en, /in our /sight.",
            ],
            [
                "O let the sor_row_ful sigh_ing of the pris_on_ers /come be_/fore thee;",
                "ac_cor_ding to the great_ness of thy pow_er, pre_serve thou those that are ap_/poin_ted to /die.",
            ],
            [
                "And for the blas_phe_my where_with our neigh_bours /have blas_/phemed thee,",
                "re_ward thou them, O Lord, sev_en_fold /in_to their /bo_som.",
            ],
            [
                "So we, that are thy peo_ple, and sheep of thy pas_ture, shall give thee /thanks for /ev_er,",
                "and will al_way be show_ing forth thy praise from ge_ne_ra_tion to /ge_ne_/ra_tion.",
            ],
        ],
    },
    {
        id: "psalm80",
        lines: [
            [
                "HEAR, O thou Shep_herd of Is_ra_el, thou that lead_est /Jo_seph /like a /flock;",
                "show thy_self al_so, thou that sitt_est up_/on the /Che_ru_bim.",
            ],
            [
                "Be_fore Eph_ra_im, Ben_ja_min, /and Ma_/na_sseh,",
                "stir up thy strength, and /come and /help us.",
            ],
            [
                "/Turn us a_/gain, O God;",
                "show the light of thy coun_te_nance, and /we /shall be /whole.",
            ],
            [
                "O /LORD /God of /hosts,",
                "how long wilt thou be an_gry with thy /peo_ple that /pray_eth?",
            ],
            [
                "Thou feed_est them /with the /bread of /tears,",
                "and giv_est them plen_teous_ness of /tears to /drink.",
            ],
            [
                "Thou hast made us a ve_ry strife /un_to our /neigh_bours,",
                "and our e_ne_mies /laugh /us to /scorn.",
            ],
            [
                "Turn us a_/gain, thou /God of /hosts;",
                "show the light of thy coun_te_nance, and /we /shall be /whole.",
            ],
            [
                "Thou hast brought a vine /out of /E_gypt;",
                "thou hast cast out the /heath_en, and /plan_ted it.",
            ],
            [
                "Thou /mad_est /room for it;",
                "and when it had tak_en /root, it /filled the /land.",
            ],
            [
                "The hills were co_vered with the /sha_dow of /it,",
                "and the boughs there_of were like the /good_ly /ce_dar-_trees.",
            ],
            [
                "She stretched out her branch_es /un_to the /sea,",
                "and her boughs /un_to the /Ri_ver.",
            ],
            [
                "Why hast thou then /bro_ken /down her hedge,",
                "that all they that go by /pluck /off her /grapes?",
            ],
            [
                "The wild boar out of the /wood doth /root it up,",
                "and the wild beasts of the /field de_/vour it.",
            ],
            [
                "Turn thee a_gain, thou God of hosts, look /down from /hea_ven,",
                "be_hold, and /vis_it /this /vine;",
            ],
            [
                "And the place of the vine_yard that thy right /hand hath /plan_ted,",
                "and the branch that thou mad_est so /strong for /thy_/self.",
            ],
            [
                "It is burnt with /fire, and cut /down;",
                "and they shall per_ish at the re_/buke of thy /coun_te_nance.",
            ],
            [
                "Let thy hand be up_on the /man of /thy right /hand,",
                "and up_on the son of man, whom thou mad_est so /strong for thine /own /self.",
            ],
            [
                "And so will not /we go /back from thee:",
                "O let us live, and we shall /call up_/on thy /Name.",
            ],
            [
                "Turn us a_gain, O /LORD /God of /hosts;",
                "show the light of thy coun_te_nance, and /we /shall be /whole.",
            ],
        ],
    },
    {
        id: "psalm81",
        lines: [
            [
                "SING we mer_ri_ly /un_to /God our /strength;",
                "make a cheer_ful noise un_to the /God of /Ja_cob.",
            ],
            [
                "Take the psalm, bring /hi_ther the /tab_ret,",
                "the mer_ry /harp with the /lute.",
            ],
            [
                "Blow up the trum_pet /in the /new /moon,",
                "e_ven in the time ap_poin_ted, and up_on our /sol_emn /feast-_day.",
            ],
            [
                "For this was made a /stat_ute for /Is_ra_el,",
                "and a law of the /God of /Ja_cob.",
            ],
            [
                "This he or_dained in Jo_seph for a /tes_ti_/mo_ny,",
                "when he came out of the land of E_gypt, and had /heard a strange /lang_uage.",
            ],
            [
                "I eased his shoul_der /from the /bur_den,",
                "and his hands were de_li_vered from /ma_king the /pots.",
            ],
            [
                "Thou call_edst up_on me in trou_bles, and /I de_/li_vered thee;",
                "and heard thee what time as the storm /fell up_/on thee.",
            ],
            ["I /proved thee /al_so", "at the /wa_ters of /strife."],
            [
                "Hear, O my peo_ple; and I will ass_ure /thee, O /Is_ra_el,",
                "if thou wilt /hear_ken /un_to /me,",
            ],
            [
                "There shall no strange /god be /in thee,",
                "nei_ther shalt thou wor_ship /an_y /oth_er /god.",
            ],
            [
                "I am the LORD thy God, who brought thee out of the /land of /E_gypt:",
                "o_pen thy mouth wide, and /I shall /fill it.",
            ],
            [
                "But my peo_ple /would not /hear my /voice;",
                "and Is_ra_el would /not o_/bey me;",
            ],
            [
                "So I gave them up /un_to their /own hearts' /lusts,",
                "and let them fol_low their own i_/ma_gi_/na_tions.",
            ],
            [
                "O that my peo_ple would have /heark_ened /un_to me!",
                "for if Is_ra_el had /walked in my /ways,",
            ],
            [
                "I should soon have put /down their /e_ne_mies,",
                "and turned my hand a_gainst their /ad_ver_/sa_ries.",
            ],
            [
                "The hat_ers of the LORD should have sub_mit_ted them_/selves un_to /him;",
                "but their time should have en_/dured for /ev_er.",
            ],
            [
                "I would have fed them al_so with the /fin_est /wheat_flour;",
                "and with hon_ey out of the sto_ny rock would I have /sa_tis_/fied thee.",
            ],
        ],
    },
    {
        id: "psalm82",
        lines: [
            [
                "GOD stand_eth in the con_gre_/ga_tion of /prin_ces;",
                "he is a /Judge a_/mong gods.",
            ],
            [
                "How long will ye /give wrong /judg_ment,",
                "and ac_cept the per_sons of /the un_/god_ly?",
            ],
            [
                "De_fend the /poor and /fa_ther_less;",
                "see that such as are in need and ne_/ces_si_ty /have right.",
            ],
            [
                "De_li_ver the /out_cast and /poor;",
                "save them from the hand of /the un_/god_ly.",
            ],
            [
                "They know not, nei_ther do they un_der_stand, but walk on /still in /dark_ness:",
                "all the found_a_tions of the /earth are /out of /course.",
            ],
            [
                "I have /said, /Ye are /gods,",
                "and ye are all the child_ren of /the Most /High_est.",
            ],
            [
                "But /ye shall /die like /men,",
                "and fall like /one of the /prin_ces.",
            ],
            [
                "A_rise, O God, and /judge /thou the /earth;",
                "for thou shalt take all na_tions to /thine in_/he_ri_tance.",
            ],
        ],
    },
    {
        id: "psalm83",
        lines: [
            [
                "HOLD not thy tongue, O God, keep /not still /si_lence:",
                "re_frain /not thy_/self, O /God.",
            ],
            [
                "For lo, thine e_ne_mies /make a /mur_mur_ing;",
                "and they that hate thee have /lift up their /head.",
            ],
            [
                "They have i_ma_gined craf_ti_ly a_/gainst thy /peo_ple,",
                "and tak_en coun_sel a_/gainst thy /sec_ret /ones.",
            ],
            [
                "They have said, Come, and let us root them out, that they be no /more a /peo_ple,",
                "and that the name of Is_ra_el may be no /more in re_/mem_brance.",
            ],
            [
                "For they have cast their heads to_/ge_ther with /one con_/sent,",
                "and are con_fed_er_/ate a_/gainst thee:",
            ],
            [
                "The ta_ber_na_cles of the E_dom_ites, and the /Ish_ma_/el_ites;",
                "the Mo_a_/bites, and /Ha_ga_renes;",
            ],
            [
                "Ge_bal, and /Am_mon, and /A_ma_lek;",
                "the Phi_li_stines, with /them that /dwell at /Tyre.",
            ],
            [
                "As_sy_ria /al_so is /joined with /them;",
                "they have hol_pen the /child_ren of /Lot.",
            ],
            [
                "But do thou to them as un_to the /Mi_di_/an_ites;",
                "un_to Si_se_ra, and un_to Ja_bin at the /brook of /Ki_shon;",
            ],
            [
                "Who /per_ished at /En_dor,",
                "and be_came as the /dung of the /earth.",
            ],
            [
                "Make them and their prin_ces like /Or_eb and /Ze_eb;",
                "yea, make all their prin_ces like as Ze_bah /and Zal_/mun_na;",
            ],
            [
                "Who say, Let us /take to our_/selves",
                "the hou_ses of God /in pos_/sess_ion.",
            ],
            [
                "O my God, make them like /un_to the /whirl_ing /dust,",
                "and as the /stub_ble be_/fore the /wind;",
            ],
            [
                "Like as the fire that burn_eth /up the /for_est,",
                "and as the flame that con_/sum_eth the /moun_tains;",
            ],
            [
                "Pur_sue them e_ven so /with thy /tem_pest,",
                "and make them a_/fraid with thy /storm.",
            ],
            [
                "Make their /fa_ces a_/shamed, O /LORD,",
                "that /they may /seek thy /Name.",
            ],
            [
                "Let them be con_foun_ded and vexed /ev_er /more and /more;",
                "let them be put to /shame, and /per_ish.",
            ],
            [
                "And they shall know that thou, whose /Name is JE_/HO_VAH,",
                "art on_ly the Most High_est /o_ver /all the /earth.",
            ],
        ],
    },
    {
        id: "psalm84",
        lines: [
            ["O HOW a_mi_able /are thy /dwell_ings,", "thou LORD of /hosts!"],
            [
                "My soul hath a de_sire and long_ing to en_ter in_to the /courts of the /LORD;",
                "my heart and my flesh re_/joice in the /li_ving /God.",
            ],
            [
                "Yea, the spar_row hath found her an house, and the swal_low a nest, /where she may /lay her /young;",
                "e_ven thy alt_ars, O LORD of hosts, my /King and my /God.",
            ],
            [
                "Bless_ed are they that /dwell in thy /house;",
                "they will be /al_way /prais_ing /thee.",
            ],
            [
                "Bless_ed is the man whose /strength is /in /thee;",
                "in whose /heart are thy /ways.",
            ],
            [
                "Who go_ing through the vale of mi_se_ry /use it /for a /well;",
                "and the pools are /filled with /wa_ter.",
            ],
            [
                "They will /go from /strength to /strength,",
                "and un_to the God of gods ap_pear_eth eve_ry one of /them in /Si_on.",
            ],
            [
                "O LORD God of /hosts, /hear my /prayer;",
                "hear_ken, O /God of /Ja_cob.",
            ],
            [
                "Be_hold, O God /our de_/fen_der,",
                "and look up_on the face of /thine a_/noin_ted.",
            ],
            ["For one /day /in thy /courts", "is bet_ter /than a /thou_sand."],
            [
                "I had ra_ther be a door-_kee_per in the /house of my /God,",
                "than to dwell in the /tents of un_/god_li_ness.",
            ],
            [
                "For the LORD God is a /light and de_/fence;",
                "the LORD will give grace and wor_ship; and no good thing shall he with_hold from them that /live a /god_ly life.",
            ],
            [
                "O /LORD /God of /hosts,",
                "bless_ed is the man that /putt_eth his /trust in /thee.",
            ],
        ],
    },
    {
        id: "psalm85",
        lines: [
            [
                "LORD, thou art be_come gra_cious /un_to thy /land;",
                "thou hast turned a_way the cap_/ti_vi_ty of /Ja_cob.",
            ],
            [
                "Thou hast for_gi_ven the of_/fence of thy /peo_ple,",
                "and /co_vered /all their /sins.",
            ],
            [
                "Thou hast tak_en a_way all /thy dis_/plea_sure,",
                "and turned thy_self from thy wrath_ful /in_dig_/na_tion.",
            ],
            [
                "Turn us then, O /God our /Sav_iour,",
                "and let thine /an_ger /cease from us.",
            ],
            [
                "Wilt thou be dis_pleased at /us for /ev_er?",
                "and wilt thou stretch out thy wrath from one ge_ne_ra_tion /to a_/no_ther?",
            ],
            [
                "Wilt thou not turn a_/gain, and /quick_en us,",
                "that thy peo_ple /may re_/joice in /thee?",
            ],
            [
                "Show us thy /mer_cy, O /LORD,",
                "and grant us /thy sal_/va_tion.",
            ],
            [
                "I will hear_ken what the /LORD /God will /say;",
                "for he shall speak peace un_to his peo_ple, and to his saints, that they turn not a_gain /un_to /fool_ish_ness.",
            ],
            [
                "For his sal_va_tion is nigh /them that /fear him;",
                "that glo_ry may /dwell /in our /land.",
            ],
            [
                "Mer_cy and truth are /met to_/ge_ther:",
                "right_eous_ness and peace have /kissed each /oth_er.",
            ],
            [
                "Truth shall flou_rish /out of the /earth,",
                "and right_eous_ness hath looked /down from /hea_ven.",
            ],
            [
                "Yea, the LORD shall show /lov_ing-_/kind_ness;",
                "and our land shall /give her /in_crease.",
            ],
            [
                "Right_eous_ness shall /go be_/fore him,",
                "and shall di_rect his /go_ing /in the /way.",
            ],
        ],
    },
    {
        id: "psalm86",
        lines: [
            [
                "BOW down thine ear, O /LORD, and /hear me;",
                "for I am /poor, and in /mi_se_ry.",
            ],
            [
                "Pre_serve thou my soul, for /I am /ho_ly:",
                "my God, save thy ser_vant that /putt_eth his /trust in /thee.",
            ],
            [
                "Be mer_ci_ful /un_to /me, O /Lord;",
                "for I will call /dai_ly up_/on thee.",
            ],
            [
                "Com_fort the /soul of thy /ser_vant;",
                "for un_to thee, O Lord, do I /lift /up my /soul.",
            ],
            [
                "For thou, Lord, art /good and /gra_cious,",
                "and of great mer_cy un_to all them that /call up_/on thee.",
            ],
            [
                "Give ear, LORD, /un_to my /prayer,",
                "and pon_der the voice of my /hum_ble de_/sires.",
            ],
            [
                "In the time of my trou_ble I will /call up_/on thee;",
                "/for thou /hear_est /me.",
            ],
            [
                "A_mong the gods there is none like /un_to /thee, O /Lord;",
                "there is not one that can /do as /thou do_est.",
            ],
            [
                "All na_tions whom thou hast made shall come and /wor_ship /thee, O /Lord;",
                "and shall /glo_ri_/fy thy Name.",
            ],
            [
                "For thou art great, and /do_est /won_drous /things:",
                "/thou art /God a_/lone.",
            ],
            [
                "Teach me thy way, O LORD, and I will /walk in thy /truth:",
                "O knit my heart un_to thee, that /I may /fear thy /Name.",
            ],
            [
                "I will thank thee, O Lord my /God, with /all my /heart;",
                "and will praise thy /Name for /ev_er_/more.",
            ],
            [
                "For great is thy /mer_cy to_/ward me;",
                "and thou hast de_li_vered my soul from the /neth_er_/most hell.",
            ],
            [
                "O God, the proud are /ri_sen a_/gainst me;",
                "and the con_gre_ga_tions of vio_lent men have sought af_ter my soul, and have not set /thee be_/fore their /eyes.",
            ],
            [
                "But thou, O Lord God, art full of com_/pass_ion and /mer_cy,",
                "long-_suf_fer_ing, plen_te_ous in /good_ness and /truth.",
            ],
            [
                "O turn thee then un_to me, and have /mer_cy up_/on me;",
                "give thy strength un_to thy ser_vant, and help the /son of thine /hand_maid.",
            ],
            [
                "Show some to_ken up_on me for good; that they who hate me may see /it, and /be a_/shamed,",
                "be_cause thou, LORD, hast hol_pen me, and /com_for_ted /me.",
            ],
        ],
    },
    {
        id: "psalm87",
        lines: [
            [
                "HER found_a_tions are up_/on the /ho_ly /hills:",
                "the LORD lov_eth the gates of Si_on more than all the /dwell_ings of /Ja_cob.",
            ],
            [
                "Ve_ry ex_cell_ent things are /spo_ken of /thee,",
                "thou /ci_ty of /God.",
            ],
            [
                "I will make men_tion of /E_gypt and /Ba_by_lon,",
                "a_mong /them that /know me.",
            ],
            [
                "Be_hold, Phil_is_ti_a al_so; and Tyre, with /E_thi_/o_pi_a;",
                "lo, in /Si_on /were they /born.",
            ],
            [
                "Yea, of Si_on it shall be re_por_ted, this one and /that one were /born in /her;",
                "and the Most /High shall /stab_lish her.",
            ],
            [
                "The LORD shall re_cord it, when he writ_eth /up the /peo_ples;",
                "lo, in /Si_on /were they /born.",
            ],
            [
                "The sing_ers al_so and trump_et_ers /shall make /an_swer:",
                "All my fresh /springs are /in thee.",
            ],
        ],
    },
    {
        id: "psalm88",
        lines: [
            [
                "O LORD God of my sal_va_tion, I have cried day and /night be_/fore thee:",
                "O let my prayer en_ter in_to thy pres_ence, in_cline thine ear /un_to my /call_ing;",
            ],
            [
                "For my soul is /full of /trou_ble,",
                "and my life draw_eth nigh /un_to the /grave.",
            ],
            [
                "I am coun_ted as one of them that go down /in_/to the /pit,",
                "and I am e_ven as a /man that /hath no /strength;",
            ],
            [
                "Cast off a_mong the dead, like un_to them that are slain, and /lie in the /grave,",
                "who are out of re_mem_brance, and are cut a_/way from thy /hand.",
            ],
            [
                "Thou hast laid me /in the /low_est pit,",
                "in a place of /dark_ness, and /in the /deep.",
            ],
            [
                "Thine in_dig_na_tion li_eth /hard up_/on me,",
                "and thou hast /vexed me with /all thy /storms.",
            ],
            [
                "Thou hast put a_way mine ac_/quain_tance /far from me,",
                "and made me to /be ab_/horred of /them.",
            ],
            ["I am so /fast in /pri_son", "/that I can_/not get /forth."],
            [
                "My sight fail_eth for /ve_ry /trou_ble;",
                "LORD, I have called dai_ly up_on thee, I have stretched forth my /hands /un_to /thee.",
            ],
            [
                "Dost thou show /won_ders a_/mong the /dead?",
                "or shall the dead rise up a_/gain, and /praise thee?",
            ],
            [
                "Shall thy lov_ing-_kind_ness be /showed in the /grave?",
                "or thy faith_ful_ness /in des_/truc_tion?",
            ],
            [
                "Shall thy won_drous works be /known in the /dark?",
                "and thy right_eous_ness in the land where all /things are for_/got_ten?",
            ],
            [
                "Un_to /thee have I /cried, O /LORD;",
                "and ear_ly shall my /prayer come be_/fore thee.",
            ],
            [
                "LORD, why ab_/horr_est /thou my /soul,",
                "and hid_est /thou thy /face from me?",
            ],
            [
                "I am in mi_se_ry, and like un_to him that is /at the /point to /die;",
                "e_ven from my youth up, thy terr_ors have I suff_ered with a /trou_bled /mind.",
            ],
            [
                "Thy wrath_ful dis_plea_sure /go_eth /o_ver me,",
                "and the fear of /thee hath un_/done me.",
            ],
            [
                "They came round a_bout me /dai_ly like /wa_ter,",
                "and com_passed me to_/ge_ther on /eve_ry /side.",
            ],
            [
                "My lov_ers and friends hast thou /put a_/way from me,",
                "and hid mine ac_quain_tance /out of my /sight.",
            ],
        ],
    },
    {
        id: "psalm89",
        lines: [
            [
                "MY song shall be al_way of the lov_ing-_/kind_ness /of the /LORD;",
                "with my mouth will I ev_er be show_ing thy truth from one ge_ne_ra_tion /to a_/no_ther.",
            ],
            [
                "For I have said, Mer_cy shall be set /up for /ev_er;",
                "thy truth shalt thou stab_lish /in the /hea_vens.",
            ],
            [
                "I have made a co_ve_nant /with my /cho_sen;",
                "I have sworn un_to /Da_vid my /ser_vant:",
            ],
            [
                "Thy seed will I /stab_lish for /ev_er,",
                "and set up thy throne from one ge_ne_ra_tion /to a_/no_ther.",
            ],
            [
                "O LORD, the ve_ry hea_vens shall /praise thy /won_drous /works;",
                "and thy truth in the con_gre_/ga_tion /of the /saints.",
            ],
            [
                "For who is /he a_/mong the /clouds,",
                "that shall be comp_ared /un_to the /LORD?",
            ],
            [
                "And what is /he a_/mong the /gods,",
                "that shall be like /un_to the /LORD?",
            ],
            [
                "God is ve_ry great_ly to be feared in the /coun_cil /of the /saints,",
                "and to be had in rev_erence of all them that are /round a_/bout him.",
            ],
            [
                "O Lord God of hosts, who is /like /un_to /thee?",
                "thy truth, most migh_ty /LORD, is on /eve_ry /side.",
            ],
            [
                "Thou rul_est the /rag_ing /of the /sea;",
                "thou still_est the waves there_/of when /they a_/rise.",
            ],
            [
                "Thou hast sub_dued E_gypt, /and des_/troyed it;",
                "thou hast scat_tered thine e_ne_mies a_broad /with thy /migh_ty /arm.",
            ],
            [
                "The hea_vens are thine, the earth /al_so is /thine;",
                "thou hast laid the foun_da_tion of the round world, and /all that /there_in /is.",
            ],
            [
                "Thou hast made the /north and the /south;",
                "Ta_bor and Her_mon shall re_/joice in /thy /Name.",
            ],
            [
                "Thou /hast a /migh_ty /arm;",
                "strong is thy hand, and /high is thy /right hand.",
            ],
            [
                "Right_eous_ness and eq_ui_ty are the ha_bi_/ta_tion /of thy /seat;",
                "mer_cy and truth shall /go be_/fore thy /face.",
            ],
            [
                "Bless_ed is the peo_ple, O LORD, that /can re_/joice in /thee;",
                "they shall walk in the /light of thy /coun_te_nance.",
            ],
            [
                "Their de_light shall be /dai_ly /in thy /Name;",
                "and in thy right_eous_ness /shall they /make their /boast.",
            ],
            [
                "For thou art the /glo_ry /of their /strength,",
                "and in thy lov_ing-_kind_ness thou shalt /lift /up our /horns.",
            ],
            [
                "For the /LORD is /our de_/fence;",
                "the Ho_ly One of /Is_ra_el /is our /King.",
            ],
            [
                "Thou spak_est some_time in vis_ions /un_to thy /saints, and /saidst,",
                "I have laid help up_on one that is migh_ty, I have ex_al_ted one cho_sen /out of the /peo_ple.",
            ],
            [
                "I have found /Da_vid my /ser_vant;",
                "with my ho_ly oil have /I a_/noin_ted /him.",
            ],
            [
                "My /hand shall /hold him /fast,",
                "and my /arm shall /strength_en him.",
            ],
            [
                "The e_ne_my shall not be a_ble to /do him /vio_lence;",
                "the son of wick_ed_ness /shall not /hurt him.",
            ],
            [
                "I will smite down his /foes be_/fore his /face,",
                "and plague /them that /hate him.",
            ],
            [
                "My truth al_so and my mer_cy /shall be /with him;",
                "and in my Name shall his horn /be ex_/al_ted.",
            ],
            [
                "I will set his do_min_ion /al_so /in the /sea,",
                "and his right /hand /in the /floods.",
            ],
            [
                "He shall call me, /Thou art my /Fa_ther,",
                "my God, and my /strong sal_/va_tion.",
            ],
            [
                "And I will /make him my /first_born,",
                "high_er than the /kings of the /earth.",
            ],
            [
                "My mer_cy will I keep for /him for /ev_er_/more,",
                "and my co_ve_nant /shall stand /fast with him.",
            ],
            [
                "His seed al_so will I make to en_/dure for /ev_er,",
                "and his throne as the /days of /hea_ven.",
            ],
            [
                "But if his /child_ren for_/sake my /law,",
                "and walk /not in my /judg_ments;",
            ],
            [
                "If they break my stat_utes, and keep /not my com_/mand_ments;",
                "I will vis_it their off_en_ces with the rod, and their /sin with /scour_ges.",
            ],
            [
                "Ne_ver_the_less, my lov_ing-_kind_ness will I not /utt_er_ly /take from him,",
                "nor suf_fer my /truth to /fail.",
            ],
            [
                "My co_ve_nant will I not break, nor al_ter the thing that is gone /out of my /lips:",
                "I have sworn once by my ho_li_ness, that I /will not fail /Da_vid.",
            ],
            [
                "His seed shall en_/dure for /ev_er,",
                "and his throne is like as the /sun be_/fore me.",
            ],
            [
                "He shall stand fast for ev_er_/more as the /moon,",
                "and as the faith_ful /wit_ness in /hea_ven.",
            ],
            [
                "But thou hast ab_horred and for_sa_ken /thine a_/noin_ted,",
                "and /art dis_/pleased at /him.",
            ],
            [
                "Thou hast bro_ken the co_ve_nant /of thy /ser_vant,",
                "and cast his /crown to the /ground.",
            ],
            [
                "Thou hast ov_er_thrown /all his /hed_ges,",
                "and bro_ken /down his /strong_holds.",
            ],
            [
                "All they that /go by /spoil him,",
                "and he is be_come a rep_/roach to his /neigh_bours.",
            ],
            [
                "Thou hast set up the right /hand of his /e_ne_mies,",
                "and made all his ad_ver_/sa_ries /to re_/joice.",
            ],
            [
                "Thou hast tak_en a_way the /edge of his /sword,",
                "and giv_est him not vic_to_ry /in the /bat_tle.",
            ],
            [
                "Thou hast put /out his /glo_ry,",
                "and cast his throne /down to the /ground.",
            ],
            [
                "The days of his youth /hast thou /short_ened,",
                "and co_vered him /with dis_/hon_our.",
            ],
            [
                "LORD, how long wilt thou hide thy_/self? for /ev_er?",
                "and shall thy /wrath /burn like /fire?",
            ],
            [
                "O re_mem_ber how /short my /time is;",
                "where_fore hast thou /made all /men for /nought?",
            ],
            [
                "What man is he that liv_eth, and /shall /not see /death?",
                "and shall he de_li_ver his soul from the /pow_er of /the /grave?",
            ],
            [
                "Lord, where are thy old /lov_ing-_/kind_ness_es,",
                "which thou swar_est un_to /Da_vid /in thy /truth?",
            ],
            [
                "Re_mem_ber, Lord, the re_/buke that thy /ser_vants have,",
                "and how I do bear in my bo_som the re_bukes of /ma_ny /peo_ple;",
            ],
            [
                "Where_with thine e_ne_mies /have blas_/phemed thee,",
                "and slan_dered the foot_steps of /thine a_/noin_ted.",
            ],
            ["Praised be the /LORD for /ev_er_more.", "A_men, and /A_men."],
        ],
    },
    {
        id: "psalm90",
        lines: [
            [
                "LORD, thou hast /been our /re_fuge,",
                "from one ge_ne_ra_tion /to a_/no_ther.",
            ],
            [
                "Be_fore the moun_tains were brought forth, or ev_er the earth /and the /world were made,",
                "thou art God from ev_er_last_ing, and /world with_/out /end.",
            ],
            [
                "Thou turn_est /man to des_/truc_tion;",
                "a_gain thou say_est, Come a_gain, ye /child_ren of /men.",
            ],
            [
                "For a thou_sand years in thy sight are but as yes_ter_day /when /it is /past,",
                "and as a /watch in the /night.",
            ],
            [
                "As soon as thou scat_ter_est them they are /e_ven /as a sleep;",
                "and fade a_way /sud_den_ly /like the /grass.",
            ],
            [
                "In the mor_ning it is /green, and /grow_eth /up;",
                "but in the eve_ning it is cut down, dried /up, and /with_ered.",
            ],
            [
                "For we con_sume a_way in /thy dis_/plea_sure,",
                "and are a_fraid at thy wrath_ful /in_dig_/na_tion.",
            ],
            [
                "Thou hast set our mis_/deeds be_/fore thee;",
                "and our sec_ret sins in the /light of thy /coun_te_nance.",
            ],
            [
                "For when thou art an_gry /all our /days are /gone:",
                "we bring our years to an end, as it were a /tale that is /told.",
            ],
            [
                "The days of our age are three_score years and ten; and though men be so strong that they /come to /four_score /years,",
                "yet is their strength then but la_bour and sor_row; so soon pass_eth it a_/way, and /we are /gone.",
            ],
            [
                "But who re_gard_eth the /pow_er /of thy /wrath?",
                "or fear_eth a_right thy /in_dig_/na_tion?",
            ],
            [
                "So teach us to /num_ber our /days,",
                "that we may ap_ply our hearts /un_to /wis_dom.",
            ],
            [
                "Turn thee a_gain, O /LORD, /at the /last,",
                "and be gra_cious /un_to thy /ser_vants.",
            ],
            [
                "O sat_is_fy us with thy /mer_cy, /and that /soon:",
                "so shall we re_joice and be glad all the /days of our /life.",
            ],
            [
                "Com_fort us a_gain now af_ter the time that /thou hast /plagued us;",
                "and for the years where_in we have /suff_ered ad_/ver_si_ty.",
            ],
            [
                "Show thy /ser_vants /thy work,",
                "and their /child_ren thy /glo_ry.",
            ],
            [
                "And the glo_rious ma_jes_ty of the LORD our /God be up_/on us:",
                "pros_per thou the work of our hands up_on us; O pros_per /thou our /han_dy-_work.",
            ],
        ],
    },
    {
        id: "psalm91",
        lines: [
            [
                "WHO_SO dwell_eth un_der the de_/fence of the Most /High,",
                "shall a_bide un_der the sha_dow /of the Al_/migh_ty.",
            ],
            [
                "I will say un_to the LORD, Thou art my /hope, and my /strong_hold;",
                "my God, in /him will /I trust.",
            ],
            [
                "For he shall de_li_ver thee from the /snare of the /hun_ter,",
                "and from the /noi_some /pes_til_ence.",
            ],
            [
                "He shall de_fend thee un_der his wings, and thou shalt be safe /un_der his /feath_ers;",
                "his faith_ful_ness and truth shall be thy /shield and /buck_ler.",
            ],
            [
                "Thou shalt not be a_fraid for an_y /terr_or by /night,",
                "nor for the ar_row that /fli_eth /by /day;",
            ],
            [
                "For the pes_til_ence that /walk_eth in /dark_ness,",
                "nor for the sick_ness that des_troy_eth /in the /noon-_day.",
            ],
            [
                "A thou_sand shall fall be_side thee, and ten thou_sand /at thy right /hand;",
                "but it shall /not come /nigh thee.",
            ],
            [
                "Yea, with thine /eyes shalt /thou be_/hold,",
                "and see the re_ward of /the un_/god_ly.",
            ],
            [
                "For /thou, LORD, /art my /hope;",
                "thou hast set thine house of de_/fence /ve_ry /high.",
            ],
            [
                "There shall no e_vil /hap_pen /un_to /thee,",
                "nei_ther shall an_y plague come /nigh thy /dwell_ing.",
            ],
            [
                "For he shall give his an_gels /charge /o_ver thee,",
                "to /keep thee in /all thy /ways.",
            ],
            [
                "They shall /bear thee /in their /hands,",
                "that thou hurt not thy /foot a_/gainst a /stone.",
            ],
            [
                "Thou shalt go up_on the /li_on and /add_er:",
                "the young li_on and the dra_gon shalt thou tread /un_der /thy /feet.",
            ],
            [
                "Be_cause he hath set his love up_on me, there_fore will /I de_/li_ver him;",
                "I will set him up, be_/cause he hath /known my /Name.",
            ],
            [
                "He shall call up_on me, and /I will /hear him;",
                "yea, I am with him in trou_ble; I will de_li_ver him, and /bring him to /ho_nour.",
            ],
            [
                "With long life will I /sat_is_fy /him,",
                "and show him /my sal_/va_tion.",
            ],
        ],
    },
    {
        id: "psalm92",
        lines: [
            [
                "IT is a good thing to give thanks /un_to the /LORD,",
                "and to sing prais_es un_to thy Name, /O Most /High_est;",
            ],
            [
                "To tell of thy lov_ing-_kind_ness ear_ly /in the /mor_ning,",
                "and of thy /truth in the /night /sea_son;",
            ],
            [
                "Up_on an in_stru_ment of ten /strings, and up_/on the /lute;",
                "up_on a loud in_stru_ment, /and up_/on the /harp.",
            ],
            [
                "For thou, LORD, hast made me /glad through thy /works;",
                "and I will re_joice in gi_ving praise for the op_er_/a_tions of /thy /hands.",
            ],
            [
                "O LORD, how /glo_rious /are thy /works!",
                "thy /thoughts are /ve_ry /deep.",
            ],
            [
                "An un_wise man doth not /well con_/si_der this,",
                "and a fool doth not /un_der_/stand it.",
            ],
            [
                "When the un_god_ly are green as the grass, and when all the wor_kers of /wick_ed_ness do /flou_rish,",
                "then shall they be des_troyed for ev_er; but thou, LORD, art the Most /High_est for /ev_er_/more.",
            ],
            [
                "For lo, thine e_ne_mies, O LORD, lo, thine /e_ne_mies shall /per_ish;",
                "and all the wor_kers of wick_ed_ness /shall /be des_/troyed.",
            ],
            [
                "But my horn shall be ex_al_ted like the /horn of an /u_ni_corn;",
                "for I am a_/noin_ted with /fresh oil.",
            ],
            [
                "Mine eye al_so shall see his /lust of mine /e_ne_mies,",
                "and mine ear shall hear his de_sire of the wick_ed that a_rise /up a_/gainst me.",
            ],
            [
                "The right_eous shall flou_rish /like a /palm-_tree,",
                "and shall spread a_broad like a /ce_dar in /Le_ba_non.",
            ],
            [
                "Such as are plan_ted in the /house of the /LORD,",
                "shall flou_rish in the courts of the /house of our /God.",
            ],
            [
                "They al_so shall bring forth more /fruit in their /age,",
                "and shall be /fat and well-_/li_king;",
            ],
            [
                "That they may show how true the /LORD my /strength is,",
                "and that there is no un_/right_eous_ness /in him.",
            ],
        ],
    },
    {
        id: "psalm93",
        lines: [
            [
                "THE LORD is King, and hath put on /glo_rious ap_/pa_rel;",
                "the LORD hath put on his ap_pa_rel, and /gir_ded him_/self with /strength.",
            ],
            [
                "He hath /made the round /world so /sure,",
                "that it /can_/not be /moved.",
            ],
            [
                "Ev_er since the world be_gan, hath thy /seat /been pre_/pared:",
                "thou art from /ev_er_/last_ing.",
            ],
            [
                "The floods are ri_sen, O LORD, the floods have /lift /up their /voice;",
                "the floods /lift /up their /waves.",
            ],
            [
                "The waves of the sea are migh_ty, and rage /hor_ri_bly;",
                "but yet the LORD, who dwell_eth on /high, is /migh_ti_er.",
            ],
            [
                "Thy tes_ti_mon_ies, O /LORD, are /ve_ry /sure:",
                "ho_li_ness be_com_eth thine /house for /ev_er.",
            ],
        ],
    },
    {
        id: "psalm94",
        lines: [
            [
                "O LORD God, to whom /ven_geance be_/long_eth,",
                "thou God, to whom ven_geance be_/long_eth, /show thy_self.",
            ],
            [
                "A_rise, thou /Judge of the /world,",
                "and re_ward the proud af_ter /their de_/serv_ing.",
            ],
            [
                "LORD, how long /shall the un_/god_ly,",
                "how long shall the un_/god_ly /tri_umph?",
            ],
            [
                "How long shall all wick_ed do_ers /speak so dis_/dain_ful_ly,",
                "and /make such proud /boast_ing?",
            ],
            [
                "They smite down thy /peo_ple, O /LORD,",
                "and /trou_ble thine /he_ri_tage.",
            ],
            [
                "They mur_der the wid_ow /and the /stran_ger,",
                "and put the /fa_ther_/less to /death.",
            ],
            [
                "And yet they say, Tush, the /LORD /shall not see,",
                "nei_ther shall the God of /Ja_cob re_/gard it.",
            ],
            [
                "Take heed, ye un_wise a_/mong the /peo_ple:",
                "O ye fools, when /will ye /un_der_/stand?",
            ],
            [
                "He that plan_ted the ear, /shall /he not /hear?",
                "or he that made the eye, /shall /he not /see?",
            ],
            [
                "Or he that in_/struct_eth the /heath_en,",
                "it is he that teach_eth man know_ledge; shall /not he /pu_nish?",
            ],
            [
                "The LORD /know_eth the /thoughts of man,",
                "that /they are /but vain.",
            ],
            [
                "Bless_ed is the man whom thou /chast_en_/est, O /LORD,",
                "and /teach_est him /in thy law;",
            ],
            [
                "That thou may_est give him pa_tience in /time of ad_/ver_si_ty,",
                "un_til the pit be digged up for /the un_/god_ly.",
            ],
            [
                "For the LORD will not /fail his /peo_ple;",
                "nei_ther will he for_/sake his in_/he_ri_tance;",
            ],
            [
                "Un_til right_eous_ness turn a_gain /un_to /judg_ment:",
                "all such as are true in /heart shall /fol_low it.",
            ],
            [
                "Who will rise up with me a_/gainst the /wick_ed?",
                "or who will take my part a_gainst the /e_vil /do_ers?",
            ],
            [
                "If the LORD /had not /helped me,",
                "it had not failed, but my soul had been /put to /si_lence.",
            ],
            [
                "But when I /said, My /foot hath /slipt;",
                "thy mer_cy, O /LORD, /held me /up.",
            ],
            [
                "In the mul_ti_tude of the sor_rows that I /had in my /heart,",
                "thy com_forts /have re_/freshed my /soul.",
            ],
            [
                "Wilt thou have an_y thing to do with the /throne of /wick_ed_ness,",
                "which i_ma_gin_eth /mis_chief /as a law?",
            ],
            [
                "They gath_er them to_ge_ther a_gainst the /soul of the /right_eous,",
                "and con_demn the /in_no_/cent /blood.",
            ],
            [
                "But the /LORD is my /re_fuge,",
                "and my God is the /strength of my /con_fi_dence.",
            ],
            [
                "He shall re_com_pense them their wick_ed_ness, and des_troy them in /their own /ma_lice;",
                "yea, the LORD our God /shall des_/troy them.",
            ],
        ],
    },
    {
        id: "psalm95",
        lines: [
            [
                "O COME, let us sing /un_to the /LORD;",
                "let us hear_ti_ly re_joice in the strength of /our sal_/va_tion.",
            ],
            [
                "Let us come be_fore his pres_ence /with thanks_/giv_ing;",
                "and show our_selves /glad in /him with /Psalms.",
            ],
            [
                "For the /LORD is a /great God;",
                "and a great /King a_/bove all /gods.",
            ],
            [
                "In his hand are all the /cor_ners /of the /earth;",
                "and the strength of the /hills is his /al_so.",
            ],
            [
                "The sea is /his, and he /made it;",
                "and his hands pre_/pared the /dry land.",
            ],
            [
                "O come, let us /wor_ship and /fall /down,",
                "and kneel be_fore the /LORD our /Ma_ker.",
            ],
            [
                "For he /is the /Lord our /God;",
                "and we are the peo_ple of his pas_ture, and the /sheep of his /hand.",
            ],
            [
                "To-_day if ye will hear his voice, /har_den /not your /hearts",
                "as in the pro_vo_ca_tion, and as in the day of temp_ta_tion /in the /wil_der_ness;",
            ],
            [
                "When your /fa_thers /tempt_ed me,",
                "/proved me, and /saw my /works.",
            ],
            [
                "For_ty years long was I grieved with this ge_ne_/ra_tion, and /said,",
                "It is a peo_ple that do err in their hearts, for they /have not /known my /ways:",
            ],
            [
                "Un_to whom I /sware in my /wrath,",
                "that they should not en_ter /in_to my /rest.",
            ],
        ],
    },
    {
        id: "psalm96",
        lines: [
            [
                "O SING un_to the /LORD a new /song;",
                "sing un_to the LORD, /all the /whole /earth.",
            ],
            [
                "Sing un_to the /LORD, and /praise his /Name;",
                "be tell_ing of his sal_va_tion /from /day to /day.",
            ],
            [
                "De_clare his ho_nour un_/to the /heath_en,",
                "and his won_ders un_/to all /peo_ples.",
            ],
            [
                "For the LORD is great, and can_not /wor_thi_ly be /praised;",
                "he is more to be /feared than all /gods.",
            ],
            [
                "As for all the gods of the heath_en, /they are but /i_dols;",
                "but it is the LORD that /made the /hea_vens.",
            ],
            [
                "Glo_ry and wor_ship /are be_/fore him;",
                "pow_er and ho_nour are in his /sanc_tu_/a_ry.",
            ],
            [
                "A_scribe un_to the LORD, O ye kind_reds /of the /peo_ples,",
                "a_scribe un_to the LORD /wor_ship and /pow_er.",
            ],
            [
                "A_scribe un_to the LORD the ho_nour due /un_to his /Name;",
                "bring pres_ents, and come /in_to his /courts.",
            ],
            [
                "O wor_ship the LORD in the /beau_ty of /ho_li_ness;",
                "let the whole earth /stand in /awe of him.",
            ],
            [
                "Tell it out a_mong the heath_en, that the LORD is King, and that it is he who hath made the round world so fast that it /can_/not be /moved;",
                "and how that he shall judge the /peo_ples /right_eous_ly.",
            ],
            [
                "Let the hea_vens re_joice, and /let the /earth be /glad;",
                "let the sea make a noise, and /all that /there_in /is.",
            ],
            [
                "Let the field be joy_ful, and /all that is /in it;",
                "then shall all the trees of the wood re_/joice be_/fore the /LORD.",
            ],
            [
                "For he com_eth, for he /com_eth to /judge the earth;",
                "and with right_eous_ness to judge the world, and the /peo_ples /with his /truth.",
            ],
        ],
    },
    {
        id: "psalm97",
        lines: [
            [
                "THE LORD is King, the earth /may be /glad there_of;",
                "yea, the mul_ti_tude of the /isles may be /glad there_of.",
            ],
            [
                "Clouds and dark_ness are /round a_/bout him:",
                "right_eous_ness and judg_ment are the ha_bi_/ta_tion /of his seat.",
            ],
            [
                "There shall go a /fire be_/fore him,",
                "and burn up his e_ne_/mies on /eve_ry /side.",
            ],
            [
                "His light_nings gave shine /un_to the /world:",
                "the earth /saw it, and /was a_/fraid.",
            ],
            [
                "The hills mel_ted like wax at the /pres_ence /of the /LORD;",
                "at the pres_ence of the /Lord of the /whole earth.",
            ],
            [
                "The hea_vens have de_/clared his /right_eous_ness,",
                "and all the peo_ples have /seen his /glo_ry.",
            ],
            [
                "Con_foun_ded be all they that wor_ship carved im_a_ges, and that de_/light in /vain /gods:",
                "/wor_ship him, /all ye gods.",
            ],
            [
                "Si_on heard of it, and re_joiced; and the daugh_ters of /Ju_dah were /glad,",
                "be_cause of thy /judg_ments, O /LORD.",
            ],
            [
                "For thou, LORD, art high_er than all /that are /in the /earth:",
                "thou art ex_al_ted /far a_/bove all /gods.",
            ],
            [
                "O ye that love the LORD, see that ye hate the /thing which is /e_vil:",
                "the Lord pre_ser_veth the souls of his saints; he shall de_li_ver them from the hand of /the un_/god_ly.",
            ],
            [
                "There is sprung up a /light for the /right_eous,",
                "and joy_ful glad_ness for such as /are true-_/heart_ed.",
            ],
            [
                "Re_joice in the /LORD, ye /right_eous;",
                "and give thanks for a re_mem_brance /of his /ho_li_ness.",
            ],
        ],
    },
    {
        id: "psalm98",
        lines: [
            [
                "O SING un_to the /LORD a new /song;",
                "for he hath done /mar_vell_ous /things.",
            ],
            [
                "With his own right hand, and /with his /ho_ly /arm,",
                "hath he got_ten him_/self the /vic_to_ry.",
            ],
            [
                "The LORD de_/clared his sal_/va_tion;",
                "his right_eous_ness hath he o_pen_ly showed in the /sight of the /heath_en.",
            ],
            [
                "He hath re_mem_bered his mer_cy and truth to_ward the /house of Is_ra_el;",
                "and all the ends of the world have seen the sal_/va_tion /of our /God.",
            ],
            [
                "Show your_selves joy_ful un_to the /LORD, all ye /lands;",
                "sing, re_/joice, /and give /thanks.",
            ],
            [
                "Praise the /LORD up_/on the /harp;",
                "sing to the harp with a /psalm of thanks_/giv_ing.",
            ],
            [
                "With trum_pets /al_so and /shawms,",
                "O show your_selves joy_ful be_/fore the /LORD, the /King.",
            ],
            [
                "Let the sea make a noise, and /all that /there_in /is;",
                "the round world, and /they that /dwell there_/in.",
            ],
            [
                "Let the floods clap their hands, and let the hills be joy_ful to_/ge_ther be_/fore the /LORD;",
                "for he is /come to /judge the earth.",
            ],
            [
                "With right_eous_ness /shall he /judge the /world,",
                "and the /peo_ples with /eq_ui_ty.",
            ],
        ],
    },
    {
        id: "psalm99",
        lines: [
            [
                "THE LORD is King, be the peo_ple nev_er /so im_/pa_tient;",
                "he sitt_eth bet_ween the Che_ru_bim, be the earth nev_er /so un_/qui_et.",
            ],
            ["The LORD is /great in /Si_on,", "and high a_/bove all /peo_ple."],
            [
                "They shall give /thanks un_to thy /Name,",
                "which is great, won_der_/ful, and /ho_ly.",
            ],
            [
                "The King's pow_er lov_eth judg_ment; thou hast pre_/pared /eq_ui_ty,",
                "thou hast ex_e_cut_ed judg_ment and right_eous_/ness in /Ja_cob.",
            ],
            [
                "O mag_ni_fy the LORD our God, and fall down be_/fore his /foot_stool;",
                "for /he is /ho_ly.",
            ],
            [
                "Mo_ses and Aa_ron a_mong his priests, and Sam_u_el a_mong such as /call up_/on his Name:",
                "these called up_on the /LORD, and he /heard them.",
            ],
            [
                "He spake un_to them out of the /clou_dy /pil_lar;",
                "for they kept his tes_ti_mon_ies, and the /law that he /gave them.",
            ],
            [
                "Thou heard_est /them, O /LORD our God;",
                "thou for_gav_est them, O God, though thou didst pu_nish their /wick_ed /do_ings.",
            ],
            [
                "O mag_ni_fy the LORD our God, and wor_ship him up_/on his /ho_ly /hill;",
                "for the LORD our /God is /ho_ly.",
            ],
        ],
    },
    {
        id: "psalm100",
        lines: [
            [
                "O BE joy_ful in the /LORD, all ye /lands:",
                "serve the LORD with glad_ness, and come be_fore his /pres_ence /with a song.",
            ],
            [
                "Be ye sure that the LORD he is God; it is he that hath made us, /and not /we our_/selves;",
                "we are his peo_ple, and the /sheep of his /pas_ture.",
            ],
            [
                "O go your way in_to his gates with thanks_giv_ing, and /in_to his /courts with /praise;",
                "be thank_ful un_to him, and speak /good of his /Name.",
            ],
            [
                "For the LORD is gra_cious, his mer_cy is /ev_er_/last_ing;",
                "and his truth en_dur_eth from ge_ne_ra_tion to /ge_ne_/ra_tion.",
            ],
        ],
    },
    {
        id: "psalm101",
        lines: [
            [
                "MY song shall be of /mer_cy and /judg_ment;",
                "un_to thee, O /LORD, will I /sing.",
            ],
            [
                "O let me have /un_der_/stan_ding",
                "in the /way of /god_li_ness!",
            ],
            [
                "When wilt thou /come un_to /me?",
                "I will walk in my house /with a /per_fect /heart.",
            ],
            [
                "I will take no wick_ed thing in hand; I hate the /sins of un_/faith_ful_ness;",
                "there shall no such /cleave un_to /me.",
            ],
            [
                "A fro_ward heart /shall de_/part from me;",
                "I will not know a /wick_ed /per_son.",
            ],
            [
                "Who_so pri_vi_ly slan_der_/eth his /neigh_bour,",
                "/him will /I des_/troy.",
            ],
            [
                "Who_so hath al_so a haugh_ty look /and a /proud heart,",
                "I /will not /suf_fer him.",
            ],
            [
                "Mine eyes look up_on such as are /faith_ful /in the /land,",
                "that /they may /dwell with me.",
            ],
            ["Who_so /lead_eth a /god_ly life,", "he shall /be my /ser_vant."],
            [
                "There shall no de_ceit_ful per_son /dwell in my /house;",
                "he that tell_eth lies shall not /tar_ry in /my /sight.",
            ],
            [
                "I shall soon des_troy all the un_god_ly /that are /in the land;",
                "that I may root out all wick_ed do_ers from the /ci_ty /of the /LORD.",
            ],
        ],
    },
    {
        id: "psalm102",
        lines: [
            [
                "HEAR my /prayer, O /LORD,",
                "and let my cry_ing come /un_to /thee.",
            ],
            [
                "Hide not thy face from me in the /time of my /trou_ble;",
                "in_cline thine ear un_to me when I call; O /hear me, and /that right soon.",
            ],
            [
                "For my days are con_/sumed a_/way like /smoke,",
                "and my bones are burnt up as it /were a /fire_brand.",
            ],
            [
                "My heart is smit_ten down, and /with_ered like /grass;",
                "so that I for_/get to /eat my /bread.",
            ],
            [
                "For the /voice of my /groan_ing,",
                "my bones will scarce /cleave to my /flesh.",
            ],
            [
                "I am be_come like a pel_i_can /in the /wil_der_ness,",
                "and like an owl that is /in the /des_ert.",
            ],
            [
                "I have watched, and am e_ven as it /were a /spar_row,",
                "that sitt_eth a_lone up_/on the /house_top.",
            ],
            [
                "Mine e_ne_mies re_vile me /all the day /long;",
                "and they that are mad up_on me are sworn to_/ge_ther a_/gainst /me.",
            ],
            [
                "For I have eat_en ash_es /as it /were bread,",
                "and ming_led my /drink with /weep_ing;",
            ],
            [
                "And that, be_cause of thine in_dig_/na_tion and /wrath;",
                "for thou hast tak_en me /up, and /cast me /down.",
            ],
            [
                "My days are /gone like a /sha_dow,",
                "and I am /with_ered /like grass.",
            ],
            [
                "But thou, O LORD, shalt en_/dure for /ev_er,",
                "and thy re_mem_brance through_out all /gen_er_/a_tions.",
            ],
            [
                "Thou shalt a_rise, and have mer_cy /up_on /Si_on;",
                "for it is time that thou have mer_cy up_on her, /yea, the /time is /come.",
            ],
            [
                "And why? thy ser_vants /think up_/on her /stones,",
                "and it pi_ti_eth them to /see her /in the /dust.",
            ],
            [
                "The na_tions shall /fear thy /Name, O LORD;",
                "and all the kings of the /earth thy /ma_jes_ty;",
            ],
            [
                "When the LORD shall /build up /Si_on,",
                "and when his /glo_ry /shall ap_/pear;",
            ],
            [
                "When he tur_neth him un_to the prayer of the /poor des_ti_tute,",
                "and des_pis_eth /not /their de_/sire.",
            ],
            [
                "This shall be writ_ten for /those that come /af_ter,",
                "and the peo_ple which shall be /born shall /praise the /LORD.",
            ],
            [
                "For he hath looked down from his /sanc_tu_/a_ry;",
                "out of the hea_ven did the /LORD be_/hold the earth;",
            ],
            [
                "That he might hear the mourn_ings of such as are /in cap_/ti_vi_ty,",
                "and de_li_ver them that are ap_/poin_ted /un_to /death;",
            ],
            [
                "That they may de_clare the Name of the /LORD in /Si_on,",
                "and his wor_ship /at Je_/ru_sa_lem;",
            ],
            [
                "When the peo_ples are /ga_thered to_/ge_ther,",
                "and the king_doms /al_so, to /serve the LORD.",
            ],
            [
                "He brought down my /strength in my /journ_ey,",
                "and /short_ened my /days.",
            ],
            [
                "But I said, O my God, take me not a_way in the /midst of mine /age;",
                "as for thy years, they en_dure through_out all /gen_er_/a_tions.",
            ],
            [
                "Thou, Lord, in the be_ginn_ing hast laid the foun_/da_tion /of the earth,",
                "and the hea_vens are the /work of thy /hands.",
            ],
            [
                "They shall per_ish, but /thou shalt en_/dure:",
                "they all shall wax old as /doth a /gar_ment;",
            ],
            [
                "And as a ves_ture shalt thou change them, and /they shall /be changed;",
                "but thou art the same, and thy /years shall /not fail.",
            ],
            [
                "The child_ren of thy ser_vants /shall con_/tin_ue,",
                "and their seed shall stand /fast in thy /sight.",
            ],
        ],
    },
    {
        id: "psalm103",
        lines: [
            [
                "PRAISE the /LORD, O my /soul;",
                "and all that is with_in me, /praise his /ho_ly Name.",
            ],
            [
                "Praise the /LORD, O my /soul,",
                "and for_get not /all his /be_ne_fits:",
            ],
            [
                "Who for_/giv_eth /all thy /sin,",
                "and heal_eth all /thine in_/fir_mi_ties;",
            ],
            [
                "Who sav_eth thy /life from des_/truc_tion,",
                "and crown_eth thee with mer_cy and /lov_ing-_/kind_ness;",
            ],
            [
                "Who sa_tis_fi_eth thy /mouth with good /things,",
                "ma_king thee young and lus_ty /as an /ea_gle.",
            ],
            [
                "The LORD ex_e_cut_eth right_eous_ness and /judg_ment",
                "for all them that /are op_/pressed with /wrong.",
            ],
            [
                "He showed his /ways un_to /Mo_ses,",
                "his works un_to the /child_ren of /Is_ra_el.",
            ],
            [
                "The LORD is full of com_/pass_ion and /mer_cy,",
                "long_suff_er_ing, /and of great /good_ness.",
            ],
            [
                "He will not /al_way be /chid_ing;",
                "nei_ther keep_eth he his /an_ger for /ev_er.",
            ],
            [
                "He hath not dealt with us /af_ter our /sins;",
                "nor re_war_ded us ac_cor_ding to our /wick_ed_/ness_es.",
            ],
            [
                "For look how high the hea_ven is in com_/pa_ri_son /of the /earth;",
                "so great is his mer_cy al_so to_ward /them that /fear him.",
            ],
            [
                "Look how wide al_so the /east is /from the /west;",
                "so far hath he /set our /sins from us.",
            ],
            [
                "Yea, like as a fa_ther pi_ti_eth /his own /child_ren;",
                "e_ven so is the LORD mer_ci_ful un_to /them that /fear him.",
            ],
            [
                "For he know_eth where_/of we are /made;",
                "he re_mem_ber_eth that /we are /but /dust.",
            ],
            [
                "The days of /man are /but as /grass;",
                "for he flour_ish_eth as a /flow_er /of the /field.",
            ],
            [
                "For as soon as the wind go_eth /o_ver it, /it is /gone;",
                "and the place there_of shall /know it no /more.",
            ],
            [
                "But the mer_ci_ful good_ness of the LORD en_dur_eth for ev_er and ev_er up_on /them that /fear him;",
                "and his right_eous_ness up_on /child_ren's /child_ren;",
            ],
            [
                "E_ven up_on such as /keep his /co_ve_nant,",
                "and think up_on his com_/mand_ments to /do them.",
            ],
            [
                "The LORD hath pre_pared his /seat in /hea_ven,",
                "and his king_dom /rul_eth /o_ver all.",
            ],
            [
                "O praise the LORD, ye an_gels of his, ye that /ex_cel in /strength;",
                "ye that ful_fil his com_mand_ment, and hear_ken un_to the /voice of his /word.",
            ],
            [
                "O praise the /LORD, all /ye his /hosts;",
                "ye ser_vants of his that /do his /plea_sure.",
            ],
            [
                "O speak good of the LORD, all ye works of his, in all pla_ces of /his do_/min_ion:",
                "praise thou the LORD, /O my soul.",
            ],
        ],
    },
    {
        id: "psalm104",
        lines: [
            [
                "PRAISE the /LORD, O my /soul:",
                "O LORD my God, thou art be_come ex_ceed_ing glo_rious; thou art clothed with ma_jes_/ty and /ho_nour.",
            ],
            [
                "Thou deck_est thy_self with light as it /were with a /gar_ment,",
                "and spread_est out the hea_vens /like a /cur_tain.",
            ],
            [
                "Who lay_eth the beams of his cham_bers /in the /wa_ters,",
                "and mak_eth the clouds his cha_ri_ot, and walk_eth up_on the /wings of the /wind.",
            ],
            [
                "He /mak_eth his /an_gels /winds,",
                "and his mi_ni_/sters a /flam_ing /fire.",
            ],
            [
                "He laid the found_/a_tions /of the earth,",
                "that it nev_er should /move at /an_y time.",
            ],
            [
                "Thou cov_eredst it with the deep like as /with a /gar_ment;",
                "the wa_ters /stand a_/bove the hills.",
            ],
            [
                "At /thy re_/buke they /flee;",
                "at the voice of thy /thun_der they /haste a_/way.",
            ],
            [
                "They go up as high as the hills, and down to the /vall_eys be_/neath;",
                "e_ven un_to the place which thou hast ap_/poin_ted for /them.",
            ],
            [
                "Thou hast set them their bounds, /which they /shall not /pass,",
                "nei_ther turn a_gain to /co_ver the /earth.",
            ],
            [
                "He send_eth the springs /in_to the /ri_vers,",
                "which /run a_/mong the /hills.",
            ],
            [
                "All beasts of the /field drink there_/of,",
                "and the wild /ass_es /quench their /thirst.",
            ],
            [
                "Be_side them shall the fowls of the air have their /ha_bi_/ta_tion,",
                "and sing a_/mong the /branch_es.",
            ],
            [
                "He wa_ter_eth the /hills from a_/bove;",
                "the earth is filled with the /fruit of thy /works.",
            ],
            [
                "He bring_eth forth /grass for the /cat_tle,",
                "and green herb for the /ser_vice of /men;",
            ],
            [
                "That he may bring food out of the earth, and wine that mak_eth /glad the /heart of man;",
                "and oil to make him a cheer_ful coun_te_nance, and bread to /strength_en /man's heart.",
            ],
            [
                "The trees of the LORD /al_so are /full of /sap;",
                "e_ven the ce_dars of Le_ba_non which /he hath /plan_ted;",
            ],
            [
                "Where_in the /birds /make their /nests;",
                "and the fir_trees are a /dwell_ing /for the stork.",
            ],
            [
                "The high hills are a re_fuge /for the /wild /goats;",
                "and so are the sto_ny /rocks for the /con_ies.",
            ],
            [
                "He ap_poin_ted the moon for /cer_tain /sea_sons,",
                "and the sun /know_eth his /go_ing /down.",
            ],
            [
                "Thou mak_est dark_ness /that it /may be /night;",
                "where_in all the beasts of the /for_est do /move.",
            ],
            [
                "The li_ons, roar_ing /af_ter their /prey,",
                "do /seek their /meat from /God.",
            ],
            [
                "The sun a_ris_eth, and they get them a_/way to_/ge_ther,",
                "and lay them /down in their /dens.",
            ],
            [
                "Man go_eth forth to his work, and /to his /la_bour,",
                "un_/til the /eve_ning.",
            ],
            [
                "O LORD, how /ma_ni_fold /are thy /works!",
                "in wis_dom hast thou made them all; the earth is /full of thy /rich_es.",
            ],
            [
                "So is the great and /wide sea /al_so;",
                "where_in are things creep_ing in_nu_me_ra_ble, both /small and /great beasts.",
            ],
            [
                "There go the ships, and there is /that le_/vi_a_than,",
                "whom thou hast made to take his /pas_time there_/in.",
            ],
            [
                "These /wait all up_/on thee,",
                "that thou may_est give them /meat in due /sea_son.",
            ],
            [
                "When thou giv_est it /them, they /gath_er it;",
                "and when thou o_pen_est thy hand, /they are /filled with good.",
            ],
            [
                "When thou hid_est thy face, /they are /trou_bled:",
                "when thou tak_est a_way their breath, they die, and are turned a_/gain to their /dust.",
            ],
            [
                "When thou lett_est thy breath go /forth, they /shall be /made;",
                "and thou shalt re_new the /face of the /earth.",
            ],
            [
                "The glo_rious ma_jes_ty of the LORD shall en_/dure for /ev_er;",
                "the LORD shall re_/joice in his /works.",
            ],
            [
                "The earth shall trem_ble /at the /look of him;",
                "if he do but touch the /hills, they shall /smoke.",
            ],
            [
                "I will sing un_to the LORD as /long as /I /live;",
                "I will praise my God while I /have my /be_ing.",
            ],
            [
                "And so /shall my words /please him:",
                "my joy /shall be /in the /LORD.",
            ],
            [
                "As for sin_ners, they shall be con_sumed /out /of the /earth,",
                "and the un_god_ly shall /come to an /end.",
            ],
            ["Praise thou the /LORD, O my /soul.", "/Praise the /LORD."],
        ],
    },
    {
        id: "psalm105",
        lines: [
            [
                "GIVE thanks un_to the LORD, and /call up_/on his /Name;",
                "tell the peo_ple what /things /he hath /done.",
            ],
            [
                "O let your songs be of /him, and /praise him;",
                "and let your talk_ing be of /all his /won_drous /works.",
            ],
            [
                "Re_/joice in his /ho_ly Name;",
                "let the heart of them re_/joice that /seek the /LORD.",
            ],
            [
                "Seek the /LORD and his /strength;",
                "/seek his face /ev_er_more.",
            ],
            [
                "Re_mem_ber the mar_vell_ous /works that /he hath /done;",
                "his won_ders, and the /judg_ments /of his /mouth;",
            ],
            [
                "O ye seed of Ab_ra_/ham his /ser_vant,",
                "ye child_ren of /Ja_cob his /cho_sen.",
            ],
            [
                "He /is the /LORD our /God;",
                "his judg_ments /are in /all the world.",
            ],
            [
                "He hath been al_way mind_ful of his co_ve_/nant and /prom_ise,",
                "that he made to a thou_sand /gen_er_/a_tions;",
            ],
            [
                "E_ven the co_ve_nant that he /made with /Ab_ra_ham;",
                "and the oath that he sware /un_to /I_saac;",
            ],
            [
                "And ap_poin_ted the same un_to /Ja_cob /for a law,",
                "and to Is_ra_el for an ev_er_/last_ing /tes_ta_ment;",
            ],
            [
                "Say_ing, Un_to thee will I give the /land of /Ca_naan,",
                "the lot of /your in_/he_ri_tance:",
            ],
            [
                "When there were /yet but a /few of them,",
                "and they /stran_gers /in the land;",
            ],
            [
                "What time as they went from one na_tion /to a_/no_ther,",
                "from one king_dom to a_/no_ther /peo_ple;",
            ],
            [
                "He suff_ered no /man to /do them wrong,",
                "but re_proved e_ven /kings for their /sakes;",
            ],
            ["Touch /not mine a_/noin_ted,", "and do my /pro_phets /no harm."],
            [
                "More_ov_er, he called for a /dearth up_/on the land,",
                "and des_troyed all the pro_/vis_/ion of /bread.",
            ],
            [
                "But he had sent a /man be_/fore them,",
                "e_ven Jo_seph, who was sold to /be a bond-_/ser_vant;",
            ],
            [
                "Whose feet they /hurt in the /stocks;",
                "the i_ron en_tered /in_/to his /soul;",
            ],
            [
                "Un_til the time came /that his /cause was /known:",
                "the word of the LORD /tried /him.",
            ],
            [
                "The king /sent, and de_/li_vered him;",
                "the prince of the peo_ple /let him go /free.",
            ],
            [
                "He made him lord /al_so /of his /house,",
                "and ru_ler of /all his /sub_stance;",
            ],
            [
                "That he might in_form his prin_ces /af_ter /his /will,",
                "and teach his /se_na_tors /wis_dom.",
            ],
            [
                "Is_ra_el al_so came /in_to /E_gypt,",
                "and Ja_cob was a stran_ger /in the /land of /Ham.",
            ],
            [
                "And he in_creased his /peo_ple ex_/ceed_ing_ly,",
                "and made them stron_ger /than their /e_ne_mies;",
            ],
            [
                "Whose heart turned so, that they /hat_ed his /peo_ple,",
                "and dealt un_tru_ly /with his /ser_vants.",
            ],
            [
                "Then sent he /Mo_ses /his ser_vant,",
                "and Aa_ron whom /he had /cho_sen.",
            ],
            [
                "And these showed his /tok_ens a_/mong them,",
                "and won_ders /in the /land of /Ham.",
            ],
            [
                "He sent /dark_ness, and /it was /dark;",
                "and they were not o_be_di_ent /un_to his /word.",
            ],
            [
                "He turned their /wa_ters /in_to /blood,",
                "and slew their /fish.",
            ],
            [
                "Their /land /brought forth /frogs;",
                "yea, e_ven /in their /kings' cham_bers.",
            ],
            [
                "He spake the word, and there came all /man_ner of /flies,",
                "and lice in /all their /quar_ters.",
            ],
            [
                "He gave them /hail_stones for /rain;",
                "and flames of /fire in their /land.",
            ],
            [
                "He smote their vines /al_so and /fig-_trees;",
                "and des_troyed the trees /that were /in their /coasts.",
            ],
            [
                "He spake the word, and the grass_hop_pers came, and ca_ter_pil_lars in_/nu_me_/ra_ble,",
                "and did eat up all the grass in their land, and de_voured the /fruit of their /ground.",
            ],
            [
                "He smote all the /first_born /in their /land;",
                "e_ven the /chief of /all their /strength.",
            ],
            [
                "He brought them forth al_so with /sil_ver and /gold;",
                "there was not one fee_ble /per_son a_/mong their tribes.",
            ],
            [
                "E_gypt was glad at /their de_/part_ing;",
                "for they /were a_/fraid of them.",
            ],
            [
                "He spread out a cloud to /be a /co_ver_ing,",
                "and fire to give light in the night /sea_son.",
            ],
            [
                "At their de_/sire he brought /quails;",
                "and he filled them with the /bread of /hea_ven.",
            ],
            [
                "He o_pened the rock of stone, and the /wa_ters flowed /out,",
                "so that ri_vers ran /in the /dry pla_ces.",
            ],
            [
                "For why? he re_mem_bered his /ho_ly /prom_ise;",
                "and Ab_ra_/ham his /ser_vant.",
            ],
            [
                "And he brought forth his /peo_ple with /joy,",
                "and his /cho_sen with /glad_ness;",
            ],
            [
                "And gave them the /lands of the /heath_en;",
                "and they took the la_bours of the peo_ple /in pos_/sess_ion;",
            ],
            [
                "That they might /keep his /stat_utes,",
                "and ob_/serve his /laws.",
            ],
        ],
    },
    {
        id: "psalm106",
        lines: [
            [
                "O GIVE thanks un_to the LORD; for /he is /gra_cious,",
                "and his mer_cy en_/dur_eth for /ev_er.",
            ],
            [
                "Who can ex_press the no_ble /acts of the /LORD,",
                "or show /forth /all his /praise?",
            ],
            [
                "Bless_ed are they that /al_way keep /judg_ment,",
                "and do /right_eous_ness.",
            ],
            [
                "Re_mem_ber me, O LORD, ac_cor_ding to the fa_vour that thou bear_est /un_to thy /peo_ple;",
                "O vis_it me with /thy sal_/va_tion;",
            ],
            [
                "That I may see the fe_li_ci_ty /of thy /cho_sen,",
                "and re_joice in the glad_ness of thy peo_ple, and give thanks with /thine in_/he_ri_tance.",
            ],
            [
                "We have /sinned with our /fa_thers;",
                "we have done a_/miss, and dealt /wick_ed_ly.",
            ],
            [
                "Our fa_thers re_gar_ded not thy won_ders in E_gypt, nei_ther kept they thy great good_ness /in re_/mem_brance;",
                "but were dis_o_be_di_ent at the sea, e_ven /at the Red /Sea.",
            ],
            [
                "Ne_ver_the_less, he helped them /for his /Name's sake,",
                "that he might make his /pow_er /to be /known.",
            ],
            [
                "He re_buked the Red Sea al_so, and /it was /dried up;",
                "so he led them through the deep, as /through a /wil_der_ness.",
            ],
            [
                "And he saved them from the ad_/ver_sa_ry's /hand,",
                "and de_li_vered them from the /hand of the /e_ne_my.",
            ],
            [
                "As for those that trou_bled them, the wa_ters /ov_er_/whelmed them;",
                "there was not /one /of them /left.",
            ],
            [
                "Then be_/lieved they his /words,",
                "and sang /praise /un_to /him.",
            ],
            [
                "But with_in a /while they for_/gat his /works,",
                "and would not a_/bide his /coun_sel.",
            ],
            [
                "But lust came up_on them /in the /wil_der_ness,",
                "and they tempt_ed /God in the /des_ert.",
            ],
            [
                "And he /gave them /their de_/sire,",
                "and sent lean_ness with_al /in_to /their /soul.",
            ],
            [
                "They an_gered Mo_ses /al_so /in the /tents,",
                "and Aa_ron the /saint of /the /LORD.",
            ],
            [
                "So the earth o_pened, and /swal_lowed up /Da_than,",
                "and co_vered the con_gre_/ga_tion of A_/bi_ram.",
            ],
            [
                "And the fire was kin_dled /in their /com_pa_ny;",
                "the flame burnt /up the un_/god_ly.",
            ],
            [
                "They made a /calf in /Ho_reb,",
                "and wor_shipped the /mol_ten /im_age.",
            ],
            [
                "Thus they /turned their /glo_ry",
                "in_to the si_mi_li_tude of a /calf that /eat_eth /hay.",
            ],
            [
                "And they for_gat /God their /Sav_iour,",
                "who had done so great /things in /E_gypt;",
            ],
            [
                "Won_drous /works in the /land of /Ham;",
                "and fear_ful /things by the /Red Sea.",
            ],
            [
                "So he said he would have des_troyed them, had not Mo_ses his cho_sen stood be_/fore him /in the /gap,",
                "to turn a_way his wrath_ful in_dig_na_tion, lest he /should des_/troy them.",
            ],
            [
                "Yea, they thought /scorn of that /plea_sant /land,",
                "and gave no cre_dence /un_to /his /word;",
            ],
            [
                "But /mur_mured /in their /tents,",
                "and heark_ened not un_to the /voice /of the /LORD.",
            ],
            [
                "Then lift he up his /hand a_/gainst them,",
                "to o_ver_throw them /in the /wil_der_ness;",
            ],
            [
                "To cast out their seed a_/mong the /na_tions,",
                "and to /scat_ter them /in the /lands.",
            ],
            [
                "They joined them_selves /un_to /Baal-_pe_or,",
                "and ate the /of_fer_ings /of the /dead.",
            ],
            [
                "Thus they pro_voked him to an_ger with their /own in_/ven_tions;",
                "and the plague was /great a_/mong them.",
            ],
            [
                "Then stood up Phi_ne_has, and /in_ter_/posed;",
                "and /so the /plague ceased.",
            ],
            [
                "And that was coun_ted un_to /him for /right_eous_ness,",
                "a_mong all pos_te_ri_/ties for /ev_er_more.",
            ],
            [
                "They an_gered him al_so at the /wa_ters of /strife,",
                "so that he pun_ished /Mo_ses /for their /sakes;",
            ],
            [
                "Be_cause they pro_/voked his /spi_rit,",
                "so that he spake un_ad_/vi_sed_ly /with his /lips.",
            ],
            [
                "Nei_ther des_troyed /they the /heath_en,",
                "as the /LORD com_/man_ded them;",
            ],
            [
                "But were ming_led a_/mong the /heath_en,",
                "and learned their /works.",
            ],
            [
                "In_so_much that they wor_shipped their i_dols, which be_came a /snare un_to /them;",
                "yea, they off_ered their sons and their daugh_ters /un_to /dev_ils;",
            ],
            [
                "And shed in_no_cent blood, e_ven the blood of their sons and /of their /daugh_ters,",
                "whom they off_ered un_to the i_dols of Ca_naan; and the /land was de_/filed with /blood.",
            ],
            [
                "Thus were they /stained with their /own works,",
                "and went a whor_ing with their /own in_/ven_tions.",
            ],
            [
                "There_fore was the wrath of the LORD kin_dled a_/gainst his /peo_ple,",
                "in_so_much that he ab_horred his /own in_/he_ri_tance.",
            ],
            [
                "And he gave them o_ver in_to the /hand of the /heath_en;",
                "and they that hat_ed them were /lords /o_ver /them.",
            ],
            [
                "Their e_ne_mies op_/pressed them,",
                "and had them /in sub_/jec_tion.",
            ],
            [
                "Ma_ny a time /did he de_/li_ver them;",
                "but they re_belled a_gainst him with their own in_ven_tions, and were brought /down in their /wick_ed_ness.",
            ],
            [
                "Ne_ver_the_less, when he /saw their ad_/ver_si_ty,",
                "he /heard their com_/plaint.",
            ],
            [
                "He thought up_on his co_ve_nant, and pit_ied them, ac_cor_ding un_to the mul_ti_tude /of his /mer_cies;",
                "yea, he made all those that led them a_way /cap_tive to /pi_ty them.",
            ],
            [
                "De_li_ver us, O LORD our God, and gath_er us from a_/mong the /heath_en;",
                "that we may give thanks un_to thy ho_ly Name, and make our /boast of thy /praise.",
            ],
            [
                "Bless_ed be the LORD God of Is_ra_el, from ev_er_last_ing, and /world with_/out /end;",
                "And let all the /peo_ple /say, A_/men.",
            ],
        ],
    },
    {
        id: "psalm107",
        lines: [
            [
                "O GIVE thanks un_to the LORD, for /he is /gra_cious,",
                "and his mer_cy en_/dur_eth for /ev_er.",
            ],
            [
                "Let them give thanks whom the /LORD hath re_/deemed,",
                "and de_li_vered from the /hand of the /e_ne_my;",
            ],
            [
                "And ga_thered them out of the lands, from the /east, and /from the /west;",
                "from the /north, and /from the south.",
            ],
            [
                "They went as_tray in the wil_der_ness /out of the /way,",
                "and found no /ci_ty to /dwell in.",
            ],
            ["Hun_gry and /thirs_ty,", "their soul /faint_ed /in them."],
            [
                "So they cried un_to the LORD /in their /trou_ble,",
                "and he de_li_vered /them from /their dist_ress.",
            ],
            [
                "He led them forth /by the right /way,",
                "that they might go to the /ci_ty /where they /dwelt.",
            ],
            [
                "O that men would there_fore praise the LORD /for his /good_ness;",
                "and de_clare the won_ders that he do_eth for the /child_ren of /men!",
            ],
            [
                "For he sa_tis_/fi_eth the /emp_ty soul,",
                "and fil_leth the hun_gry /soul with /good_ness.",
            ],
            [
                "Such as sit in dark_ness, and in the /sha_dow of /death,",
                "be_ing fast bound in mi_se_/ry and /i_ron;",
            ],
            [
                "Be_cause they re_belled a_gainst the /words of the /Lord,",
                "and light_ly re_gar_ded the coun_sel /of the Most /High_est;",
            ],
            [
                "He al_so brought down their /heart through /hea_vi_ness:",
                "they fell down, and there was /none to /help them.",
            ],
            [
                "So when they cried un_to the LORD /in their /trou_ble,",
                "he de_li_vered them /out of /their dist_/ress.",
            ],
            [
                "For he brought them out of dark_ness, and out of the /sha_dow of /death,",
                "and brake their /bonds in /sun_der.",
            ],
            [
                "O that men would there_fore praise the LORD /for his /good_ness;",
                "and de_clare the won_ders that he do_eth for the /child_ren of /men!",
            ],
            [
                "For he hath /bro_ken the /gates of /brass,",
                "and smit_ten the bars of /i_ron in /sun_der.",
            ],
            [
                "Fool_ish men are /plagued for /their of_/fence,",
                "and be_/cause of their /wick_ed_ness.",
            ],
            [
                "Their soul ab_horred all /man_ner of /meat,",
                "and they were e_ven /hard at /death's door.",
            ],
            [
                "So when they cried un_to the LORD /in their /trou_ble,",
                "he de_li_vered them /out of /their dist_/ress.",
            ],
            [
                "He sent his /word, and /healed them;",
                "and they were saved from /their des_/truc_tion.",
            ],
            [
                "O that men would there_fore praise the LORD /for his /good_ness;",
                "and de_clare the won_ders that he do_eth for the /child_ren of /men!",
            ],
            [
                "That they would off_er un_to him the sac_ri_fice /of thanks_/giv_ing,",
                "and tell out his /works with /glad_ness!",
            ],
            [
                "THEY that go /down to the /sea in /ships,",
                "and oc_cu_py their busi_ness /in great /wa_ters;",
            ],
            [
                "These men see the /works of the /LORD,",
                "and his /won_ders /in the /deep.",
            ],
            [
                "For at his word the stor_my /wind a_/ris_eth,",
                "which lift_eth /up the /waves there_/of.",
            ],
            [
                "They are car_ried up to the hea_ven, and down a_/gain to the /deep;",
                "their soul melt_eth a_way be_/cause of the /trou_ble.",
            ],
            [
                "They reel to and fro, and stag_ger /like a /drunk_en /man,",
                "and are /at their /wit's end.",
            ],
            [
                "So when they cry un_to the LORD /in their /trou_ble,",
                "he de_li_ver_eth them /out of /their dist_/ress.",
            ],
            [
                "For he /mak_eth the /storm to /cease,",
                "so that the /waves there_/of are /still.",
            ],
            [
                "Then are they glad, be_/cause they /are at /rest;",
                "and so he bring_eth them un_to the ha_ven /where they /would be.",
            ],
            [
                "O that men would there_fore praise the LORD /for his /good_ness;",
                "and de_clare the won_ders that he do_eth for the /child_ren of /men!",
            ],
            [
                "That they would ex_alt him al_so in the con_gre_ga_tion /of the /peo_ple,",
                "and praise him in the /seat of the /eld_ers!",
            ],
            [
                "He tur_neth the floods /in_to a /wil_der_ness,",
                "and dri_eth up the /wa_ter-_springs.",
            ],
            [
                "A fruit_ful land /mak_eth he /bar_ren,",
                "for the wick_ed_ness of /them that /dwell there_/in.",
            ],
            [
                "A_gain, he mak_eth the wil_der_ness a /stand_ing /wa_ter,",
                "and wa_ter-_springs /of a /dry ground.",
            ],
            [
                "And there he /set_teth the /hun_gry,",
                "that they may build them a /ci_ty to /dwell in;",
            ],
            [
                "That they may sow their /land, and plant /vine_yards,",
                "to yield them /fruits of /in_crease.",
            ],
            [
                "He bles_seth them, so that they mul_ti_/ply ex_/ceed_ing_ly;",
                "and suff_er_eth not their /cat_tle /to de_/crease.",
            ],
            [
                "And a_gain, when they are /min_ished /and brought /low",
                "through opp_ress_ion, through an_y /plague or /trou_ble;",
            ],
            [
                "Though he suf_fer them to be e_vil en_/treat_ed through /ty_rants,",
                "and let them wan_der out of the /way in the /wil_der_ness;",
            ],
            [
                "Yet help_eth he the poor /out of /mi_se_ry,",
                "and mak_eth him house_holds /like a /flock of /sheep.",
            ],
            [
                "The right_eous will con_si_der /this, and re_/joice;",
                "and the mouth of all /wick_ed_ness /shall be /stopped.",
            ],
            [
                "Who_so is wise, will /pon_der /these /things;",
                "and they shall un_der_stand the lov_ing-_/kind_ness /of the /LORD.",
            ],
        ],
    },
    {
        id: "psalm108",
        lines: [
            [
                "O GOD, my heart is rea_dy, my /heart is /rea_dy;",
                "I will sing, and give praise with the best /mem_ber /that I have.",
            ],
            [
                "A_/wake, thou /lute and /harp;",
                "I my_self will a_/wake right /ear_ly.",
            ],
            [
                "I will give thanks un_to thee, O LORD, a_/mong the /peo_ples;",
                "I will sing prais_es un_to thee a_/mong the /na_tions.",
            ],
            [
                "For thy mer_cy is great_er /than the /hea_vens,",
                "and thy truth reach_eth /un_/to the /clouds.",
            ],
            [
                "Set up thy_self, O God, a_/bove the /hea_vens,",
                "and thy glo_ry a_/bove /all the /earth;",
            ],
            [
                "That thy be_lov_ed may /be de_/li_vered:",
                "let thy right hand /save them, and /hear thou me.",
            ],
            [
                "God hath spo_ken /in his /ho_li_ness;",
                "I will re_joice there_fore, and di_vide She_chem, and mete out the /val_ley of /Succ_oth.",
            ],
            [
                "Gi_le_ad is mine, and Ma_/na_sseh /is /mine;",
                "Eph_ra_im al_so is the strength of my head; Ju_dah /is my /law_giv_er;",
            ],
            [
                "Mo_ab is my wash-_pot; o_ver E_dom will I /cast /out my /shoe;",
                "up_on Phil_is_ti_a /will I /tri_umph.",
            ],
            [
                "Who will lead me in_to /the strong /ci_ty?",
                "and who will bring me /in_to /E_dom?",
            ],
            [
                "Hast not thou for_/sa_ken /us, O /God?",
                "and wilt not thou, O God, go /forth with our /hosts?",
            ],
            [
                "O help us a_/gainst the /e_ne_my:",
                "for /vain is the /help of /man.",
            ],
            [
                "Through God /we shall do /great acts;",
                "and it is he that shall tread /down our /e_ne_mies.",
            ],
        ],
    },
    {
        id: "psalm109",
        lines: [
            [
                "Hold not thy tongue, O /God of my /praise;",
                "for the mouth of the un_god_ly, yea, the mouth of the de_ceit_ful is /o_pened up_/on me.",
            ],
            [
                "And they have spo_ken a_/gainst me with /false tongues;",
                "they com_passed me a_bout al_so with words of hat_red, and fought a_/gainst me with_/out a cause.",
            ],
            [
                "For the love that I had un_to them, lo, they take now my /con_tra_ry /part;",
                "but I give my_/self /un_to /prayer.",
            ],
            [
                "Thus have they re_war_ded me /e_vil for /good,",
                "and hat_red /for my /good will.",
            ],
            [
                "Set thou an un_god_ly man to be /ru_ler /o_ver him,",
                "and let an ad_ver_sa_ry /stand at his /right /hand.",
            ],
            [
                "When sen_tence is gi_ven up_on him, let him /be con_/demned;",
                "and let his prayer be /turned /in_to /sin.",
            ],
            [
                "/Let his /days be /few;",
                "and let a_no_ther /take his /off_ice.",
            ],
            [
                "Let his /child_ren be /fa_ther_less,",
                "and his /wife a /wid_ow.",
            ],
            [
                "Let his child_ren be va_ga_/bonds, and /beg their /bread;",
                "let them seek it al_so out of /de_so_late /pla_ces.",
            ],
            [
                "Let the ex_tor_tion_er con_sume /all that he /hath;",
                "and let the stran_ger /spoil his /la_bour.",
            ],
            [
                "Let there be no /man to /pi_ty him,",
                "nor to have com_pass_ion up_on his /fa_ther_less /child_ren.",
            ],
            [
                "Let his pos_/te_ri_ty /be des_/troyed;",
                "and in the next ge_ne_ra_tion let his /name be /clean put out.",
            ],
            [
                "Let the wick_ed_ness of his fa_thers be had in re_mem_brance in the /sight of the /LORD;",
                "and let not the sin of his /mo_ther be /done a_/way.",
            ],
            [
                "Let them /al_way be be_/fore the LORD,",
                "that he may root out the me_mor_i_al of /them from /off the earth;",
            ],
            [
                "And that, be_cause his mind was /not to do /good;",
                "but per_se_cu_ted the poor help_less man, that he might slay him that was /vexed /at the /heart.",
            ],
            [
                "His de_light was in cur_sing, and it shall /hap_pen /un_to /him;",
                "he loved not bless_ing, there_fore /shall it be /far from /him.",
            ],
            [
                "He clothed him_self with cur_sing like as /with a /rai_ment,",
                "and it shall come in_to his bow_els like wa_ter, and like oil /in_to /his /bones.",
            ],
            [
                "Let it be un_to him as the cloak that he /hath up_/on him,",
                "and as the gir_dle that he is al_way /gir_ded with_/al.",
            ],
            [
                "Let it thus hap_pen from the LORD /un_to mine /e_ne_mies,",
                "and to those that speak /e_vil a_/gainst my /soul.",
            ],
            [
                "But deal thou with me, O LORD God, ac_cor_ding /un_to thy /Name;",
                "for /sweet is thy /mer_cy.",
            ],
            [
                "O de_li_ver me, for I am /help_less and /poor,",
                "and my heart is /woun_ded with_/in me.",
            ],
            [
                "I go hence like the sha_dow /that de_/par_teth,",
                "and am driv_en a_way /as the /grass_hop_per.",
            ],
            [
                "My knees are /weak through /fast_ing;",
                "my flesh is dried up for /want of /fat_ness.",
            ],
            [
                "I am be_come al_so a rep_roach /un_to /them:",
                "they that look up_/on me /shake their heads.",
            ],
            [
                "/Help me, O /LORD my /God;",
                "O save me ac_cor_ding /to thy /mer_cy;",
            ],
            [
                "And they shall know how that /this is thy /hand,",
                "and that /thou, LORD, hast /done it.",
            ],
            [
                "Though they /curse, yet /bless thou;",
                "and let them be con_foun_ded that rise up a_gainst me; but let thy /ser_vant re_/joice.",
            ],
            [
                "Let mine ad_ver_sa_ries be /clothed with /shame;",
                "and let them co_ver them_selves with their own con_fu_sion, /as /with a /cloak.",
            ],
            [
                "As for me, I will give great thanks un_to the /LORD with my /mouth,",
                "and praise him a_/mong the /mul_ti_tude;",
            ],
            [
                "For he shall stand at the /right hand /of the /poor,",
                "to save his soul from un_/right_eous /judg_es.",
            ],
        ],
    },
    {
        id: "psalm110",
        lines: [
            [
                "THE LORD said /un_to my /Lord,",
                "Sit thou on my right hand, un_til I make thine e_ne_mies thy /foot_stool.",
            ],
            [
                "The LORD shall send the rod of thy pow_er /out of /Si_on:",
                "be thou ru_ler, e_ven in the midst a_/mong thine /e_ne_mies.",
            ],
            [
                "In the day of thy pow_er shall thy peo_ple off_er them_selves will_ing_ly with an /ho_ly /wor_ship:",
                "thy young men come to thee as dew from the /womb of the /mor_ning.",
            ],
            [
                "The LORD /sware, and will /not re_/pent,",
                "Thou art a Priest for ev_er af_ter the or_der /of Mel_/chi_ze_dek.",
            ],
            [
                "The Lord up_/on thy /right hand",
                "shall wound e_ven kings in the /day of /his /wrath.",
            ],
            [
                "He shall judge a_/mong the /heath_en;",
                "he shall fill the pla_ces with the dead bod_ies, and smite in sun_der the heads o_ver /di_vers /coun_tries.",
            ],
            [
                "He shall drink of the /brook in the /way;",
                "there_fore /shall he lift /up his /head.",
            ],
        ],
    },
    {
        id: "psalm111",
        lines: [
            [
                "I WILL give thanks un_to the LORD /with my /whole heart,",
                "se_cret_ly a_mong the faith_ful, and in the /con_gre_/ga_tion.",
            ],
            [
                "The works of the /LORD are /great,",
                "sought out of all them that have /plea_sure there_/in.",
            ],
            [
                "His work is wor_thy to be praised and /had in /ho_nour,",
                "and his right_eous_ness en_/dur_eth for /ev_er.",
            ],
            [
                "The mer_ci_ful and gra_cious LORD hath so done his /mar_vell_ous /works,",
                "that they ought to be /had in re_/mem_brance.",
            ],
            [
                "He hath gi_ven meat un_to /them that /fear him;",
                "he shall ev_er be mind_ful /of his /co_ve_nant.",
            ],
            [
                "He hath showed his peo_ple the /pow_er /of his /works,",
                "that he may give them the he_ri_tage /of the /heath_en.",
            ],
            [
                "The works of his hands are /ve_ri_ty and /judg_ment;",
                "all his com_/mand_ments are /true.",
            ],
            [
                "They stand fast for /ev_er and /ev_er,",
                "and are done in /truth and /eq_ui_ty.",
            ],
            [
                "He sent re_demp_tion /un_to his /peo_ple;",
                "he hath com_man_ded his co_ve_nant for ev_er; ho_ly and /re_ver_end /is his /Name.",
            ],
            [
                "The fear of the LORD is the be_/ginn_ing of /wis_dom;",
                "a good un_der_stan_ding have all they that do there_af_ter; his praise en_/dur_eth for /ev_er.",
            ],
        ],
    },
    {
        id: "psalm112",
        lines: [
            [
                "BLESS_ED is the man that /fear_eth the /LORD;",
                "he hath great de_light in /his com_/mand_ments.",
            ],
            [
                "His seed shall be /migh_ty up_/on earth;",
                "the ge_ne_ra_tion of the /faith_ful /shall be /blessed.",
            ],
            [
                "Rich_es and plen_teous_ness shall /be in his /house;",
                "and his right_eous_ness en_/dur_eth for /ev_er.",
            ],
            [
                "Un_to the god_ly there a_ris_eth up /light in the /dark_ness;",
                "he is mer_ci_ful, /lov_ing, and /right_eous.",
            ],
            [
                "A good man is mer_ci_/ful, and /len_deth;",
                "and will guide his /words with dis_/cre_tion.",
            ],
            [
                "For he shall /nev_er be /moved:",
                "and the right_eous shall be had in ev_er_/last_ing re_/mem_brance.",
            ],
            [
                "He will not be a_fraid of an_y /e_vil /tid_ings;",
                "for his heart stand_eth fast, and be_/liev_eth /in the /LORD.",
            ],
            [
                "His heart is /stab_lished, and /will not /shrink,",
                "un_til he see his de_sire up_/on his /e_ne_mies.",
            ],
            [
                "He hath dis_persed a_broad, and /gi_ven /to the /poor.",
                "and his right_eous_ness re_main_eth for ev_er; his horn shall be ex_/al_ted with /ho_nour.",
            ],
            [
                "The un_god_ly shall see it, and /it shall /grieve him;",
                "he shall gnash with his teeth, and con_sume a_way; the de_sire of the un_/god_ly shall /per_ish.",
            ],
        ],
    },
    {
        id: "psalm113",
        lines: [
            [
                "PRAISE the /LORD, ye /ser_vants;",
                "O praise the /Name /of the /LORD.",
            ],
            [
                "Bless_ed be the /Name of the /LORD",
                "from this time /forth for /ev_er_more.",
            ],
            [
                "The LORD'S /Name is /praised",
                "from the ris_ing up of the sun un_to the go_ing /down of the /same.",
            ],
            [
                "The LORD is high a_/bove all /na_tions,",
                "and his glo_ry a_/bove the /hea_vens.",
            ],
            [
                "Who is like un_to the LORD our God, that hath his /dwell_ing so /high,",
                "and yet humb_leth him_self to be_hold the things that are in /hea_ven and /earth!",
            ],
            [
                "He tak_eth up the sim_ple /out of the /dust,",
                "and lift_eth the poor /out of /the /mire;",
            ],
            [
                "That he may set him /with the /prin_ces,",
                "e_ven with the prin_ces /of his /peo_ple.",
            ],
            [
                "He mak_eth the bar_ren /wo_man /to keep /house,",
                "and to be a joy_ful /mo_ther of /child_ren.",
            ],
        ],
    },
    {
        id: "psalm114",
        lines: [
            [
                "WHEN Is_ra_el came /out of /E_gypt,",
                "and the house of Ja_cob from a_/mong the strange /peo_ple,",
            ],
            [
                "Ju_dah was his /sanc_tu_/a_ry,",
                "and Is_ra_el /his do_/min_ion.",
            ],
            ["The /sea saw /that, and fled;", "/Jor_dan was /driv_en back."],
            [
                "The /moun_tains /skipped like /rams,",
                "and the lit_tle /hills like /young sheep.",
            ],
            [
                "What ail_eth thee, O thou /sea, that thou /fled_dest?",
                "and thou Jor_dan, that /thou wast /driv_en /back?",
            ],
            [
                "Ye moun_tains, /that ye /skipped like /rams?",
                "and ye lit_tle /hills, like /young sheep?",
            ],
            [
                "Trem_ble, thou earth, at the /pres_ence /of the /Lord:",
                "at the pres_ence of the /God of /Ja_cob;",
            ],
            [
                "Who turned the hard rock in_to a /stand_ing /wa_ter,",
                "and the flint-_stone /in_to a /spring_ing /well.",
            ],
        ],
    },
    {
        id: "psalm115",
        lines: [
            [
                "NOT un_to us, O LORD, not un_to us, but un_to /thy Name /give the /praise;",
                "for thy lov_ing mer_cy, and /for thy /truth's sake.",
            ],
            [
                "Where_fore /shall the /heath_en say,",
                "/Where is /now their /God?",
            ],
            [
                "As for our God, he /is in /hea_ven:",
                "he hath done what_so_/ev_er /pleased him.",
            ],
            [
                "Their i_dols are /sil_ver /and /gold,",
                "e_ven the /work of men's /hands.",
            ],
            [
                "They have /mouths, and /speak not;",
                "eyes have /they, and /see not.",
            ],
            [
                "They have /ears, and /hear not;",
                "no_ses have /they, and /smell not.",
            ],
            [
                "They have hands, and han_dle not; feet have /they, and /walk not;",
                "nei_ther /speak they /through their throat.",
            ],
            [
                "They that make them /are like /un_to /them;",
                "and so are all such as /put their /trust in them.",
            ],
            [
                "But thou, house of Is_ra_el, /trust thou /in the LORD;",
                "he is their hel_per /and de_fen_der.",
            ],
            [
                "Ye house of Aa_ron, put your /trust in the /LORD;",
                "he is their hel_per /and de_fen_der.",
            ],
            [
                "Ye that fear the LORD, put your /trust in the /LORD;",
                "he is their hel_per /and de_fen_der.",
            ],
            [
                "The LORD hath been mind_ful of us, and /he shall /bless us;",
                "e_ven he shall bless the house of Is_ra_el, he shall bless the /house of /Aa_ron.",
            ],
            [
                "He shall /bless them that /fear the /LORD,",
                "both /small and great.",
            ],
            [
                "The LORD shall in_/crease you /more and more,",
                "you /and your /child_ren.",
            ],
            [
                "Ye are the /bless_ed /of the /LORD,",
                "who made /hea_ven and /earth.",
            ],
            [
                "All the whole /hea_vens /are the LORD'S;",
                "the earth hath he gi_ven to the /child_ren of /men.",
            ],
            [
                "The dead /praise not /thee, O LORD,",
                "nei_ther all they that go /down in_to /si_lence.",
            ],
            [
                "But /we will /praise the LORD,",
                "from this time forth for ev_er_more. /Praise the LORD.",
            ],
        ],
    },
    {
        id: "psalm116",
        lines: [
            [
                "MY de_/light is /in the /LORD;",
                "be_cause he hath heard the /voice of my /prayer;",
            ],
            [
                "Be_cause he hath in_/clined his ear /un_to /me;",
                "there_fore will I call up_on him as /long as I /live.",
            ],
            [
                "The snares of death /com_passed me /round a_/bout,",
                "and the pains of hell gat /hold up_/on me.",
            ],
            [
                "I found trou_ble and hea_vi_ness; then called I up_on the /Name of the /LORD;",
                "O LORD, I be_seech thee, de_/li_ver my /soul.",
            ],
            [
                "Gra_cious is the /LORD, and /right_eous;",
                "yea, our /God is /mer_ci_ful.",
            ],
            [
                "The LORD pre_/ser_veth the /sim_ple:",
                "I was in mi_se_ry, /and he /helped me.",
            ],
            [
                "Turn a_gain then un_to thy /rest, O my /soul;",
                "for the LORD /hath re_/war_ded /thee.",
            ],
            [
                "And why? thou hast de_/li_vered my /soul from /death,",
                "mine eyes from tears, and my /feet from /fall_ing.",
            ],
            [
                "I will /walk be_/fore the /LORD",
                "in the /land of the /li_ving.",
            ],
            [
                "I be_lieved, and there_fore will I speak; but I /was sore /trou_bled:",
                "I said in my haste, All /men are /li_ars.",
            ],
            [
                "What re_ward shall I give /un_to the /LORD",
                "for all the be_ne_fits that he hath /done un_to /me?",
            ],
            [
                "I will re_ceive the /cup of sal_/va_tion,",
                "and call up_on the /Name of the /LORD.",
            ],
            [
                "I will pay my vows now in the pres_ence of /all his /peo_ple:",
                "right dear in the sight of the LORD is the /death of his /saints.",
            ],
            [
                "Be_hold, O LORD, how that /I am thy /ser_vant;",
                "I am thy ser_vant, and the son of thine hand_maid; thou hast bro_ken my /bonds in /sun_der.",
            ],
            [
                "I will off_er to thee the sac_ri_fice /of thanks_/giv_ing,",
                "and will call up_on the /Name of the /LORD.",
            ],
            [
                "I will pay my vows un_to the LORD, in the sight of /all his /peo_ple,",
                "in the courts of the LORD'S house; e_ven in the midst of thee, O Je_/ru_sa_lem. /Praise the /LORD.",
            ],
        ],
    },
    {
        id: "psalm117",
        lines: [
            [
                "O PRAISE the LORD, /all ye /na_tions;",
                "praise him, /all ye /peo_ples.",
            ],
            [
                "For his mer_ci_ful kind_ness is ev_er more and /more to_/ward us;",
                "and the truth of the LORD en_dur_eth for /ev_er. /Praise the LORD.",
            ],
        ],
    },
    {
        id: "psalm118",
        lines: [
            [
                "O GIVE thanks un_to the LORD, for /he is /gra_cious;",
                "be_cause his mer_cy en_/dur_eth for /ev_er.",
            ],
            [
                "Let Is_ra_el now con_fess that /he is /gra_cious,",
                "and that his mer_cy en_/dur_eth for /ev_er.",
            ],
            [
                "Let the house of /Aa_ron /now con_/fess,",
                "that his mer_cy en_/dur_eth for /ev_er.",
            ],
            [
                "Yea, let them now that /fear the /LORD con_/fess,",
                "that his mer_cy en_/dur_eth for /ev_er.",
            ],
            [
                "I called up_on the /LORD in /trou_ble;",
                "and the LORD /heard me /at /large.",
            ],
            [
                "The /LORD is /on my side;",
                "I will not fear what man /do_eth /un_to /me.",
            ],
            [
                "The LORD tak_eth my part with /them that /help me;",
                "there_fore shall I see my de_sire up_/on mine /e_ne_mies.",
            ],
            [
                "It is bet_ter to /trust in the /LORD,",
                "than to put an_y /con_fi_/dence in /man.",
            ],
            [
                "It is bet_ter to /trust in the /LORD,",
                "than to put an_y con_fi_/dence in /prin_ces.",
            ],
            [
                "All na_tions /com_passed me /round a_/bout;",
                "but in the Name of the LORD will /I des_/troy them.",
            ],
            [
                "They kept me in on eve_ry side, they kept me in, I /say, on /eve_ry side;",
                "but in the Name of the LORD will /I des_/troy them.",
            ],
            [
                "They came a_bout me like bees, and are ex_tinct e_ven as the /fire a_/mong the /thorns;",
                "for in the Name of the LORD I /will des_/troy them.",
            ],
            [
                "Thou hast thrust sore at me, /that I might /fall;",
                "but the /LORD was my /help.",
            ],
            [
                "The LORD is my /strength, and my /song;",
                "and is be_/come my sal_/va_tion.",
            ],
            [
                "The voice of joy and health is in the dwell_ings /of the /right_eous;",
                "the right hand of the LORD bring_eth /migh_ty /things to /pass.",
            ],
            [
                "The right hand of the LORD /hath the pre-_/em_in_ence;",
                "the right hand of the LORD bring_eth /migh_ty /things to /pass.",
            ],
            [
                "I /shall not /die, but /live,",
                "and de_clare the /works of the /LORD.",
            ],
            [
                "The LORD hath chast_ened /and cor_/rec_ted me;",
                "but he hath not gi_ven me /o_ver /un_to /death.",
            ],
            [
                "O_pen me the /gates of /right_eous_ness,",
                "that I may go in_to them, and give thanks /un_to the /LORD.",
            ],
            [
                "This is the /gate of the /LORD,",
                "the right_eous shall /en_ter /in_to it.",
            ],
            [
                "I will thank thee; for /thou hast /heard me,",
                "and art be_/come my sal_/va_tion.",
            ],
            [
                "The same stone which the /build_ers re_/fused,",
                "is be_come the head-_stone /in the /corn_er.",
            ],
            [
                "This /is the /LORD'S do_ing,",
                "and it is /mar_vell_ous /in our /eyes.",
            ],
            [
                "This is the /day which the /LORD hath /made;",
                "we will re_/joice and be /glad in it.",
            ],
            ["Help me /now, O LORD:", "O LORD, send us /now pros_/pe_ri_ty."],
            [
                "Bless_ed be he that com_eth in the /Name of the /LORD:",
                "we have wished you good luck, we that are of the /house of the /LORD.",
            ],
            [
                "God is the /LORD, who hath /showed us /light:",
                "bind the sac_ri_fice with cords, yea, e_ven un_to the /horns of the /al_tar.",
            ],
            [
                "Thou art my God, and /I will /thank thee;",
                "thou art my God, and /I will /praise thee.",
            ],
            [
                "O give thanks un_to the LORD; for /he is /gra_cious,",
                "and his mer_cy en_/dur_eth for /ev_er.",
            ],
        ],
    },
    {
        id: "psalm119",
        lines: [
            [
                "BLESS_ED are those that are un_de_/filed in the /way,",
                "and walk in the /law of the /LORD.",
            ],
            [
                "Bless_ed are they that keep his /tes_ti_/mon_ies,",
                "and seek him /with their /whole heart;",
            ],
            ["E_ven they who /do no /wick_ed_ness,", "and /walk in his /ways."],
            [
                "/Thou hast /charg-_ed",
                "that we shall di_li_gent_ly keep /thy com_/mand_ments.",
            ],
            [
                "O that my ways were /made so /di_rect,",
                "that I might /keep thy /stat_utes!",
            ],
            [
                "So shall I not /be con_/foun_ded,",
                "while I have res_pect un_to all /thy com_/mand_ments.",
            ],
            [
                "I will thank thee /with an /un_feigned heart,",
                "when I shall have learned the judg_ments /of thy /right_eous_ness.",
            ],
            ["I will /keep thy /stat_utes;", "O for_/sake me not /utt_er_ly."],
            [
                "WHERE_WITH_AL shall a young /man /cleanse his /way?",
                "e_ven by rul_ing him_self /af_ter /thy word.",
            ],
            [
                "With my whole /heart have I /sought thee;",
                "O let me not go wrong out of /thy com_/mand_ments.",
            ],
            [
                "Thy word have I /hid with_/in my heart,",
                "that I should not /sin a_/gainst thee.",
            ],
            ["Bless_ed /art thou, O /LORD;", "O /teach me thy /stat_utes."],
            [
                "With my lips have /I been /tell_ing",
                "of all the /judg_ments /of thy mouth.",
            ],
            [
                "I have had as great de_light in the way of thy /tes_ti_/mon_ies,",
                "as in all /man_ner of /rich_es.",
            ],
            [
                "I will talk of /thy com_/mand_ments,",
                "and have res_/pect un_to /thy /ways.",
            ],
            [
                "My de_light shall /be in thy /stat_utes,",
                "and I will /not for_/get thy word.",
            ],
            [
                "O DO well /un_to thy /ser_vant;",
                "that I may /live, and /keep thy word.",
            ],
            [
                "/O_pen /thou mine /eyes;",
                "that I may see the won_drous /things of thy /law.",
            ],
            [
                "I am a /stran_ger up_/on earth;",
                "O hide not thy com_/mand_ments from /me.",
            ],
            [
                "My soul break_eth out for the ve_ry /fer_vent /de_sire",
                "that it hath al_way /un_to thy /judg_ments.",
            ],
            [
                "Thou /hast re_/buked the proud;",
                "and cursed are they that do err from /thy com_/mand_ments.",
            ],
            [
                "O turn from me /shame and re_/buke;",
                "for I have kept thy /tes_ti_/mon_ies.",
            ],
            [
                "Prin_ces al_so did sit and /speak a_/gainst me;",
                "but thy ser_vant is oc_cu_pied /in thy /stat_utes.",
            ],
            [
                "For thy tes_ti_mon_ies /are /my de_/light,",
                "/and my /coun_sel_lors.",
            ],
            [
                "MY soul /cleav_eth /to the dust;",
                "O quick_en thou me, ac_/cor_ding /to thy /word.",
            ],
            [
                "I have ack_now_ledged my ways, /and thou /heard_est me:",
                "O /teach me thy /stat_utes.",
            ],
            [
                "Make me to un_der_stand the way of /thy com_/mand_ments;",
                "and so shall I /talk of thy /won_drous /works.",
            ],
            [
                "My soul melt_eth a_way for /ve_ry /hea_vi_ness;",
                "com_fort thou me ac_cor_ding /un_to /thy /word.",
            ],
            [
                "Take from me the /way of /ly_ing,",
                "and cause thou me to make /much of thy /law.",
            ],
            [
                "I have /cho_sen the /way of /truth,",
                "and thy judg_ments have I /laid be_/fore me.",
            ],
            [
                "I have stuck un_to thy /tes_ti_/mon_ies;",
                "O /LORD, con_/found me /not.",
            ],
            [
                "I will run the way of /thy com_/mand_ments,",
                "when thou hast set my /heart at /li_ber_ty.",
            ],
            [
                "TEACH me, O LORD, the /way of thy /stat_utes,",
                "and I shall keep it /un_to the /end.",
            ],
            [
                "Give me un_der_stan_ding, and /I shall /keep thy /law;",
                "yea, I shall keep it /with my /whole heart.",
            ],
            [
                "Make me to go in the path of /thy com_/mand_ments;",
                "for there_/in is /my de_/sire.",
            ],
            [
                "In_cline my heart un_to thy /tes_ti_/mon_ies,",
                "and not to /co_ve_tous_/ness.",
            ],
            [
                "O turn a_way mine eyes, lest they /be_hold /va_ni_ty;",
                "and quick_en thou /me /in thy /way.",
            ],
            [
                "O stab_lish thy /word in thy /ser_vant,",
                "that /I may /fear thee.",
            ],
            [
                "Take a_way the re_buke that I /am a_/fraid of;",
                "for thy /judg_ments are good.",
            ],
            [
                "Be_hold, my de_light is in /thy com_/mand_ments;",
                "O quick_en /me in thy /right_eous_ness.",
            ],
            [
                "LET thy lov_ing mer_cy come al_so /un_to /me, O /LORD,",
                "e_ven thy sal_va_tion, ac_cor_ding /un_to /thy /word.",
            ],
            [
                "So shall I make an_swer un_to /my blas_/phem_ers;",
                "for my /trust is /in thy /word.",
            ],
            [
                "O take not the word of thy truth utt_er_ly /out of my /mouth;",
                "for my hope is /in thy /judg_ments.",
            ],
            [
                "So shall I /al_way /keep thy /law;",
                "yea, for /ev_er and /ev_er.",
            ],
            [
                "And I will /walk at /li_ber_ty;",
                "for I /seek thy com_/mand_ments.",
            ],
            [
                "I will speak of thy tes_ti_mon_ies al_so, /e_ven be_/fore kings,",
                "and will /not /be a_/shamed.",
            ],
            [
                "And my de_light shall be in /thy com_/mand_ments,",
                "/which I /have loved.",
            ],
            [
                "My hands al_so will I lift up un_to thy com_mand_ments, /which I /have loved;",
                "and my stu_dy shall /be in thy /stat_utes.",
            ],
            [
                "O THINK up_on thy ser_vant, as con_/cer_ning thy /word,",
                "where_in thou hast /caused me to /put my /trust.",
            ],
            [
                "The same is my com_fort /in my /trou_ble;",
                "for thy /word hath /quick_ened me.",
            ],
            [
                "The proud have had me ex_ceed_ing_ly /in de_/ri_sion;",
                "yet have I not /shrinked from thy /law.",
            ],
            [
                "For I re_mem_bered thine ev_er_last_ing /judg_ments, O /LORD,",
                "/and re_ceived /com_fort.",
            ],
            [
                "I am /hor_ri_/bly a_/fraid,",
                "for the un_god_ly /that for_/sake thy /law.",
            ],
            [
                "Thy stat_utes have /been my /songs,",
                "in the /house of my /pil_grim_age.",
            ],
            [
                "I have thought up_on thy Name, O /LORD, in the night /sea_son,",
                "and /have kept thy /law.",
            ],
            [
                "This I had, be_cause I /kept thy com_/mand_ments.",
                "Thou art my por_tion, O LORD; I have /prom_ised to /keep thy /law.",
            ],
            [
                "I made my hum_ble pe_ti_tion /in thy /pres_ence",
                "with my /whole heart;",
            ],
            ["O be /mer_ci_ful /un_to me,", "ac_/cor_ding /to thy /word."],
            [
                "I called mine own /ways to re_/mem_brance,",
                "and turned my feet un_to thy /tes_ti_/mon_ies.",
            ],
            [
                "I made haste, and pro_/longed /not the /time,",
                "to /keep thy com_/mand_ments.",
            ],
            [
                "The snares of the un_god_ly have /com_passed /me a_/bout;",
                "but I have not for_/got_ten thy /law.",
            ],
            [
                "At mid_night I will rise to give /thanks un_to /thee,",
                "be_cause of thy /right_eous /judg_ments.",
            ],
            [
                "I am a com_pan_ion of all /them that /fear thee,",
                "and /keep thy com_/mand_ments.",
            ],
            [
                "The earth, O LORD, is /full of thy /mer_cy:",
                "O /teach me thy /stat_utes.",
            ],
            [
                "O LORD, thou hast dealt gra_cious_ly /with thy /ser_vant,",
                "ac_cor_ding /un_to /thy /word.",
            ],
            [
                "O teach me true un_der_/stan_ding and /know_ledge;",
                "for I have be_/lieved thy com_/mand_ments.",
            ],
            [
                "Be_fore I was /trou_bled, /I went /wrong;",
                "but /now have I /kept thy /word.",
            ],
            ["Thou art /good and /gra_cious;", "O /teach me thy /stat_utes."],
            [
                "The proud have i_ma_gined a /lie a_/gainst me;",
                "but I will keep thy com_mand_ments /with my /whole /heart.",
            ],
            [
                "Their /heart is as /fat as /brawn;",
                "but my de_light hath /been in thy /law.",
            ],
            [
                "It is good for me that I have /been in /trou_ble;",
                "that I may /learn thy /stat_utes.",
            ],
            [
                "The law of thy mouth is /dea_rer /un_to /me",
                "than thou_sands of /gold and /sil_ver.",
            ],
            [
                "THY hands have /made me and /fash_ioned me:",
                "O give me un_der_stan_ding, that I may /learn thy com_/mand_ments.",
            ],
            [
                "They that fear thee will be /glad when they /see me;",
                "be_cause I have put my /trust in thy /word.",
            ],
            [
                "I know, O LORD, that thy /judg_ments are /right,",
                "and that thou of ve_ry faith_ful_ness hast caused /me to be /trou_bled.",
            ],
            [
                "O let thy mer_ci_ful kind_ness /be my /com_fort,",
                "ac_cor_ding to thy word /un_to thy /ser_vant.",
            ],
            [
                "O let thy lov_ing mer_cies come un_to /me, that /I may /live;",
                "for thy /law is /my de_/light.",
            ],
            [
                "Let the proud be con_foun_ded, for they go wick_ed_ly a_/bout to des_/troy me;",
                "but I will be oc_cu_pied in /thy com_/mand_ments.",
            ],
            [
                "Let such as fear thee, and have known thy /tes_ti_/mon_ies,",
                "be turned /un_to me.",
            ],
            [
                "O let my heart be /sound in thy /stat_utes,",
                "that I /be /not a_/shamed.",
            ],
            [
                "MY soul hath longed for /thy sal_/va_tion,",
                "and I have a good hope be_/cause of /thy /word.",
            ],
            [
                "Mine eyes-_long /sore for thy /word;",
                "say_ing, O when /wilt thou /com_fort me?",
            ],
            [
                "For I am be_come like a /bot_tle /in the /smoke;",
                "yet do I not for_/get thy /stat_utes.",
            ],
            [
                "How ma_ny are the /days of thy /ser_vant?",
                "when wilt thou be a_venged of them that /per_se_cute /me?",
            ],
            [
                "The /proud have digged /pits for me,",
                "which are not /af_ter /thy /law.",
            ],
            [
                "All thy com_/mand_ments are /true:",
                "they per_se_cute me false_ly; O be /thou my help.",
            ],
            [
                "They had al_most made an end of /me up_/on earth;",
                "but I for_sook /not thy com_/mand_ments.",
            ],
            [
                "O quick_en me af_ter thy /lov_ing-_/kind_ness;",
                "and so shall I keep the tes_ti_mon_ies /of thy mouth.",
            ],
            ["O LORD, thy /word", "en_dur_eth for /ev_er in /hea_ven."],
            [
                "Thy truth al_so re_main_eth from one ge_ne_ra_tion /to a_/no_ther;",
                "thou hast laid the foun_da_tion of the earth, and /it a_/bi_deth.",
            ],
            [
                "They con_tin_ue this day ac_cor_ding /to thine /ord_in_ance;",
                "for /all things /serve /thee.",
            ],
            [
                "If my de_light had not /been in thy /law,",
                "I should have per_ished /in my /trou_ble.",
            ],
            [
                "I will nev_er for_/get thy com_/mand_ments;",
                "for with them /thou hast /quick_ened me.",
            ],
            [
                "I am /thine: O /save me,",
                "for I have /sought thy com_/mand_ments.",
            ],
            [
                "The un_god_ly laid wait for /me, to des_/troy me;",
                "but I will con_si_der thy /tes_ti_/mon_ies.",
            ],
            [
                "I see that all things /come to an /end;",
                "but thy com_mand_ment /is ex_/ceed_ing broad.",
            ],
            [
                "LORD, what love have I /un_to thy /law!",
                "all the day long is my /stu_dy /in it.",
            ],
            [
                "Thou, through thy com_mand_ments, hast made me wis_er /than mine /e_ne_mies;",
                "for they are /ev_er /with me.",
            ],
            [
                "I have more un_der_stan_ding /than my /teach_ers;",
                "for thy tes_ti_mon_ies /are my /stu_dy.",
            ],
            [
                "I am wis_er /than the /ag-_ed;",
                "be_cause I /keep thy com_/mand_ments.",
            ],
            [
                "I have ref_rained my feet from /eve_ry /e_vil /way,",
                "that /I may /keep thy /word.",
            ],
            [
                "I have not /shrunk from thy /judg_ments;",
                "/for thou /teach_est me.",
            ],
            [
                "O how sweet are thy words /un_to my /throat;",
                "yea, swee_ter than hon_ey /un_to my /mouth!",
            ],
            [
                "Through thy com_mand_ments I get /un_der_/stan_ding:",
                "there_fore I /hate all /e_vil /ways.",
            ],
            [
                "THY word is a lant_ern /un_to my /feet,",
                "and a light /un_to my /paths.",
            ],
            [
                "I have sworn, and am /sted_fast_ly /pur_posed,",
                "to keep thy /right_eous /judg_ments.",
            ],
            [
                "I am trou_bled /a_bove /meas_ure:",
                "quick_en me, O LORD, ac_/cor_ding /to thy /word.",
            ],
            [
                "Let the free-_will of_fer_ings of my mouth /please thee, O /LORD;",
                "and /teach me thy /judg_ments.",
            ],
            [
                "My soul is /al_way /in my hand;",
                "yet do I /not for_/get thy law.",
            ],
            [
                "The un_god_ly have /laid a /snare for me;",
                "but yet I swerved not from /thy com_/mand_ments.",
            ],
            [
                "Thy tes_ti_mon_ies have I claimed as mine he_ri_/tage for /ev_er;",
                "and why? they are the ve_ry /joy of my /heart.",
            ],
            [
                "I have app_lied my heart to ful_fil thy /stat_utes /al_way,",
                "e_ven /un_to the /end.",
            ],
            [
                "I HATE them that i_/ma_gine /e_vil things;",
                "but thy /law do I /love.",
            ],
            [
                "Thou /art my de_/fence and shield;",
                "and my /trust is /in thy /word.",
            ],
            [
                "A_way from /me, ye /wick_ed;",
                "I will keep the com_/mand_ments /of my God.",
            ],
            [
                "O stab_lish me ac_cor_ding to thy /word, that /I may live;",
                "and let me not be dis_ap_/point_ed /of my hope.",
            ],
            [
                "Hold thou me up, and /I shall /be safe;",
                "yea, my de_light shall be ev_er /in thy /stat_utes.",
            ],
            [
                "Thou hast trod_den down all them that de_/part from thy /stat_utes;",
                "for they i_/ma_gine /but de_/ceit.",
            ],
            [
                "Thou putt_est a_way all the un_god_ly /of the /earth like dross;",
                "there_fore I love thy /tes_ti_/mon_ies.",
            ],
            [
                "My flesh /tremb_leth for /fear of /thee;",
                "and I am a_/fraid of thy /judg_ments.",
            ],
            [
                "I DEAL with the thing that is /law_ful and /right;",
                "O give me not o_ver un_to /mine op_/press_ors.",
            ],
            [
                "Make thou thy ser_vant to de_light in /that which is /good,",
                "that the proud /do me /no wrong.",
            ],
            [
                "Mine eyes are wast_ed a_way with /look_ing /for thy health,",
                "and for the /word of thy /right_eous_ness.",
            ],
            [
                "O deal with thy ser_vant ac_cor_ding un_to thy /lov_ing /mer_cy,",
                "and /teach me thy /stat_utes.",
            ],
            [
                "I am thy ser_vant; O grant me /un_der_/stan_ding,",
                "that I may know thy /tes_ti_/mon_ies.",
            ],
            [
                "It is time for thee, LORD, to /lay to /thine hand;",
                "for they /have des_/troyed thy /law.",
            ],
            [
                "For I /love thy com_/mand_ments",
                "a_bove /gold and /prec_ious stones.",
            ],
            [
                "There_fore hold I straight /all thy com_/mand_ments;",
                "and all false ways I /utt_er_/ly ab_/hor.",
            ],
            [
                "THY tes_ti_mon_ies /are /won_der_ful;",
                "there_fore /doth my soul /keep them.",
            ],
            [
                "When thy /word go_eth /forth,",
                "it gi_veth light and un_der_stan_ding /un_to the /sim_ple.",
            ],
            [
                "I o_pened my mouth, and /drew in my /breath;",
                "for my de_light was in /thy com_/mand_ments.",
            ],
            [
                "O look thou up_on me, and be /mer_ci_ful /un_to me,",
                "as thou us_est to do un_to /those that /love thy Name.",
            ],
            [
                "Or_der my /steps in thy /word;",
                "and so shall no wick_ed_ness have do_/min_ion /o_ver me.",
            ],
            [
                "O de_li_ver me from the wrong_ful /deal_ings of /men;",
                "and so shall I /keep thy com_/mand_ments.",
            ],
            [
                "Show the light of thy coun_te_nance up_/on thy /ser_vant,",
                "and /teach me thy /stat_utes.",
            ],
            [
                "Mine eyes gush /out with /wa_ter,",
                "be_cause /men keep /not thy law.",
            ],
            [
                "/RIGHT_EOUS art /thou, O /LORD;",
                "and /true are thy /judg_ments.",
            ],
            [
                "The tes_ti_mon_ies that /thou hast com_/man_ded",
                "are ex_ceed_ing /right_eous and /true.",
            ],
            [
                "My zeal hath /e_ven con_/sumed me;",
                "be_cause mine e_ne_mies have for_/got_ten /thy /words.",
            ],
            [
                "Thy word is /tried to the /ut_ter_most,",
                "and thy /ser_vant /lov_eth it.",
            ],
            [
                "I am small and of no /re_pu_/ta_tion;",
                "yet do I not for_/get thy com_/mand_ments.",
            ],
            [
                "Thy right_eous_ness is an ev_er_/last_ing /right_eous_ness,",
                "and thy /law is the /truth.",
            ],
            [
                "Trou_ble and hea_vi_ness have tak_en /hold up_/on me;",
                "yet is my de_light in /thy com_/mand_ments.",
            ],
            [
                "The right_eous_ness of thy tes_ti_mon_ies is /ev_er_/last_ing:",
                "O grant me un_der_/stan_ding, and /I shall live.",
            ],
            [
                "I /CALL with my /whole /heart;",
                "hear me, O LORD; I will /keep thy /stat_utes.",
            ],
            [
                "Yea, e_ven un_to /thee do I /call;",
                "help me, and I shall keep thy /tes_ti_/mon_ies.",
            ],
            [
                "Ear_ly in the mor_ning do I /cry un_to /thee;",
                "for in thy /word is my /trust.",
            ],
            [
                "Mine eyes pre_/vent the night /watch_es;",
                "that I might be /oc_cu_pied /in thy word.",
            ],
            [
                "Hear my voice, O LORD, ac_cor_ding un_to thy /lov_ing_/kind_ness;",
                "quick_en me, ac_cor_ding /to thy /judg_ments.",
            ],
            [
                "They draw nigh that of ma_lice /per_se_/cute /me,",
                "and are /far from thy /law.",
            ],
            [
                "Be thou /nigh at /hand, O /LORD;",
                "for all thy com_/mand_ments are /true.",
            ],
            [
                "As con_cer_ning thy tes_ti_mon_ies, /I have /known /long since,",
                "that thou hast groun_ded /them for /ev_er.",
            ],
            [
                "O CON_SI_DER mine ad_ver_si_ty, /and de_/li_ver me,",
                "for I do /not for_/get thy law.",
            ],
            [
                "A_venge thou my cause, /and de_/li_ver me;",
                "quick_en me ac_/cor_ding /to thy /word.",
            ],
            [
                "Health is far from /the un_/god_ly;",
                "for they re_gard /not thy /stat_utes.",
            ],
            [
                "Great is thy /mer_cy, O /LORD;",
                "quick_en /me, as /thou art wont.",
            ],
            [
                "Ma_ny there are that trou_ble me, and /per_se_/cute me;",
                "yet do I not swerve from thy /tes_ti_/mon_ies.",
            ],
            [
                "It griev_eth me when I /see the trans_/gres_sors;",
                "be_cause they /keep not /thy law.",
            ],
            [
                "Con_si_der, O LORD, how I /love thy com_/mand_ments;",
                "O quick_en me, ac_cor_ding to thy /lov_ing-_/kind_ness.",
            ],
            [
                "Thy word is true from /ev_er_/last_ing;",
                "all the judg_ments of thy right_eous_ness en_/dure for /ev_er_more.",
            ],
            [
                "PRIN_CES have per_se_cu_ted /me with_/out a cause;",
                "but my heart stand_eth in /awe of thy /word.",
            ],
            [
                "I am as /glad of thy /word,",
                "as one that /find_eth /great spoils.",
            ],
            [
                "As for lies, I /hate and ab_/hor them;",
                "but thy /law do I /love.",
            ],
            [
                "Se_ven times a /day do I /praise thee;",
                "be_cause of thy /right_eous /judg_ments.",
            ],
            [
                "Great is the peace that they /have who /love thy law;",
                "and they have none oc_/ca_sion of /stum_bling.",
            ],
            [
                "LORD, I have /looked for thy /sav_ing health,",
                "and done af_ter /thy com_/mand_ments.",
            ],
            [
                "My soul hath kept thy /tes_ti_/mon_ies,",
                "and /loved them ex_/ceed_ing_ly.",
            ],
            [
                "I have kept thy com_mand_ments and /tes_ti_/mon_ies;",
                "for all my /ways are be_/fore thee.",
            ],
            [
                "LET my com_plaint come be_/fore thee, O /LORD;",
                "give me un_der_stan_ding ac_/cor_ding /to thy /word.",
            ],
            [
                "Let my supp_li_ca_tion /come be_/fore thee;",
                "de_li_ver me ac_/cor_ding /to thy /word.",
            ],
            [
                "My lips shall /speak of thy /praise,",
                "when thou hast /taught me thy /stat_utes.",
            ],
            [
                "Yea, my tongue shall /sing of thy /word;",
                "for all thy com_/mand_ments are /right_eous.",
            ],
            [
                "Let /thine hand /help me;",
                "for I have cho_sen /thy com_/mand_ments.",
            ],
            [
                "I have longed for thy /sav_ing /health, O /LORD;",
                "and in thy /law is /my de_/light.",
            ],
            [
                "O let my soul live, and /it shall /praise thee;",
                "and thy /judg_ments shall /help me.",
            ],
            [
                "I have gone as_tray like a /sheep that is /lost;",
                "O seek thy ser_vant, for I do not for_/get thy com_/mand_ments.",
            ],
        ],
    },
    {
        id: "psalm120",
        lines: [
            [
                "WHEN I was in trou_ble, I /called up_/on the /LORD,",
                "and he /heard me.",
            ],
            [
                "De_li_ver my soul, O /LORD, from /ly_ing /lips,",
                "and /from a de_/ceit_ful /tongue.",
            ],
            [
                "What re_ward shall be gi_ven or done un_to /thee, thou /false /tongue?",
                "e_ven migh_ty and sharp arr_ows, with /hot /burn_ing /coals.",
            ],
            [
                "Woe is me, that I am con_strained to /dwell with /Mesh_ech,",
                "and to have my ha_bi_ta_tion a_mong the /tents of /Ke_dar!",
            ],
            [
                "My soul hath long /dwelt a_/mong them",
                "that are /e_ne_mies /un_to /peace.",
            ],
            [
                "I la_bour for peace; but when I /speak un_to /them there_/of,",
                "they make them /rea_dy to /bat_tle.",
            ],
        ],
    },
    {
        id: "psalm121",
        lines: [
            [
                "I WILL lift up mine /eyes un_to the /hills;",
                "from /whence com_eth /my /help?",
            ],
            [
                "My help com_eth /e_ven /from the /LORD,",
                "who hath made /hea_ven /and /earth.",
            ],
            [
                "He will not suf_fer thy /foot /to be /moved;",
                "and he that /keep_eth thee /will not /sleep.",
            ],
            [
                "Be_hold, he that /keep_eth /Is_ra_el",
                "shall nei_ther /slum_ber /nor /sleep.",
            ],
            [
                "The LORD him_/self is thy /keep_er;",
                "the LORD is thy de_fence up_/on thy /right hand;",
            ],
            [
                "So that the sun shall not /burn thee by /day,",
                "/nei_ther the /moon by /night.",
            ],
            [
                "The LORD shall pre_serve thee /from all /e_vil;",
                "yea, it is e_ven /he that shall /keep thy /soul.",
            ],
            [
                "The LORD shall pre_serve thy go_ing /out, and thy /com_ing in,",
                "from this time /forth for /ev_er_more.",
            ],
        ],
    },
    {
        id: "psalm122",
        lines: [
            [
                "I WAS glad when they /said un_to /me,",
                "We will go in_to the /house of the /LORD.",
            ],
            ["Our feet shall /stand in thy /gates,", "O Je_/ru_sa_lem."],
            [
                "Je_ru_sa_lem is /built as a /ci_ty",
                "that is at u_ni_ty /in it_/self.",
            ],
            [
                "For thi_ther the tribes go up, e_ven the /tribes of the /LORD,",
                "to tes_ti_fy un_to Is_ra_el, to give thanks un_to the /Name of the /LORD.",
            ],
            [
                "For there is the /seat of /judg_ment,",
                "e_ven the seat of the /house of /Da_vid.",
            ],
            [
                "O pray for the peace of Je_/ru_sa_lem;",
                "they shall /pros_per that /love thee.",
            ],
            [
                "Peace be with_/in thy /walls,",
                "and plen_teous_ness with_/in thy /pa_la_ces.",
            ],
            [
                "For my breth_ren /and com_/pan_ions' sakes,",
                "I will /wish thee pros_/pe_ri_ty.",
            ],
            [
                "Yea, be_cause of the house of the /LORD our God,",
                "I will /seek to /do thee /good.",
            ],
        ],
    },
    {
        id: "psalm123",
        lines: [
            [
                "UN_TO /thee lift I /up mine /eyes,",
                "O thou that dwell_est /in the /hea_vens.",
            ],
            [
                "Be_hold, e_ven as the eyes of ser_vants look un_to the hand of their mas_ters, and as the eyes of a mai_den un_to the /hand of her /mis_tress,",
                "e_ven so our eyes wait up_on the LORD our God, un_til he have /mer_cy up_/on us.",
            ],
            [
                "Have mer_cy up_on us, O LORD, have /mer_cy up_/on us;",
                "for we are /utt_er_ly /des_pised.",
            ],
            [
                "Our soul is filled with the scornf_ul re_/proof of the /weal_thy,",
                "and with the des_/pite_ful_ness /of the /proud.",
            ],
        ],
    },
    {
        id: "psalm124",
        lines: [
            [
                "IF the LORD him_self had not been on our side, now may /Is_ra_el /say;",
                "if the LORD him_self had not been on our side, when men rose /up a_/gainst us;",
            ],
            [
                "They had /swal_lowed us /up a_/live;",
                "when they were so wrath_ful_/ly dis_/pleased at us.",
            ],
            [
                "Yea, the /wa_ters had /drowned us,",
                "and the stream had gone /o_ver our /soul.",
            ],
            [
                "The deep /wa_ters /of the /proud",
                "had gone e_ven /o_ver our /soul.",
            ],
            [
                "But /praised be the /LORD,",
                "who hath not gi_ven us o_ver for a /prey un_to /their /teeth.",
            ],
            [
                "Our soul is es_caped e_ven as a bird out of the /snare of the /fow_ler;",
                "the snare is bro_ken, and /we are de_/li_vered.",
            ],
            [
                "Our help stand_eth in the /Name of the /LORD,",
                "who hath made /hea_ven /and /earth.",
            ],
        ],
    },
    {
        id: "psalm125",
        lines: [
            [
                "THEY that put their trust in the LORD shall be e_ven /as the mount /Si_on,",
                "which may not be re_moved, but stand_eth /fast for /ev_er.",
            ],
            [
                "The hills stand a_/bout Je_/ru_sa_lem;",
                "e_ven so stand_eth the LORD round a_bout his peo_ple, from this time /forth for /ev_er_more.",
            ],
            [
                "For the scep_tre of the un_god_ly shall not a_bide up_on the /lot of the /right_eous;",
                "lest the right_eous put their hand /un_to /wick_ed_ness.",
            ],
            [
                "Do well, O /LORD,",
                "un_to those that are /good and /true of heart.",
            ],
            [
                "As for such as turn back un_to their own /wick_ed_ness,",
                "the LORD shall lead them forth with the e_vil do_ers; but peace shall /be up_on /Is_ra_el.",
            ],
        ],
    },
    {
        id: "psalm126",
        lines: [
            [
                "WHEN the LORD turned a_gain the cap_ti_vi_/ty of /Si_on,",
                "then were we like /un_to /them that dream.",
            ],
            [
                "Then was our mouth /filled with /laugh_ter,",
                "/and our /tongue with /joy.",
            ],
            [
                "Then said they a_/mong the /heath_en,",
                "The LORD hath /done great /things for them.",
            ],
            [
                "Yea, the LORD hath done great things for /us al_/rea_dy;",
                "where_of /we re_joice.",
            ],
            [
                "Turn our cap_ti_vi_ty, O LORD, as the /ri_vers /in the /south.",
                "They that sow in /tears shall /reap in joy.",
            ],
            [
                "He that now go_eth on his way weep_ing, and /bear_eth /forth good /seed,",
                "shall doubt_less come a_gain with joy, and /bring his /sheaves with him.",
            ],
        ],
    },
    {
        id: "psalm127",
        lines: [
            [
                "EX_CEPT the /LORD build the /house,",
                "their la_bour is but /lost that /build it.",
            ],
            [
                "Ex_cept the LORD /keep the /ci_ty,",
                "the watch_man /wak_eth /but in /vain.",
            ],
            [
                "It is but lost la_bour that ye haste to rise up ear_ly, and so late take rest, and eat the /bread of /care_ful_ness;",
                "for so he gi_veth /his be_/lov_ed /sleep.",
            ],
            [
                "Lo, child_ren, and the /fruit of the /womb,",
                "are an he_ri_tage and gift that /com_eth /of the /LORD.",
            ],
            [
                "Like as the arr_ows in the /hand of the /gi_ant,",
                "e_ven so /are the young /child_ren.",
            ],
            [
                "Hap_py is the man that hath his /qui_ver /full of them;",
                "they shall not be a_shamed when they speak with their /e_ne_mies /in the /gate.",
            ],
        ],
    },
    {
        id: "psalm128",
        lines: [
            [
                "BLESS_ED are all /they that /fear the /LORD,",
                "and /walk in his /ways.",
            ],
            [
                "For thou shalt eat the /la_bours /of thine hands:",
                "O well is thee, and /hap_py /shalt thou be.",
            ],
            [
                "Thy wife shall be /as the /fruit_ful /vine",
                "up_on the /walls of thine /house;",
            ],
            [
                "Thy child_ren like the /ol_ive-_/branch_es",
                "round a_/bout thy /ta_ble.",
            ],
            [
                "Lo, thus /shall the /man be /blessed",
                "that /fear_eth the /LORD.",
            ],
            [
                "The LORD from out of Si_on /shall so /bless thee,",
                "that thou shalt see Je_ru_sa_lem in pros_pe_ri_ty /all thy /life long;",
            ],
            [
                "Yea, that thou shalt see thy /child_ren's /child_ren,",
                "and /peace up_on /Is_ra_el.",
            ],
        ],
    },
    {
        id: "psalm129",
        lines: [
            [
                "MA_NY a time have they fought a_gainst me /from my /youth up,",
                "may /Is_ra_el /now say;",
            ],
            [
                "Yea, ma_ny a time have they vexed me /from my /youth up;",
                "but they have not pre_/vailed a_/gainst me.",
            ],
            [
                "The plo_wers /plowed up_/on my back,",
                "and /made long /furr_ows.",
            ],
            [
                "/But the /right_eous /LORD",
                "hath hewn the snares of the un_/god_ly in /pie_ces.",
            ],
            [
                "Let them be con_foun_ded /and turned /back_ward,",
                "as ma_ny as have e_vil /will at /Si_on.",
            ],
            [
                "Let them be e_ven as the grass up_/on the /house_tops,",
                "which with_er_eth a_/fore it be /grown up;",
            ],
            [
                "Where_of the mo_wer /fil_leth /not his hand,",
                "nei_ther he that bind_eth up the /sheaves his /bo_som.",
            ],
            [
                "So that they who go by say not so much /as, The LORD /pros_per you;",
                "we wish you good luck in the /Name of the /LORD.",
            ],
        ],
    },
    {
        id: "psalm130",
        lines: [
            [
                "OUT of the deep have I called /un_to /thee, O LORD;",
                "Lord, /hear my /voice.",
            ],
            [
                "O let thine /ears con_/si_der /well",
                "the /voice of /my com_/plaint.",
            ],
            [
                "If thou, LORD, wilt be ext_reme to mark /what is /done a_/miss,",
                "O Lord, /who may a_/bide it?",
            ],
            [
                "For there is /mer_cy /with /thee;",
                "there_fore /shalt thou be /feared.",
            ],
            [
                "I look for the LORD; my /soul doth /wait for him;",
                "in his /word is my /trust.",
            ],
            [
                "My soul fleeth un_to the Lord be_/fore the /mor_ning watch;",
                "I say, be_/fore the /mor_ning watch.",
            ],
            [
                "O Is_ra_el, trust in the LORD; for with the /LORD there is /mer_cy,",
                "and with him is /plen_te_ous re_/demp_tion.",
            ],
            ["And he /shall re_deem /Is_ra_el", "/from /all his /sins."],
        ],
    },
    {
        id: "psalm131",
        lines: [
            ["LORD, I am /not high-_/min_ded;", "I /have no /proud looks."],
            [
                "I do not ex_er_cise my_self /in great /mat_ters",
                "which /are too /high for me.",
            ],
            [
                "But I re_frain my soul, and keep it low, like as a child that is /weaned from his /mo_ther:",
                "yea, my soul is e_ven /as a /weaned /child.",
            ],
            [
                "O Is_ra_el, /trust in the /LORD",
                "from this time /forth for /ev_er_more.",
            ],
        ],
    },
    {
        id: "psalm132",
        lines: [
            ["LORD, re_/mem_ber /Da_vid,", "and /all his /trou_ble:"],
            [
                "How he sware /un_to the /LORD,",
                "and vowed a vow un_to the Al_/migh_ty /God of /Ja_cob:",
            ],
            [
                "I will not come with_in the tab_er_/na_cle /of mine /house,",
                "nor climb up /in_to /my /bed;",
            ],
            [
                "I will not suf_fer mine eyes to sleep, nor mine /eye_lids to /slum_ber;",
                "nei_ther the temp_les of my /head to take /an_y rest;",
            ],
            [
                "Un_til I find out a place for the /tem_ple /of the /LORD;",
                "an ha_bi_ta_tion for the Migh_ty /God of /Ja_cob.",
            ],
            [
                "Lo, we heard of the /same at /Eph_ra_tah,",
                "and /found it /in the /wood.",
            ],
            [
                "We will go in_to his /tab_er_/na_cle,",
                "and fall low on our knees be_/fore his /foot_stool.",
            ],
            [
                "A_rise, O LORD, /in_to thy /res_ting-_place;",
                "thou, and the /ark /of thy /strength.",
            ],
            [
                "Let thy priests be /clothed with /right_eous_ness;",
                "and let thy saints /sing with /joy_ful_ness.",
            ],
            [
                "For thy /ser_vant /Da_vid's /sake,",
                "turn not a_way the face of /thine a_/noin_ted.",
            ],
            [
                "The LORD hath made a faith_ful /oath un_to /Da_vid,",
                "and he /shall not /shrink from it:",
            ],
            ["Of the /fruit of thy /bo_dy", "shall I /set up_/on thy /throne."],
            [
                "If thy child_ren will keep my co_ve_nant, and my tes_ti_mon_ies that /I shall /teach them;",
                "their child_ren al_so shall sit up_on thy /throne for /ev_er_more.",
            ],
            [
                "For the LORD hath cho_sen Si_on to be an ha_bi_/ta_tion /for him_self;",
                "/he hath /longed for /her.",
            ],
            [
                "This shall be my /rest for /ev_er:",
                "here will I dwell, for I /have a de_/light there_/in.",
            ],
            [
                "I will bless her /vic_tu_als with /in_crease,",
                "and will sat_is_fy her /poor with /bread.",
            ],
            [
                "I will /deck her /priests with /health,",
                "and her saints /shall re_/joice and /sing.",
            ],
            [
                "There shall I make the horn of /Da_vid to /flou_rish:",
                "I have or_dained a lant_ern for /mine a_/noin_ted.",
            ],
            [
                "As for his e_ne_mies, I shall /clothe them with /shame;",
                "but up_on him_self /shall his crown /flou_rish.",
            ],
        ],
    },
    {
        id: "psalm133",
        lines: [
            [
                "BE_HOLD, how good and /joy_ful a /thing it /is,",
                "for breth_ren to dwell to_/ge_ther in /u_ni_ty!",
            ],
            [
                "It is like the prec_ious oil up_on the head, that ran down /un_to the /beard,",
                "e_ven un_to Aa_ron's beard, and went down to the /skirts of his /clo_thing.",
            ],
            [
                "Like as the /dew of /Her_mon,",
                "which fell up_on the /hill of /Si_on.",
            ],
            [
                "For there the LORD /prom_ised his /bless_ing,",
                "and /life for /ev_er_/more.",
            ],
        ],
    },
    {
        id: "psalm134",
        lines: [
            [
                "BE_/HOLD now, /praise the /LORD,",
                "all ye /ser_vants /of the /LORD;",
            ],
            [
                "Ye that by night stand in the /house of the /LORD,",
                "e_ven in the courts of the /house of our /God.",
            ],
            [
                "Lift up your hands in the sanc_tu_a_ry, and /praise the /LORD.",
                "The LORD that made hea_ven and earth give thee bless_ing /out of /Si_on.",
            ],
        ],
    },
    {
        id: "psalm135",
        lines: [
            [
                "O PRAISE the LORD, laud ye the /Name of the /LORD;",
                "praise it, O ye /ser_vants /of the /LORD;",
            ],
            [
                "Ye that stand in the /house of the /LORD,",
                "in the courts of the /house of our /God.",
            ],
            [
                "O praise the LORD, for the /LORD is /gra_cious;",
                "O sing prais_es un_to his Name, for /it is /love_ly.",
            ],
            [
                "For why? the LORD hath cho_sen Ja_cob /un_to /him_self,",
                "and Is_ra_el for his /own pos_/sess_ion.",
            ],
            [
                "For I /know that the /LORD is /great,",
                "and that our Lord /is a_/bove all /gods.",
            ],
            [
                "What_so_ev_er the LORD pleased, that did he in /hea_ven, /and in /earth;",
                "and in the sea, and in /all deep /pla_ces.",
            ],
            [
                "He bring_eth forth the clouds from the /ends of the /world,",
                "and send_eth forth light_nings with the rain, bring_ing the winds /out of his /treas_ur_ies.",
            ],
            [
                "He smote the /first_born of /E_gypt,",
                "/both of /man and /beast.",
            ],
            [
                "He hath sent tok_ens and won_ders in_to the midst of thee, O thou /land of /E_gypt;",
                "up_on Pha_raoh, and /all his /ser_vants.",
            ],
            ["He smote /di_vers /na_tions,", "and slew /migh_ty /kings:"],
            [
                "Si_hon, king of the Am_or_ites; and Og, the /king of /Ba_shan;",
                "and all the /king_doms of /Ca_naan;",
            ],
            [
                "And gave their land to /be an /he_ri_tage,",
                "e_ven an he_ri_tage un_to Is_ra_/el his /peo_ple.",
            ],
            [
                "Thy Name, O LORD, en_/dur_eth for /ev_er;",
                "so doth thy me_mor_i_al, O LORD, from one ge_ne_ra_tion /to a_/no_ther.",
            ],
            [
                "For the LORD will a_/venge his /peo_ple,",
                "and be gra_cious /un_to his /ser_vants.",
            ],
            [
                "As for the im_a_ges of the heath_en, they are but /sil_ver and /gold;",
                "the /work of /men's /hands.",
            ],
            [
                "They have /mouths, and /speak not;",
                "eyes have they, /but they /see not.",
            ],
            [
                "They have ears, and /yet they /hear not;",
                "nei_ther is there an_y /breath in their /mouths.",
            ],
            [
                "They that make them are /like un_to /them;",
                "and so are all they that /put their /trust in /them.",
            ],
            [
                "Praise the LORD, ye /house of /Is_ra_el;",
                "praise the LORD, ye /house of /Aa_ron.",
            ],
            [
                "Praise the LORD, ye /house of /Le_vi;",
                "ye that /fear the LORD, /praise the /LORD.",
            ],
            [
                "Praised be the LORD /out of /Si_on,",
                "who dwell_eth /at Je_/ru_sa_lem.",
            ],
        ],
    },
    {
        id: "psalm136",
        lines: [
            [
                "O GIVE thanks un_to the LORD, for /he is /gra_cious:",
                "and his mer_cy en_/dur_eth for /ev_er.",
            ],
            [
                "O give thanks un_to the /God of /all gods:",
                "for his mer_cy en_/dur_eth for /ev_er.",
            ],
            [
                "O thank the /Lord of all /lords:",
                "for his mer_cy en_/dur_eth for /ev_er.",
            ],
            [
                "Who on_ly /do_eth great /won_ders:",
                "for his mer_cy en_/dur_eth for /ev_er.",
            ],
            [
                "Who by his ex_cell_ent wis_dom /made the /hea_vens:",
                "for his mer_cy en_/dur_eth for /ev_er.",
            ],
            [
                "Who laid out the earth a_/bove the /wa_ters:",
                "for his mer_cy en_/dur_eth for /ev_er.",
            ],
            [
                "Who /hath made great /lights:",
                "for his mer_cy en_/dur_eth for /ev_er:",
            ],
            [
                "The /sun to /rule the /day:",
                "for his mer_cy en_/dur_eth for /ev_er;",
            ],
            [
                "The moon and the stars to /gov_ern the /night:",
                "for his mer_cy en_/dur_eth for /ev_er.",
            ],
            [
                "Who smote E_gypt, /with their /first_born:",
                "for his mer_cy en_/dur_eth for /ev_er;",
            ],
            [
                "And brought out Is_ra_el /from a_/mong them:",
                "for his mer_cy en_/dur_eth for /ev_er;",
            ],
            [
                "With a migh_ty /hand and /stretched-_out /arm:",
                "for his mer_cy en_/dur_eth for /ev_er.",
            ],
            [
                "Who di_vi_ded the Red /Sea in /two /parts:",
                "for his mer_cy en_/dur_eth for /ev_er;",
            ],
            [
                "And made Is_ra_el to go /through the /midst of /it:",
                "for his mer_cy en_/dur_eth for /ev_er.",
            ],
            [
                "But as for Pha_raoh and his host, he o_ver_threw them /in the /Red Sea:",
                "for his mer_cy en_/dur_eth for /ev_er.",
            ],
            [
                "Who led his peo_ple /through the /wil_der_ness:",
                "for his mer_cy en_/dur_eth for /ev_er.",
            ],
            [
                "Who /smote great /kings:",
                "for his mer_cy en_/dur_eth for /ev_er;",
            ],
            [
                "Yea, and /slew /migh_ty /kings:",
                "for his mer_cy en_/dur_eth for /ev_er:",
            ],
            [
                "Si_hon, /king of the /Am_or_ites:",
                "for his mer_cy en_/dur_eth for /ev_er;",
            ],
            [
                "And Og, the /king of /Ba_shan:",
                "for his mer_cy en_/dur_eth for /ev_er;",
            ],
            [
                "And gave a_way their /land for an /he_ri_tage:",
                "for his mer_cy en_/dur_eth for /ev_er;",
            ],
            [
                "E_ven for an he_ri_tage un_to Is_ra_/el his /ser_vant:",
                "for his mer_cy en_/dur_eth for /ev_er.",
            ],
            [
                "Who re_mem_bered us when we /were in /trou_ble:",
                "for his mer_cy en_/dur_eth for /ev_er;",
            ],
            [
                "And hath de_li_vered us /from our /e_ne_mies:",
                "for his mer_cy en_/dur_eth for /ev_er.",
            ],
            [
                "Who gi_veth /food to /all /flesh:",
                "for his mer_cy en_/dur_eth for /ev_er.",
            ],
            [
                "O give thanks un_to the /God of /hea_ven:",
                "for his mer_cy en_/dur_eth for /ev_er.",
            ],
            [
                "O give thanks /un_to the /Lord of /lords:",
                "for his mer_cy en_/dur_eth for /ev_er",
            ],
        ],
    },
    {
        id: "psalm137",
        lines: [
            [
                "BY the wa_ters of Ba_by_lon we /sat down /and /wept,",
                "when we re_mem_bered /thee, O /Si_on.",
            ],
            [
                "As for our /harps, we /hanged them /up",
                "up_on the /trees that /are there_/in.",
            ],
            [
                "For they that led us a_way cap_tive, re_quired of us then a song, and me_lo_dy /in our /hea_vi_ness:",
                "Sing us one of the /songs of /Si_on.",
            ],
            ["How shall we /sing the /LORD'S /song", "in a /strange land?"],
            [
                "If I for_get thee, /O Je_/ru_sa_lem,",
                "let my right hand for_/get her /cunn_ing.",
            ],
            [
                "If I do not re_mem_ber thee, let my tongue cleave to the /roof of my /mouth;",
                "yea, if I pre_fer not Je_ru_sa_lem a_/bove my /chief joy.",
            ],
            [
                "Re_mem_ber the child_ren of E_dom, O LORD, in the /day of Je_/ru_sa_lem;",
                "how they said, Down with it, down with it, /e_ven /to the /ground.",
            ],
            [
                "O daugh_ter of Ba_by_lon, /wast_ed with /mi_se_ry;",
                "yea, hap_py shall he be that re_ward_eth thee as /thou hast /served us.",
            ],
            [
                "Bless_ed shall he be that /tak_eth thy /child_ren,",
                "and throw_eth /them a_/gainst the /stones.",
            ],
        ],
    },
    {
        id: "psalm138",
        lines: [
            [
                "I will give thanks un_to thee, O Lord, with /my whole /heart;",
                "e_ven be_fore the gods will I sing /praise un_/to /thee.",
            ],
            [
                "I will wor_ship to_ward thy ho_ly tem_ple, and praise thy Name, be_cause of thy lov_ing-_/kind_ness and /truth;",
                "for thou hast mag_ni_fied thy Name, and thy /word, a_/bove all /things.",
            ],
            [
                "When I called up_/on thee, thou /heard_est me;",
                "and en_duedst my /soul /with much /strength.",
            ],
            [
                "All the kings of the earth shall /praise /thee, O /LORD;",
                "for they have heard the /words of thy /mouth.",
            ],
            [
                "Yea, they shall sing of the /ways of the /LORD,",
                "that great is the /glo_ry /of the /LORD.",
            ],
            [
                "For though the LORD be high, yet hath he res_pect /un_to the /low_ly;",
                "as for the proud, he be_hold_eth /them af_/ar off.",
            ],
            [
                "Though I walk in the midst of trou_ble, yet shalt /thou ref_/resh me;",
                "thou shalt stretch forth thy hand up_on the fu_ri_ous_ness of mine e_ne_mies, and thy right /hand shall /save me.",
            ],
            [
                "The LORD shall make good his lov_ing-_/kind_ness to_/ward me;",
                "yea, thy mer_cy, O LORD, en_dur_eth for ev_er; des_pise not then the /works of /thine own /hands.",
            ],
        ],
    },
    {
        id: "psalm139",
        lines: [
            [
                "O LORD, thou hast searched me /out, and /known me.",
                "Thou know_est my down-_sitt_ing, and mine up_ris_ing; thou un_der_stand_est my /thoughts /long be_/fore.",
            ],
            [
                "Thou art a_bout my /path, and a_/bout my /bed;",
                "and art ac_/quain_ted with /all my /ways.",
            ],
            [
                "For lo, there is not a /word in my /tongue,",
                "but thou, O LORD, know_est it /al_to_/ge_ther.",
            ],
            [
                "Thou hast be_set me be_/hind and be_/fore,",
                "and laid thine /hand up_/on me.",
            ],
            [
                "Such know_ledge is too won_der_ful and /ex_cell_ent /for /me;",
                "I can_/not at_tain /un_to it.",
            ],
            [
                "Whi_ther shall I go then /from thy /Spi_rit?",
                "or whi_ther shall I go then /from thy /pres_ence?",
            ],
            [
                "If I climb up in_to /hea_ven, /thou art /there;",
                "if I go down to hell, /thou art there /al_so.",
            ],
            [
                "If I take the /wings of the /mor_ning,",
                "and re_main in the ut_ter_most /parts of /the /sea;",
            ],
            [
                "E_ven there al_so /shall thy hand /lead me,",
                "and thy right /hand shall /hold me.",
            ],
            [
                "If I say, Per_ad_ven_ture the /dark_ness shall /co_ver me;",
                "then shall my /night be /turned to /day.",
            ],
            [
                "Yea, the dark_ness is no dark_ness with thee, but the night is as /clear as the /day;",
                "the dark_ness and light to /thee are /both a_/like.",
            ],
            [
                "For /my /reins are /thine;",
                "thou hast co_vered me /in my /mo_ther's /womb.",
            ],
            [
                "I will give thanks un_to thee, for I am fear_ful_ly and /won_der_/fully made:",
                "mar_vell_ous are thy works, and that my soul /know_eth /right well.",
            ],
            [
                "My /bones are not /hid from thee,",
                "though I be made se_cret_ly, and fash_ioned be_/neath in the /earth.",
            ],
            [
                "Thine eyes did see my sub_stance, yet /be_ing im_/per_fect;",
                "and in thy book were all my /mem_bers /writ_ten;",
            ],
            [
                "Which day by /day were /fash_ioned,",
                "when as yet /there was /none of /them.",
            ],
            [
                "How dear are thy coun_sels /un_to /me, O God;",
                "O how great /is the /sum of /them!",
            ],
            [
                "If I tell them, they are more in /num_ber /than the /sand:",
                "when I wake up, I am /pre_sent /with thee.",
            ],
            [
                "Wilt thou not slay the /wick_ed, O /God?",
                "De_part from me, ye /blood-_/thirs_ty /men.",
            ],
            [
                "For they speak un_right_eous_/ly a_/gainst thee;",
                "and thine e_ne_mies /take thy /Name in /vain.",
            ],
            [
                "Do not I hate them, O /LORD, that /hate thee?",
                "and am not I grieved with those that rise /up a_/gainst thee?",
            ],
            [
                "Yea, I /hate them /right sore;",
                "e_ven as though they /were mine /e_ne_mies.",
            ],
            [
                "Try me, O God, and seek the /ground of my /heart;",
                "prove me, and ex_/am_ine /my /thoughts.",
            ],
            [
                "Look well if there be an_y way of /wick_ed_ness in /me;",
                "and lead me in the way /ev_er_/last_ing.",
            ],
        ],
    },
    {
        id: "psalm140",
        lines: [
            [
                "DE_LI_VER me, O LORD, /from the /e_vil /man;",
                "and pre_serve me /from the /wick_ed man;",
            ],
            [
                "Who i_ma_gine /mis_chief /in their /hearts,",
                "and stir up strife /all the /day /long.",
            ],
            [
                "They have sharp_ened their /tongues like a /ser_pent;",
                "ad_der's poi_son is /un_der their /lips.",
            ],
            [
                "Keep me, O LORD, from the hands of /the un_/god_ly;",
                "pre_serve me from the wick_ed men, who are pur_posed to o_ver_/throw my /go_ings.",
            ],
            [
                "The proud have laid a snare for me, and spread a /net a_/broad with /cords;",
                "yea, and set /traps in my /way.",
            ],
            [
                "I said un_to the LORD, /Thou art my /God,",
                "hear the /voice of my /prayers, O /LORD.",
            ],
            [
                "O LORD God, thou /strength of my /health;",
                "thou hast co_vered my head in the /day of /bat_tle.",
            ],
            [
                "Let not the un_god_ly /have his de_/sire, O /LORD;",
                "let not his mis_chie_vous i_ma_gi_na_tion pros_per, /lest they /be too /proud.",
            ],
            [
                "Let the mis_chief of their own lips fall up_/on the /head of them",
                "that /com_pass /me a_/bout.",
            ],
            [
                "Let hot burn_ing coals /fall up_/on them;",
                "let them be cast in_to the fire, and in_to the pit, that they nev_er /rise /up a_/gain.",
            ],
            [
                "A man full of words shall not /pros_per up_/on the /earth:",
                "e_vil shall hunt the wick_ed per_son to /o_ver_/throw him.",
            ],
            [
                "Sure I am that the LORD /will a_/venge the /poor,",
                "and main_tain the /cause of the /help_less.",
            ],
            [
                "The right_eous al_so shall give /thanks un_to thy /Name;",
                "and the just shall con_/tin_ue /in thy /sight.",
            ],
        ],
    },
    {
        id: "psalm141",
        lines: [
            [
                "LORD, I call up_on thee; /haste thee /un_to /me,",
                "and con_si_der my voice, when I /cry /un_to /thee.",
            ],
            [
                "Let my prayer be set forth in thy /sight as the /in_cense;",
                "and let the lift_ing up of my hands be an /eve_ning /sac_ri_fice.",
            ],
            [
                "Set a watch, O /LORD, be_/fore my /mouth,",
                "and keep the /door of my /lips.",
            ],
            [
                "O let not mine heart be in_clined to an_y /e_vil thing;",
                "let me not be oc_cu_pied in un_god_ly works with the men that work wick_ed_ness, nei_ther let me eat of such /things as /please them.",
            ],
            [
                "Let the right_eous ra_ther smite me friend_ly, /and re_/prove me;",
                "yea, let not my head re_/fuse their /prec_ious /balms.",
            ],
            [
                "As /for the un_/god_ly,",
                "I will pray yet a_/gainst their /wick_ed_ness.",
            ],
            [
                "Let their judg_es be ov_er_thrown in /sto_ny /pla_ces,",
                "that they may hear my /words; for /they are /sweet.",
            ],
            [
                "Our bones lie /scat_tered be_/fore the /pit,",
                "like as when one break_eth and hew_eth /wood up_/on the earth.",
            ],
            [
                "But mine eyes look un_to /thee, O /LORD /God;",
                "in thee is my trust; O /cast not /out my /soul.",
            ],
            [
                "Keep me from the snare that /they have /laid for me,",
                "and from the traps of the /wick_ed /do_ers.",
            ],
            [
                "Let the un_god_ly fall in_to their own /nets to_/ge_ther,",
                "and let me /ev_er es_/cape them.",
            ],
        ],
    },
    {
        id: "psalm142",
        lines: [
            [
                "I CRIED un_to the /LORD with my /voice;",
                "yea, e_ven un_to the LORD did I make my /supp_li_/ca_tion.",
            ],
            [
                "I poured out my comp_/laints be_/fore him,",
                "and showed /him of my /trou_ble.",
            ],
            [
                "When my spi_rit was in hea_vi_ness, thou /knew_est my /path;",
                "in the way where_in I walked, have they pri_vi_ly /laid a /snare for me.",
            ],
            [
                "I looked al_so up_/on my /right hand,",
                "and saw there was no /man that would /know me.",
            ],
            [
                "I had no /place to /flee un_to,",
                "and no man /cared /for my /soul.",
            ],
            [
                "I cried un_to /thee, O /LORD, and /said,",
                "Thou art my hope, and my por_tion in the /land of the /li_ving.",
            ],
            ["Con_/si_der my /com_/plaint;", "for I am /brought /ve_ry /low."],
            [
                "O de_li_ver me from my /per_se_/cu_tors;",
                "for they /are too /strong for me.",
            ],
            [
                "Bring my soul out of pri_son, that I may give /thanks un_to thy /Name;",
                "which thing if thou wilt grant me, then shall the right_eous res_ort /un_to my /com_pa_ny.",
            ],
        ],
    },
    {
        id: "psalm143",
        lines: [
            [
                "HEAR my prayer, O LORD, and con_/si_der /my de_/sire;",
                "hear_ken un_to me for thy truth and /right_eous_ness' /sake.",
            ],
            [
                "And en_ter not in_to judg_ment /with thy /ser_vant;",
                "for in thy sight shall no man /li_ving be /jus_ti_fied.",
            ],
            [
                "For the e_ne_my hath per_se_cu_ted my soul; he hath smit_ten my life /down to the /ground;",
                "he hath laid me in the dark_ness, as the /men that have /been long /dead.",
            ],
            [
                "There_fore is my spi_rit /vexed with_/in me,",
                "and my heart with_/in me is /de_so_late.",
            ],
            [
                "Yet do I re_mem_ber the time past; I muse up_/on all thy /works;",
                "yea, I ex_er_cise my_self in the /works of thy /hands.",
            ],
            [
                "I stretch forth my /hands /un_to /thee;",
                "my soul gasp_eth un_to /thee as a /thirs_ty /land.",
            ],
            [
                "Hear me, O LORD, and that soon; for my /spi_rit /wax_eth /faint:",
                "hide not thy face from me, lest I be like un_to them that go down /in_/to the /pit.",
            ],
            [
                "O let me hear thy lov_ing-_kind_ness be_times in the mor_ning; for in /thee is my /trust:",
                "show thou me the way that I should walk in; for I lift up my /soul /un_to /thee.",
            ],
            [
                "De_li_ver me, O /LORD, from mine /e_ne_mies;",
                "for I flee un_to /thee to /hide me.",
            ],
            [
                "Teach me to do the thing that pleas_eth thee; for /thou art my /God:",
                "let thy lov_ing Spi_rit lead me forth in_to the /land of /right_eous_ness.",
            ],
            [
                "Quick_en me, O /LORD, for thy /Name's /sake;",
                "and for thy right_eous_ness' sake bring my /soul out of /trou_ble.",
            ],
            [
                "And of thy good_ness /slay mine /e_ne_mies,",
                "and des_troy all them that vex my soul; for /I am thy /ser_vant.",
            ],
        ],
    },
    {
        id: "psalm144",
        lines: [
            [
                "BLESS_ED /be the /LORD my /strength,",
                "who teach_eth my hands to war, and my /fing_ers to /fight:",
            ],
            [
                "My hope and my fort_ress, my ca_stle and de_li_ver_er, my de_/fen_der in /whom I /trust;",
                "who sub_du_eth my peo_ple /that is /un_der me.",
            ],
            [
                "LORD, what is man, that thou hast such res_/pect un_to /him?",
                "or the son of man, that thou /so re_/gard_est /him?",
            ],
            [
                "Man is /like a /thing of /nought;",
                "his time pass_eth a_way /like a /sha_dow.",
            ],
            [
                "Bow thy hea_vens, O /LORD, and /come /down;",
                "touch the /moun_tains, and /they shall /smoke.",
            ],
            [
                "Cast forth thy /light_ning, and /tear them;",
                "shoot out thine arr_ows, /and con_/sume them.",
            ],
            [
                "Send down thine /hand from a_/bove;",
                "de_li_ver me, and take me out of the great wa_ters, from the /hand of /stran_gers;",
            ],
            [
                "Whose mouth /talk_eth of /va_ni_ty,",
                "and their right hand is a right /hand of /wick_ed_ness.",
            ],
            [
                "I will sing a new song /un_to /thee, O /God;",
                "and sing prais_es un_to thee up_/on a /ten-_stringed /lute.",
            ],
            [
                "Thou hast gi_ven /vic_to_ry /un_to /kings,",
                "and hast de_li_vered Da_vid thy ser_vant from the /pe_ril /of the /sword.",
            ],
            [
                "Save me, and de_li_ver me from the /hand of /stran_gers,",
                "whose mouth talk_eth of va_ni_ty, and their right hand is a right /hand of in_/i_qui_ty:",
            ],
            [
                "That our sons may grow /up as the /young /plants,",
                "and that our daugh_ters may be as the pol_ished cor_ners /of the /tem_ple;",
            ],
            [
                "That our gar_ners may be full and plen_te_ous with all /man_ner of /store;",
                "that our sheep may bring forth thou_sands, and ten /thou_sands /in our /fields;",
            ],
            [
                "That our ox_en may be strong to la_bour; that there /be no de_/cay,",
                "no lead_ing in_to cap_ti_vi_ty, and no com_/plain_ing /in our /streets.",
            ],
            [
                "Hap_py are the peo_ple that are /in /such a /case;",
                "yea, bless_ed are the peo_ple who have the /LORD for their /God.",
            ],
        ],
    },
    {
        id: "psalm145",
        lines: [
            [
                "I WILL mag_ni_fy /thee, O /God, my /King;",
                "and I will praise thy Name for /ev_er and /ev_er.",
            ],
            [
                "Eve_ry day will I give /thanks /un_to /thee;",
                "and praise thy Name for /ev_er and /ev_er.",
            ],
            [
                "Great is the LORD, and mar_vell_ous /wor_thy /to be /praised;",
                "there is no /end of his /great_ness.",
            ],
            [
                "One ge_ne_ra_tion shall praise thy works /un_to a_/no_ther,",
                "and de_/clare thy /pow_er.",
            ],
            [
                "As for me, I will be talk_ing /of thy /wor_ship,",
                "thy glo_ry, thy /praise, and /won_drous /works;",
            ],
            [
                "So that men shall speak of the might of thy /mar_vell_ous /acts;",
                "and I will al_so /tell of thy /great_ness.",
            ],
            [
                "The me_mor_i_al of thine ab_un_dant /kind_ness /shall be /showed;",
                "and men shall /sing of thy /right_eous_ness.",
            ],
            [
                "The LORD is /gra_cious and /mer_ci_ful;",
                "long-_suf_fer_ing, /and of great /good_ness.",
            ],
            [
                "The LORD is lov_ing /un_to /eve_ry man;",
                "and his mer_cy is /o_ver /all his /works.",
            ],
            [
                "All thy works /praise thee, O /LORD;",
                "and thy saints give /thanks un_to /thee.",
            ],
            [
                "They show the glo_ry /of thy /king_dom,",
                "and /talk of thy /pow_er;",
            ],
            [
                "That thy pow_er, thy glo_ry, and migh_ti_ness /of thy /king_dom,",
                "might be /known /un_to /men.",
            ],
            [
                "Thy king_dom is an ev_er_/last_ing /king_dom,",
                "and thy do_min_ion en_dur_eth through_/out all /a_ges.",
            ],
            [
                "The LORD up_hold_eth /all such as /fall,",
                "and lift_eth up all /those that /are /down.",
            ],
            [
                "The eyes of all wait up_/on thee, O /Lord;",
                "and thou giv_est them their /meat in due /sea_son.",
            ],
            [
                "Thou /o_pen_est /thine /hand,",
                "and fill_est all things /li_ving with /plen_teous_ness.",
            ],
            [
                "The LORD is /right_eous in /all his /ways,",
                "and /ho_ly in /all his /works.",
            ],
            [
                "The LORD is nigh un_to all them that /call up_/on him;",
                "yea, all such as call up_/on him /faith_ful_ly.",
            ],
            [
                "He will ful_fil the de_sire of /them that /fear him;",
                "he al_so will hear their /cry, and will /help them.",
            ],
            [
                "The LORD pre_ser_veth all /them that /love him;",
                "but scat_ter_eth a_broad /all the un_/god_ly.",
            ],
            [
                "My mouth shall speak the /praise of the /LORD;",
                "and let all flesh give thanks un_to his ho_ly Name for /ev_er and /ev_er.",
            ],
        ],
    },
    {
        id: "psalm146",
        lines: [
            [
                "PRAISE the LORD, O my soul: while I live, /will I /praise the /LORD;",
                "yea, as long as I have an_y be_ing, I will sing prais_es /un_to my /God.",
            ],
            [
                "O put not your trust in prin_ces, nor in /an_y /child of /man;",
                "for there is no /help in them.",
            ],
            [
                "For when the breath of man go_eth forth, he shall turn a_/gain to his /earth,",
                "and then /all his thoughts /per_ish.",
            ],
            [
                "Bless_ed is he that hath the God of /Ja_cob /for his /help,",
                "and whose hope is /in the /LORD his /God:",
            ],
            [
                "Who made hea_ven and earth, the sea, and /all that /there_in is;",
                "who keep_eth his /prom_ise for /ev_er;",
            ],
            [
                "Who help_eth them to /right that /suf_fer /wrong;",
                "who /feed_eth the /hun_gry.",
            ],
            [
                "The LORD loos_eth /men out of /pri_son;",
                "the LORD gi_veth /sight to the /blind.",
            ],
            [
                "The LORD help_eth /them that are /fall_en;",
                "the LORD ca_reth for the /right_eous.",
            ],
            [
                "The LORD ca_reth for the stran_gers; he de_fend_eth the /fa_ther_less and /wid_ow:",
                "as for the way of the un_god_ly, he /tur_neth it /up_side /down.",
            ],
            [
                "The LORD thy God, O Si_on, shall be /King for /ev_er_/more,",
                "and through_out all /gen_er_/a_tions.",
            ],
        ],
    },
    {
        id: "psalm147",
        lines: [
            [
                "PRAISE the LORD, for it is a good thing to sing prais_es /un_to /our /God;",
                "yea, a joy_ful and plea_sant thing it /is to be /thank_ful.",
            ],
            [
                "The LORD doth build /up Je_/ru_sa_lem,",
                "and gath_er to_ge_ther the /out_casts of /Is_ra_el.",
            ],
            [
                "He heal_eth those that are /bro_ken in /heart,",
                "and gi_veth me_di_cine to /heal their /sick_ness.",
            ],
            [
                "He tell_eth the /num_ber /of the /stars,",
                "and call_eth them /all by their /names.",
            ],
            [
                "Great is our Lord, and /great is his /pow_er;",
                "yea, and his /wis_dom is /in_fin_ite.",
            ],
            [
                "The LORD /set_teth /up the /meek,",
                "and bring_eth the un_god_ly /down to the /ground.",
            ],
            [
                "O sing un_to the /LORD with thanks_/giv_ing;",
                "sing prais_es up_on the harp /un_to our /God:",
            ],
            [
                "Who co_ver_eth the hea_ven with clouds, and pre_par_eth /rain for the /earth;",
                "and mak_eth the grass to grow up_on the moun_tains, and /herb for the /use of /men;",
            ],
            [
                "Who gi_veth fod_der /un_to the /cat_tle,",
                "and feed_eth the young ra_vens that /call up_/on /him.",
            ],
            [
                "He hath no plea_sure in the /strength of an /horse;",
                "nei_ther de_light_eth he in /an_y /man's legs.",
            ],
            [
                "But the LORD'S de_light is in /them that /fear him,",
                "and put their /trust in his /mer_cy.",
            ],
            [
                "Praise the LORD, /O Je_/ru_sa_lem;",
                "praise thy /God, O /Si_on.",
            ],
            [
                "For he hath made fast the /bars of thy /gates,",
                "and hath bless_ed thy /child_ren with_/in thee.",
            ],
            [
                "He mak_eth /peace in thy /bor_ders,",
                "and fil_leth /thee with the /flour of /wheat.",
            ],
            [
                "He send_eth forth his com_/mand_ment up_/on /earth,",
                "and his word runn_eth /ve_ry /swift_ly.",
            ],
            [
                "He /gi_veth /snow like /wool,",
                "and scat_ter_eth the /hoar_frost like /ash_es.",
            ],
            [
                "He cast_eth forth his /ice like /mor_sels:",
                "who is a_ble /to a_/bide his /frost?",
            ],
            [
                "He send_eth out his /word, and /melt_eth them:",
                "he blow_eth with his /wind, and the /wa_ters flow.",
            ],
            [
                "He show_eth his /word un_to /Ja_cob,",
                "his stat_utes and or_di_nan_ces /un_to /Is_ra_el.",
            ],
            [
                "He hath not dealt so with /an_y /na_tion;",
                "nei_ther have the heath_en /know_ledge /of his /laws.",
            ],
        ],
    },
    {
        id: "psalm148",
        lines: [
            [
                "O PRAISE the /LORD from the /hea_vens:",
                "/praise him /in the /heights.",
            ],
            [
                "Praise him, all ye /an_gels of /his:",
                "/praise him, /all his /host.",
            ],
            [
                "/Praise him, /sun and /moon:",
                "praise him, /all ye /stars and /light.",
            ],
            [
                "Praise him, /all ye /hea_vens,",
                "and ye wa_ters that are a_/bove the /hea_vens.",
            ],
            [
                "Let them praise the /Name /of the /LORD:",
                "for he spake the word, and they were made; he com_man_ded, and /they were cre_/at_ed.",
            ],
            [
                "He hath made them fast for /ev_er and /ev_er:",
                "he hath gi_ven them a law which shall /not be /bro_ken.",
            ],
            [
                "Praise the /LORD from the /earth,",
                "ye /dra_gons and /all /deeps;",
            ],
            [
                "Fire and hail, /snow and /va_pours,",
                "wind and storm, ful_/fil_ling his /word;",
            ],
            [
                "/Moun_tains /and all /hills;",
                "fruit_ful /trees and /all /ce_dars;",
            ],
            [
                "/Beasts and all /cat_tle;",
                "creep_ing /things and /fly_ing /fowls;",
            ],
            [
                "Kings of the /earth, and all /peo_ples;",
                "prin_ces, and all /judg_es /of the /world;",
            ],
            [
                "Young men and maid_ens, old men and child_ren, praise the /Name /of the /LORD:",
                "for his Name on_ly is ex_cell_ent, and his praise a_bove /hea_ven and /earth.",
            ],
            [
                "He shall ex_alt the horn of his peo_ple: all his /saints shall /praise him;",
                "e_ven the child_ren of Is_ra_el, e_ven the /peo_ple that /serv_eth /him.",
            ],
        ],
    },
    {
        id: "psalm149",
        lines: [
            [
                "O SING un_to the /LORD a new /song;",
                "let the con_gre_ga_tion /of saints /praise /him.",
            ],
            [
                "Let Is_ra_el re_joice in /him that /made him,",
                "and let the child_ren of Si_on be /joy_ful /in their /King.",
            ],
            [
                "Let them praise his /Name in the /dance:",
                "let them sing prais_es un_to him with /tab_/ret and /harp.",
            ],
            [
                "For the LORD hath plea_sure /in his /peo_ple,",
                "and /help_eth the /meek-_/heart_ed.",
            ],
            [
                "Let the saints be /joy_ful with /glo_ry;",
                "let them re_/joice /in their /beds.",
            ],
            [
                "Let the prais_es of God /be in their /mouth;",
                "and a two-_edged /sword /in their /hands;",
            ],
            [
                "To be a_/venged of the /na_tions,",
                "and to re_/buke the /peo_ples;",
            ],
            [
                "To /bind their /kings in /chains,",
                "and their no_bles with /links of /i_ron;",
            ],
            [
                "To ex_e_cute judg_ment up_on them; as /it is /writ_ten,",
                "Such ho_nour /have /all his /saints.",
            ],
        ],
    },
    {
        id: "psalm150",
        lines: [
            [
                "O PRAISE God in his /sanc_tu_/a_ry:",
                "praise him in the fir_ma_ment /of his /pow_er.",
            ],
            [
                "Praise him /in his /no_ble /acts:",
                "praise him ac_cor_ding to his /ex_cell_ent /great_ness.",
            ],
            [
                "Praise him in the sound /of the /trum_pet:",
                "praise him up_/on the /lute and /harp.",
            ],
            [
                "Praise him in the /tim_brels and /dan_ces:",
                "praise him up_/on the /strings and /pipe.",
            ],
            [
                "Praise him up_on the /well-_tuned /cym_bals:",
                "praise him up_/on the loud /cym_bals.",
            ],
            ["Let eve_ry /thing that /hath breath", "/praise the /LORD."],
        ],
    },
];
